/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any }
  /** Markdown custom scalar type */
  Markdown: { input: string; output: string }
  /** Date custom scalar type */
  Timestamp: { input: number; output: number }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: File; output: File }
  /** Represents NULL values */
  Void: { input: any; output: any }
}

export type AddDemoBullseyePredictInput = {
  modeId: Scalars['ID']['input']
  /** Guessed price in human units. Rounded to the asset's precision; must be within ±5% of the current price. */
  price: Scalars['Float']['input']
}

export type AddDemoUpDownAiPredictInput = {
  gameId: Scalars['String']['input']
  isLong: Scalars['Boolean']['input']
}

export type AddDemoUpDownPredictInput = {
  channelId: Scalars['String']['input']
  isLong: Scalars['Boolean']['input']
}

export type Affiliate = {
  __typename?: 'Affiliate'
  walletAddress: Scalars['String']['output']
}

export type Asset = {
  __typename?: 'Asset'
  decimals: Scalars['Float']['output']
  feedId: Scalars['String']['output']
  feedNumber: Scalars['Float']['output']
  id: Scalars['String']['output']
  last7days: Array<AssetPrice>
  name: Scalars['String']['output']
  order: Scalars['Float']['output']
  precision: Scalars['Float']['output']
  price: AssetPrice
  price24h: AssetPrice
  supportedResolutions: Array<Scalars['Float']['output']>
}

export type AssetPrice = {
  __typename?: 'AssetPrice'
  assetId: Scalars['String']['output']
  expiresAt?: Maybe<Scalars['Float']['output']>
  feedId: Scalars['String']['output']
  formattedValue: Scalars['Float']['output']
  id?: Maybe<Scalars['String']['output']>
  linkFee: Scalars['String']['output']
  nativeFee: Scalars['String']['output']
  payload: Scalars['String']['output']
  timestamp: Scalars['Float']['output']
}

export type AssetPricesInput = {
  assetId: Scalars['String']['input']
  skip: Scalars['Int']['input']
  take: Scalars['Int']['input']
}

export type AssetPricesRangeInput = {
  assetId: Scalars['String']['input']
  endDate: Scalars['DateTime']['input']
  startDate: Scalars['DateTime']['input']
}

export type AttachDiscordInput = {
  code: Scalars['String']['input']
  redirectUri: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type AttachTelegramInput = {
  firstName: Scalars['String']['input']
  lastName?: InputMaybe<Scalars['String']['input']>
  telegramId: Scalars['Float']['input']
  username: Scalars['String']['input']
}

export type AttachTwitterInput = {
  code: Scalars['String']['input']
  redirectUri: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type BonusNotification = {
  __typename?: 'BonusNotification'
  amount: Scalars['Float']['output']
  assetId: Scalars['String']['output']
  createdAt: Scalars['Timestamp']['output']
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isRead: Scalars['Boolean']['output']
  title: Scalars['String']['output']
  type: NotificationType
  userId: Scalars['String']['output']
}

/** Human vs AI opponent difficulty levels. */
export enum BotDifficulty {
  Easy = 'EASY',
  Hard = 'HARD',
  Medium = 'MEDIUM'
}

export type BullseyeGame = {
  __typename?: 'BullseyeGame'
  amount: Scalars['Float']['output']
  chainIdentifier?: Maybe<Scalars['String']['output']>
  chainType?: Maybe<Scalars['String']['output']>
  commission?: Maybe<Scalars['Float']['output']>
  contractAddress?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Timestamp']['output']
  endAt?: Maybe<Scalars['Timestamp']['output']>
  endPrice?: Maybe<Scalars['Float']['output']>
  exactRange: Scalars['Float']['output']
  feedId?: Maybe<Scalars['String']['output']>
  gameType: GameType
  id: Scalars['String']['output']
  modeId: Scalars['ID']['output']
  myPredicts: Array<BullseyePredict>
  pool: BullseyeGamePoolInfo
  predicts: Array<BullseyePredict>
  startAt?: Maybe<Scalars['Timestamp']['output']>
  startPrice?: Maybe<Scalars['Float']['output']>
  status: GameStatus
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>
  timeframe: Scalars['Int']['output']
  token?: Maybe<Scalars['String']['output']>
  totalAmount?: Maybe<Scalars['Float']['output']>
  updatedAt: Scalars['Timestamp']['output']
}

export type BullseyeGameMode = {
  __typename?: 'BullseyeGameMode'
  amount: Scalars['Float']['output']
  asset: Asset
  assetId: Scalars['String']['output']
  current?: Maybe<BullseyeGame>
  exactRange: Scalars['Float']['output']
  id: Scalars['String']['output']
  lockWindow: Scalars['Float']['output']
  predictWindow: Scalars['Float']['output']
  sortOrder: Scalars['Float']['output']
  timeframeSec: Scalars['Float']['output']
}

export type BullseyeGamePoolInfo = {
  __typename?: 'BullseyeGamePoolInfo'
  poolAmount: Scalars['Float']['output']
  predictsCount: Scalars['Float']['output']
}

export type BullseyeGameResultNotificationPayload = {
  __typename?: 'BullseyeGameResultNotificationPayload'
  amount?: Maybe<Scalars['Float']['output']>
  gameType: GameType
  isExact?: Maybe<Scalars['Boolean']['output']>
  outcome?: Maybe<Scalars['Float']['output']>
  status: PredictStatus
  winner?: Maybe<User>
  winnerOutcome?: Maybe<Scalars['Float']['output']>
}

export type BullseyeGames = {
  __typename?: 'BullseyeGames'
  games: Array<BullseyeGame>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type BullseyeLeaderboard = {
  __typename?: 'BullseyeLeaderboard'
  entries: Array<BullseyeLeaderboardEntry>
  /** Exclusive UTC end of the period, used for a reset countdown. Null for all-time. */
  periodEnd?: Maybe<Scalars['Timestamp']['output']>
  /** Inclusive UTC start of the period. Null for all-time. */
  periodStart?: Maybe<Scalars['Timestamp']['output']>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type BullseyeLeaderboardEntry = {
  __typename?: 'BullseyeLeaderboardEntry'
  /** Average error percent: errorPctSum / settledRounds. */
  avgErrorPct: Scalars['Float']['output']
  exactHits: Scalars['Int']['output']
  rank: Scalars['Int']['output']
  /** Non-negative period score. Zero is valid. */
  score: Scalars['Int']['output']
  settledRounds: Scalars['Int']['output']
  user: User
}

export type BullseyeLeaderboardHistoryInput = {
  /** Closed bucket id: YYYY-MM-DD for daily, GGGG-Www for weekly. */
  bucket: Scalars['String']['input']
  pagination: PaginatedInput
  period: BullseyeLeaderboardPeriod
}

export type BullseyeLeaderboardInput = {
  pagination: PaginatedInput
  period: BullseyeLeaderboardPeriod
}

/** Live Bullseye leaderboard period. History supports daily and weekly only. */
export enum BullseyeLeaderboardPeriod {
  AllTime = 'ALL_TIME',
  Daily = 'DAILY',
  Weekly = 'WEEKLY'
}

export type BullseyeLeaderboardPositionUpdate = {
  __typename?: 'BullseyeLeaderboardPositionUpdate'
  /** Average error percent: errorPctSum / settledRounds. */
  avgErrorPct: Scalars['Float']['output']
  exactHits: Scalars['Int']['output']
  period: BullseyeLeaderboardPeriod
  rank: Scalars['Int']['output']
  /** previousRank - currentRank. Positive means the player moved up. */
  rankDelta: Scalars['Int']['output']
  /** Non-negative period score. Zero is valid. */
  score: Scalars['Int']['output']
  settledRounds: Scalars['Int']['output']
  user: User
}

export type BullseyeLeaderboardUpdate = {
  __typename?: 'BullseyeLeaderboardUpdate'
  /** Current bucket id. Null for all-time. */
  bucket?: Maybe<Scalars['String']['output']>
  period: BullseyeLeaderboardPeriod
  /** True when the live bucket rolled over. Clients must refetch the current board. */
  periodChanged: Scalars['Boolean']['output']
}

export type BullseyeModeIdInput = {
  modeId: Scalars['ID']['input']
}

export type BullseyePredict = {
  __typename?: 'BullseyePredict'
  amount: Scalars['Float']['output']
  createdAt: Scalars['Timestamp']['output']
  finalizeTxHash?: Maybe<Scalars['String']['output']>
  game?: Maybe<BullseyeGame>
  gameId: Scalars['String']['output']
  gameType: GameType
  id: Scalars['String']['output']
  index: Scalars['Int']['output']
  isExact?: Maybe<Scalars['Boolean']['output']>
  outcome?: Maybe<Scalars['Float']['output']>
  owner?: Maybe<User>
  ownerId: Scalars['String']['output']
  place: Scalars['Int']['output']
  playerAddress: Scalars['String']['output']
  pnl?: Maybe<Scalars['Float']['output']>
  price: Scalars['Float']['output']
  status: PredictStatus
  updatedAt: Scalars['Timestamp']['output']
}

export type BullseyePredicts = {
  __typename?: 'BullseyePredicts'
  predicts: Array<BullseyePredict>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type CancelReferralWithdrawRequestOperationInput = {
  cancelReason: Scalars['String']['input']
  requestId: Scalars['String']['input']
}

export type Candle = {
  __typename?: 'Candle'
  assetId: Scalars['String']['output']
  close: Scalars['Float']['output']
  closeTime: Scalars['Timestamp']['output']
  high: Scalars['Float']['output']
  low: Scalars['Float']['output']
  open: Scalars['Float']['output']
  openTime: Scalars['Timestamp']['output']
  timeframe: Scalars['Int']['output']
}

export type CashbackPeriodSummary = {
  __typename?: 'CashbackPeriodSummary'
  applicableLevel?: Maybe<Scalars['Float']['output']>
  cashbackAmount: Scalars['Float']['output']
  commissionPaid: Scalars['Float']['output']
  period: CashbackPeriods
  status?: Maybe<CashbackStatus>
  txHash?: Maybe<Scalars['String']['output']>
}

export type CashbackPeriods = {
  __typename?: 'CashbackPeriods'
  endDate: Scalars['Timestamp']['output']
  id: Scalars['String']['output']
  startDate: Scalars['Timestamp']['output']
}

export type CashbackRequest = {
  __typename?: 'CashbackRequest'
  amount: Scalars['Float']['output']
  cashbackPeriodId: Scalars['String']['output']
  commissionsPaid: Scalars['Float']['output']
  id: Scalars['String']['output']
  period?: Maybe<CashbackPeriods>
  status: CashbackStatus
  txHash?: Maybe<Scalars['String']['output']>
  userLevel?: Maybe<UserLevel>
  userLevelId: Scalars['String']['output']
}

/** Supported cashback statuses */
export enum CashbackStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ChallengeTask = {
  __typename?: 'ChallengeTask'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isCompleted: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  number: Scalars['Int']['output']
  requirement?: Maybe<Scalars['Float']['output']>
  reward?: Maybe<Scalars['Float']['output']>
  userRelatedTask?: Maybe<UserChallengeTask>
}

export type ChangeEmailInput = {
  email: Scalars['String']['input']
}

export type ChangeEmailNotificationPolicyInput = {
  notifyBetsResult?: InputMaybe<Scalars['Boolean']['input']>
  notifyBettingInvitation?: InputMaybe<Scalars['Boolean']['input']>
  notifyNewAchievements?: InputMaybe<Scalars['Boolean']['input']>
  notifyTransactions?: InputMaybe<Scalars['Boolean']['input']>
  notifyUpdates?: InputMaybe<Scalars['Boolean']['input']>
  sendNotificationsToEmail?: InputMaybe<Scalars['Boolean']['input']>
}

export type ChangeOffchainReferralCodeInputType = {
  newCode: Scalars['String']['input']
}

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input']
  oldPassword: Scalars['String']['input']
}

export type ChangePrivacyPolicyInput = {
  allowInviteIn1vs1Game?: InputMaybe<Scalars['Boolean']['input']>
  allowTagInChat?: InputMaybe<Scalars['Boolean']['input']>
  showAchievements?: InputMaybe<Scalars['Boolean']['input']>
  showBettingHistory?: InputMaybe<Scalars['Boolean']['input']>
  showProfile?: InputMaybe<Scalars['Boolean']['input']>
  showSetups?: InputMaybe<Scalars['Boolean']['input']>
  showStats?: InputMaybe<Scalars['Boolean']['input']>
}

export type CheckChallengeTaskCompletionInput = {
  id: Scalars['String']['input']
}

export type CheckNameAvailabilityInput = {
  name: Scalars['String']['input']
}

export type CheckReferralAvalabilityInput = {
  code: Scalars['String']['input']
}

export type ClaimRewardInput = {
  id: Scalars['String']['input']
}

export type CloseReferralWithdrawRequestOperationInput = {
  requestId: Scalars['String']['input']
  transactionHash: Scalars['String']['input']
}

export type ConfirmEmailInput = {
  token: Scalars['String']['input']
}

export type ConsentInput = {
  analytics: Scalars['Boolean']['input']
  grantedAt: Scalars['DateTime']['input']
  marketing: Scalars['Boolean']['input']
  version: Scalars['String']['input']
}

export type ContractEntry = {
  __typename?: 'ContractEntry'
  contractName: Scalars['String']['output']
  contracts: Array<SmartContractEntity>
}

export type ContractFees = {
  __typename?: 'ContractFees'
  contractName: Scalars['String']['output']
  fees: Fees
}

export type ContractsByNameInput = {
  contractName: Scalars['String']['input']
}

export type CreateDemoUpDownAiGameInput = {
  channelId: Scalars['String']['input']
  duration: Scalars['Int']['input']
}

export type CreateGuestSessionInput = {
  fingerprint?: InputMaybe<Scalars['String']['input']>
  utm?: InputMaybe<Scalars['JSON']['input']>
}

export type CreateOffchainReferralSeasonInput = {
  endsAt: Scalars['Timestamp']['input']
  startsAt: Scalars['Timestamp']['input']
}

export type DailyTasks = {
  __typename?: 'DailyTasks'
  facetedTasks: Array<ChallengeTask>
  serialTasks: Array<Array<ChallengeTask>>
  simpleTasks: Array<ChallengeTask>
}

export type DeleteCache = {
  /** Delete bullseye game cache by game ids */
  bullseyeGame?: InputMaybe<Array<Scalars['String']['input']>>
  /** Delete bullseye game predicts cache by game ids */
  bullseyeGamePredicts?: InputMaybe<Array<Scalars['String']['input']>>
  /** Delete predict cache by owner id and game id */
  bullseyePredict?: InputMaybe<Array<DeleteGamePredictCache>>
  /** Delete bullseye current game cache */
  currentBullseyeGame?: InputMaybe<Scalars['Boolean']['input']>
  /** Delete updown current game cache */
  currentUpDownGame?: InputMaybe<Scalars['Boolean']['input']>
  /** Delete referral cache by user ids */
  referral?: InputMaybe<Array<Scalars['String']['input']>>
  /** Delete reward cache by user ids */
  reward?: InputMaybe<Array<Scalars['String']['input']>>
  /** Delete updown game cache by game ids */
  upDownGame?: InputMaybe<Array<Scalars['String']['input']>>
  /** Delete updown game predicts cache by game ids */
  upDownGamePredicts?: InputMaybe<Array<Scalars['String']['input']>>
  /** Delete predict cache by owner id and game id */
  upDownPredict?: InputMaybe<Array<DeleteGamePredictCache>>
  /** Delete user cache by user ids */
  user?: InputMaybe<Array<Scalars['String']['input']>>
  /** Delete user bullseye predicts cache by user ids */
  userBullseyePredicts?: InputMaybe<Array<Scalars['String']['input']>>
  /** Delete user daily tasks cache by user ids */
  userDailyTasks?: InputMaybe<Array<Scalars['String']['input']>>
  /** Delete user season cache by user ids */
  userSeason?: InputMaybe<Array<Scalars['String']['input']>>
  /** Delete user updown predicts cache by user ids */
  userUpDownPredicts?: InputMaybe<Array<Scalars['String']['input']>>
}

export type DeleteGamePredictCache = {
  gameId: Scalars['String']['input']
  ownerId: Scalars['String']['input']
}

export type DemoBullseyeGame = {
  __typename?: 'DemoBullseyeGame'
  amount: Scalars['Float']['output']
  channelId: Scalars['String']['output']
  commission?: Maybe<Scalars['Float']['output']>
  createdAt: Scalars['Timestamp']['output']
  endAt?: Maybe<Scalars['Timestamp']['output']>
  endPrice?: Maybe<Scalars['Float']['output']>
  exactRange: Scalars['Float']['output']
  feeBps: Scalars['Int']['output']
  feedId: Scalars['String']['output']
  gameType: DemoGameType
  id: Scalars['String']['output']
  isExact?: Maybe<Scalars['Boolean']['output']>
  modeId: Scalars['ID']['output']
  /** The caller's guess in this round: by guest session, else by signed-in user. */
  myPredict?: Maybe<DemoBullseyePredict>
  pool: DemoBullseyeGamePoolInfo
  /** All guesses of the round. Ordered by place once CLOSE, else by time. */
  predicts: Array<DemoBullseyePredict>
  startAt?: Maybe<Scalars['Timestamp']['output']>
  startPrice?: Maybe<Scalars['Float']['output']>
  status: GameStatus
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>
  timeframe: Scalars['Int']['output']
  totalAmount?: Maybe<Scalars['Float']['output']>
  updatedAt: Scalars['Timestamp']['output']
}

export type DemoBullseyeGameMode = {
  __typename?: 'DemoBullseyeGameMode'
  amount: Scalars['Float']['output']
  asset: Asset
  assetId: Scalars['String']['output']
  /** Latest demo round of the table (OPEN, or the last settled one until the next opens). */
  current?: Maybe<DemoBullseyeGame>
  exactRange: Scalars['Float']['output']
  id: Scalars['String']['output']
  lockWindow: Scalars['Float']['output']
  predictWindow: Scalars['Float']['output']
  sortOrder: Scalars['Float']['output']
  timeframeSec: Scalars['Float']['output']
}

export type DemoBullseyeGamePoolInfo = {
  __typename?: 'DemoBullseyeGamePoolInfo'
  poolAmount: Scalars['Float']['output']
  predictsCount: Scalars['Int']['output']
}

export type DemoBullseyeGames = {
  __typename?: 'DemoBullseyeGames'
  games: Array<DemoBullseyeGame>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type DemoBullseyeModeIdInput = {
  modeId: Scalars['ID']['input']
}

export type DemoBullseyePredict = {
  __typename?: 'DemoBullseyePredict'
  amount: Scalars['Float']['output']
  commission?: Maybe<Scalars['Float']['output']>
  createdAt: Scalars['Timestamp']['output']
  game?: Maybe<DemoBullseyeGame>
  gameId: Scalars['String']['output']
  gameType: DemoGameType
  id: Scalars['String']['output']
  isExact?: Maybe<Scalars['Boolean']['output']>
  /** True when the predict belongs to the caller's guest session, or to the signed-in user. */
  isMine: Scalars['Boolean']['output']
  outcome?: Maybe<Scalars['Float']['output']>
  /** The registered owner; null for an unclaimed guest. */
  participant?: Maybe<User>
  place?: Maybe<Scalars['Int']['output']>
  pnl?: Maybe<Scalars['Float']['output']>
  price: Scalars['Float']['output']
  score?: Maybe<Scalars['Float']['output']>
  status: PredictStatus
  updatedAt: Scalars['Timestamp']['output']
}

export type DemoBullseyePredicts = {
  __typename?: 'DemoBullseyePredicts'
  predicts: Array<DemoBullseyePredict>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type DemoBullseyeQuota = {
  __typename?: 'DemoBullseyeQuota'
  /** enabled, not registered, and rounds left (or no limit). */
  canPlay: Scalars['Boolean']['output']
  /** DEMO_BULLSEYE_ENABLED. When false, addDemoBullseyePredict is rejected and the mode should be hidden. */
  enabled: Scalars['Boolean']['output']
  /** The guest session was claimed by a registration, or the caller is signed in. Demo is closed. */
  registered: Scalars['Boolean']['output']
  /** Null when the session has no round limit. */
  roundsLeft?: Maybe<Scalars['Int']['output']>
  /** Null when the session has no round limit. */
  roundsLimit?: Maybe<Scalars['Int']['output']>
  /** Rounds that count: every guess except those of REJECTed rounds. */
  roundsPlayed: Scalars['Int']['output']
}

export type DemoBullseyeUserStatistic = {
  __typename?: 'DemoBullseyeUserStatistic'
  /** Settled demo guesses that carry the round exact stamp. */
  exactHits: Scalars['Int']['output']
  /** Sum of the leaderboard deltas stored on the settled demo guesses. */
  score: Scalars['Float']['output']
  /** Settled demo guesses (WON or LOSS) of CLOSE rounds. */
  totalGames: Scalars['Int']['output']
  totalWins: Scalars['Int']['output']
  /** totalWins / totalGames × 100; 0 when no games. */
  winPercentage: Scalars['Float']['output']
}

/** The supported demo games. */
export enum DemoGameType {
  Bullseye = 'BULLSEYE',
  Updown = 'UPDOWN',
  UpdownAi = 'UPDOWN_AI'
}

export type DemoUpDownAiGame = {
  __typename?: 'DemoUpDownAiGame'
  asset: Asset
  channelId: Scalars['String']['output']
  commission?: Maybe<Scalars['Float']['output']>
  createdAt: Scalars['Timestamp']['output']
  deposit: Scalars['Float']['output']
  difficulty: BotDifficulty
  endAt?: Maybe<Scalars['Timestamp']['output']>
  endPrice?: Maybe<Scalars['Float']['output']>
  feedId: Scalars['String']['output']
  gameType: DemoGameType
  id: Scalars['String']['output']
  isUp?: Maybe<Scalars['Boolean']['output']>
  myPredict?: Maybe<DemoUpDownAiPredict>
  opponent: User
  opponentPredict?: Maybe<DemoUpDownAiPredict>
  opponentUserId: Scalars['String']['output']
  participant?: Maybe<User>
  startAt?: Maybe<Scalars['Timestamp']['output']>
  startPrice?: Maybe<Scalars['Float']['output']>
  status: GameStatus
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>
  timeframe?: Maybe<Scalars['Int']['output']>
  totalAmount?: Maybe<Scalars['Float']['output']>
  updatedAt: Scalars['Timestamp']['output']
  userId?: Maybe<Scalars['String']['output']>
}

export type DemoUpDownAiGames = {
  __typename?: 'DemoUpDownAiGames'
  games: Array<DemoUpDownAiGame>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type DemoUpDownAiPredict = {
  __typename?: 'DemoUpDownAiPredict'
  amount: Scalars['Float']['output']
  commission?: Maybe<Scalars['Float']['output']>
  createdAt: Scalars['Timestamp']['output']
  game?: Maybe<DemoUpDownAiGame>
  gameId: Scalars['String']['output']
  gameType: DemoGameType
  id: Scalars['String']['output']
  isLong: Scalars['Boolean']['output']
  outcome?: Maybe<Scalars['Float']['output']>
  participant?: Maybe<User>
  pnl?: Maybe<Scalars['Float']['output']>
  score?: Maybe<Scalars['Float']['output']>
  status: PredictStatus
  updatedAt: Scalars['Timestamp']['output']
  userId?: Maybe<Scalars['String']['output']>
  winStreakLength: Scalars['Int']['output']
}

export type DemoUpDownAiProjectedRank = {
  __typename?: 'DemoUpDownAiProjectedRank'
  /** Competition rank if the guest registered now. 1 + members scoring higher. Approximate. */
  rank: Scalars['Int']['output']
  /** Board size including the guest, so "#rank of totalRanked" matches post-registration. */
  totalRanked: Scalars['Int']['output']
}

export type DemoUpDownAiQuota = {
  __typename?: 'DemoUpDownAiQuota'
  /** Not registered, and rounds left (or no limit). */
  canPlay: Scalars['Boolean']['output']
  /** The guest session was claimed by a registration, or the caller is signed in. Demo is closed. */
  registered: Scalars['Boolean']['output']
  /** Null when the session has no round limit. */
  roundsLeft?: Maybe<Scalars['Int']['output']>
  /** Null when the session has no round limit. */
  roundsLimit?: Maybe<Scalars['Int']['output']>
  /** Rounds that count: every predict except those of REJECTed rounds. */
  roundsPlayed: Scalars['Int']['output']
}

export type DemoUpDownAiSessionStatistic = {
  __typename?: 'DemoUpDownAiSessionStatistic'
  bestStreak: Scalars['Int']['output']
  currentStreak: Scalars['Int']['output']
  /** Approximate all-time rank if the guest registered now. Null when no round has settled. */
  projectedAlltime?: Maybe<DemoUpDownAiProjectedRank>
  /** Approximate daily rank if the guest registered now. Null when no round has settled. */
  projectedDaily?: Maybe<DemoUpDownAiProjectedRank>
  /** Approximate weekly rank if the guest registered now. Null when no round has settled. */
  projectedWeekly?: Maybe<DemoUpDownAiProjectedRank>
  /** Signed session score, same as the daily board after registration. Null before any settled round. Negatives are valid. */
  score?: Maybe<Scalars['Int']['output']>
  totalGames: Scalars['Int']['output']
  totalWins: Scalars['Int']['output']
  winPercentage: Scalars['Float']['output']
}

export type DemoUpDownChannelInput = {
  channelId: Scalars['String']['input']
}

export type DemoUpDownGame = {
  __typename?: 'DemoUpDownGame'
  channelId: Scalars['String']['output']
  commission?: Maybe<Scalars['Float']['output']>
  createdAt: Scalars['Timestamp']['output']
  downPool: DemoUpDownGamePoolInfo
  endAt?: Maybe<Scalars['Timestamp']['output']>
  endPrice?: Maybe<Scalars['Float']['output']>
  feedId: Scalars['String']['output']
  gameType: DemoGameType
  id: Scalars['String']['output']
  isUp?: Maybe<Scalars['Boolean']['output']>
  myPredict?: Maybe<DemoUpDownPredict>
  startAt?: Maybe<Scalars['Timestamp']['output']>
  startPrice?: Maybe<Scalars['Float']['output']>
  status: GameStatus
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>
  timeframe?: Maybe<Scalars['Int']['output']>
  totalAmount?: Maybe<Scalars['Float']['output']>
  upPool: DemoUpDownGamePoolInfo
  updatedAt: Scalars['Timestamp']['output']
}

export type DemoUpDownGamePoolInfo = {
  __typename?: 'DemoUpDownGamePoolInfo'
  poolAmount: Scalars['Float']['output']
  predicts: Array<DemoUpDownPredict>
  predictsCount: Scalars['Float']['output']
}

export type DemoUpDownGames = {
  __typename?: 'DemoUpDownGames'
  games: Array<DemoUpDownGame>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type DemoUpDownPredict = {
  __typename?: 'DemoUpDownPredict'
  amount: Scalars['Float']['output']
  commission?: Maybe<Scalars['Float']['output']>
  createdAt: Scalars['Timestamp']['output']
  game?: Maybe<DemoUpDownGame>
  gameId: Scalars['String']['output']
  gameType: DemoGameType
  id: Scalars['String']['output']
  isLong: Scalars['Boolean']['output']
  outcome?: Maybe<Scalars['Float']['output']>
  participant?: Maybe<User>
  pnl?: Maybe<Scalars['Float']['output']>
  status: PredictStatus
  updatedAt: Scalars['Timestamp']['output']
  userId?: Maybe<Scalars['String']['output']>
  winStreakLength: Scalars['Int']['output']
}

export type DemoUpDownPredicts = {
  __typename?: 'DemoUpDownPredicts'
  predicts: Array<DemoUpDownPredict>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type DemoUpDownQuota = {
  __typename?: 'DemoUpDownQuota'
  /** Not registered, and rounds left (or no limit). */
  canPlay: Scalars['Boolean']['output']
  /** The guest session was claimed by a registration, or the caller is signed in. Demo is closed. */
  registered: Scalars['Boolean']['output']
  /** Null when the session has no round limit. */
  roundsLeft?: Maybe<Scalars['Int']['output']>
  /** Null when the session has no round limit. */
  roundsLimit?: Maybe<Scalars['Int']['output']>
  /** Rounds that count: every predict except those of REJECTed rounds. */
  roundsPlayed: Scalars['Int']['output']
}

export type EmailNotificationPolicyType = {
  __typename?: 'EmailNotificationPolicyType'
  id: Scalars['String']['output']
  notifyBetsResult: Scalars['Boolean']['output']
  notifyBettingInvitation: Scalars['Boolean']['output']
  notifyNewAchievements: Scalars['Boolean']['output']
  notifyTransactions: Scalars['Boolean']['output']
  notifyUpdates: Scalars['Boolean']['output']
  sendNotificationsToEmail: Scalars['Boolean']['output']
  userId: Scalars['String']['output']
}

export type Fees = {
  __typename?: 'Fees'
  fee?: Maybe<Scalars['Float']['output']>
  ownerFee?: Maybe<Scalars['Float']['output']>
}

export type FindUpDownAiOpponentsInput = {
  difficulty?: InputMaybe<BotDifficulty>
  name?: InputMaybe<Scalars['String']['input']>
  skip: Scalars['Int']['input']
  take: Scalars['Int']['input']
}

export type FindUsersInput = {
  name?: InputMaybe<Scalars['String']['input']>
  skip: Scalars['Int']['input']
  take: Scalars['Int']['input']
}

export type Game = {
  __typename?: 'Game'
  asset: Asset
  chainIdentifier?: Maybe<Scalars['String']['output']>
  chainType?: Maybe<Scalars['String']['output']>
  commission?: Maybe<Scalars['Float']['output']>
  contractAddress?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Timestamp']['output']
  endAt?: Maybe<Scalars['Timestamp']['output']>
  endPrice?: Maybe<Scalars['Float']['output']>
  feedId?: Maybe<Scalars['String']['output']>
  gameType: GameType
  id: Scalars['String']['output']
  startAt?: Maybe<Scalars['Timestamp']['output']>
  startPrice?: Maybe<Scalars['Float']['output']>
  status: GameStatus
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>
  timeframe?: Maybe<Scalars['Int']['output']>
  token?: Maybe<Scalars['String']['output']>
  totalAmount?: Maybe<Scalars['Float']['output']>
  updatedAt: Scalars['Timestamp']['output']
}

export type GameResultNotification = {
  __typename?: 'GameResultNotification'
  createdAt: Scalars['Timestamp']['output']
  id: Scalars['String']['output']
  isRead: Scalars['Boolean']['output']
  payload: GameResultNotificationPayload
  type: NotificationType
  userId: Scalars['String']['output']
}

/** Supported game result notifications */
export type GameResultNotificationPayload =
  | BullseyeGameResultNotificationPayload
  | OneVsOneGameResultNotificationPayload
  | SetupGameResultNotificationPayload
  | UpDownGameResultNotificationPayload

/** The supported game statuses. */
export enum GameStatus {
  Close = 'CLOSE',
  Open = 'OPEN',
  Reject = 'REJECT'
}

/** The supported games. */
export enum GameType {
  Bullseye = 'BULLSEYE',
  Onevsone = 'ONEVSONE',
  Race = 'RACE',
  Setup = 'SETUP',
  Updown = 'UPDOWN',
  UpdownAi = 'UPDOWN_AI'
}

export type GameVolume = {
  __typename?: 'GameVolume'
  volume: Scalars['Float']['output']
}

export type GameVolumeOfThePreviousDay = {
  __typename?: 'GameVolumeOfThePreviousDay'
  volume: Scalars['Float']['output']
}

export type GetAssetPriceInput = {
  assetId: Scalars['String']['input']
  timestamp?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetDiscordAuthUriInput = {
  redirectUri: Scalars['String']['input']
}

export type GetPaginatedCashbackRequestsInputType = {
  skip: Scalars['Int']['input']
  status: CashbackStatus
  take: Scalars['Int']['input']
}

export type GetRoom = {
  type: Scalars['String']['input']
}

export type GetRoomMessages = {
  paginationToken?: InputMaybe<Scalars['String']['input']>
  roomId: Scalars['String']['input']
}

export type GetTwitterAuthUriInput = {
  redirectUri: Scalars['String']['input']
}

export type GetUserReferralStatisticsInput = {
  endDate: Scalars['Timestamp']['input']
  isSubReferral: Scalars['Boolean']['input']
  startDate: Scalars['Timestamp']['input']
}

export type GetWalletChallengeInput = {
  walletAddress: Scalars['String']['input']
}

export type GlobalGamesStatistic = {
  __typename?: 'GlobalGamesStatistic'
  countDailyClosedGames: Scalars['Int']['output']
}

export type GuestDemoBullseyePredictsInput = {
  modeId?: InputMaybe<Scalars['ID']['input']>
  pagination: PaginatedInput
}

export type GuestDemoUpDownAiGamesInput = {
  channelId?: InputMaybe<Scalars['String']['input']>
  pagination: PaginatedInput
}

export type GuestDemoUpDownPredictsInput = {
  channelId?: InputMaybe<Scalars['String']['input']>
  pagination: PaginatedInput
}

export type GuestSession = {
  __typename?: 'GuestSession'
  agent?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  claimedAt?: Maybe<Scalars['Timestamp']['output']>
  country?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Timestamp']['output']
  expiresAt?: Maybe<Scalars['Timestamp']['output']>
  fingerprint?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  ip?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Timestamp']['output']
  userId?: Maybe<Scalars['String']['output']>
}

export type HotNotification = {
  __typename?: 'HotNotification'
  createdAt: Scalars['Timestamp']['output']
  id: Scalars['String']['output']
  isRead: Scalars['Boolean']['output']
  type: NotificationType
  updatedAt: Scalars['Timestamp']['output']
  userId: Scalars['String']['output']
}

export type Level = {
  __typename?: 'Level'
  cashBackPercent: Scalars['Int']['output']
  cashReward: Scalars['Float']['output']
  commissionsToPay: Scalars['Float']['output']
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  pointReward: Scalars['Float']['output']
}

export type ListCandlesInput = {
  assetId: Scalars['String']['input']
  endDate: Scalars['Timestamp']['input']
  startDate: Scalars['Timestamp']['input']
  timeframe: Scalars['Int']['input']
}

export type MarkNotificationsAsReadInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>
}

export type MentionNotification = {
  __typename?: 'MentionNotification'
  createdAt: Scalars['Timestamp']['output']
  id: Scalars['String']['output']
  isRead: Scalars['Boolean']['output']
  messageId: Scalars['String']['output']
  type: NotificationType
  userId: Scalars['String']['output']
}

export type MergeGuestSessionBullseyeResult = {
  __typename?: 'MergeGuestSessionBullseyeResult'
  /** Mean error in percent of the credited rounds. Null when nothing was credited. */
  avgErrorPct?: Maybe<Scalars['Float']['output']>
  /** Credited rounds that carry the round exact stamp. */
  exactHits: Scalars['Int']['output']
  /** All-time board rank after migration. Null when not ranked. */
  rankAlltime?: Maybe<Scalars['Int']['output']>
  /** Daily board rank after migration. Null when not ranked. */
  rankDaily?: Maybe<Scalars['Int']['output']>
  /** Weekly board rank after migration. Null when not ranked. */
  rankWeekly?: Maybe<Scalars['Int']['output']>
  /** Demo Bullseye guesses re-owned by the user. */
  roundsMigrated: Scalars['Int']['output']
  /** Score credited to the Bullseye leaderboard by the settled rounds. Zero when nothing was credited. */
  scoreMigrated: Scalars['Float']['output']
  /** Settled rounds credited to the leaderboard. */
  settledRounds: Scalars['Int']['output']
  wins: Scalars['Int']['output']
}

export type MergeGuestSessionModeResult = {
  __typename?: 'MergeGuestSessionModeResult'
  /** All-time board rank after migration. Null when not ranked. */
  rankAlltime?: Maybe<Scalars['Int']['output']>
  /** Daily board rank after migration. Null when not ranked. */
  rankDaily?: Maybe<Scalars['Int']['output']>
  /** Weekly board rank after migration. Null when not ranked. */
  rankWeekly?: Maybe<Scalars['Int']['output']>
  roundsMigrated: Scalars['Int']['output']
  /** Signed Human vs AI score credited to the leaderboard. Zero for pool mode and when nothing was migrated. */
  scoreMigrated: Scalars['Int']['output']
  wins: Scalars['Int']['output']
}

export type MergeGuestSessionResult = {
  __typename?: 'MergeGuestSessionResult'
  alreadyClaimed: Scalars['Boolean']['output']
  bullseye: MergeGuestSessionBullseyeResult
  roundsMigrated: Scalars['Int']['output']
  upDown: MergeGuestSessionModeResult
  upDownAi: MergeGuestSessionModeResult
  wins: Scalars['Int']['output']
}

export type Message = {
  __typename?: 'Message'
  createdAt: Scalars['Timestamp']['output']
  id: Scalars['String']['output']
  replyTo?: Maybe<Message>
  roomId: Scalars['String']['output']
  sender?: Maybe<User>
  tagList: Array<Scalars['String']['output']>
  text: Scalars['Markdown']['output']
}

export type Messages = {
  __typename?: 'Messages'
  messages: Array<Message>
  nextToken?: Maybe<Scalars['String']['output']>
  prevToken?: Maybe<Scalars['String']['output']>
}

export type Meta = {
  __typename?: 'Meta'
  amount?: Maybe<Scalars['Float']['output']>
  asset?: Maybe<Scalars['String']['output']>
  assets?: Maybe<Array<Scalars['String']['output']>>
  decimals?: Maybe<Scalars['Int']['output']>
  fee?: Maybe<Scalars['Float']['output']>
  isMultiParticipation?: Maybe<Scalars['Boolean']['output']>
  ownerFee?: Maybe<Scalars['Float']['output']>
  token?: Maybe<Scalars['String']['output']>
}

export type Mutation = {
  __typename?: 'Mutation'
  addAffiliateWalletAddress: Affiliate
  /** Place the caller's guess in the table's OPEN round. One guess per round; rounds per guest session are limited by DemoBullseyeQuota. Not available once registered. */
  addDemoBullseyePredict: DemoBullseyePredict
  addDemoUpDownAiPredict: DemoUpDownAiPredict
  addDemoUpDownPredict: DemoUpDownPredict
  approveWithdrawRequest: ReferralWithdrawRequest
  attachDiscord: Scalars['Void']['output']
  attachTelegram: Scalars['Void']['output']
  attachTwitter: Scalars['Void']['output']
  cancelWithdrawRequest: ReferralWithdrawRequest
  changeEmail: User
  changePassword: User
  changeReferralCode: Scalars['String']['output']
  checkChallengeTaskCompletion: Season
  claimCashback: CashbackRequest
  claimReward: UserChallengeTask
  closeWithdrawRequest: ReferralWithdrawRequest
  confirmEmail: Scalars['Boolean']['output']
  createDemoUpDownAiGame: DemoUpDownAiGame
  createGuestSession: GuestSession
  createReferralSeason: OffchainReferralSeason
  createUserUpdatedEvents: Scalars['Void']['output']
  createWithdrawRequest: ReferralWithdrawRequest
  deleteAvatar: User
  deleteCache: Scalars['Void']['output']
  deleteReferralSeason: OffchainReferralSeason
  detachTelegram: Scalars['Void']['output']
  /** Re-reads the balance of one wallet linked to the authenticated user. */
  forceUpdateUserBlockchainBalance: UserBlockchainBalance
  linkWallet: UserWallet
  linkWalletChallenge: WalletLinkChallenge
  markNotificationsRead?: Maybe<Scalars['Void']['output']>
  markReceivedCashback: CashbackRequest
  mergeGuestSession: MergeGuestSessionResult
  recoveryPassword: Scalars['Boolean']['output']
  rejectWithdrawRequest: ReferralWithdrawRequest
  removeAffiliateWalletAddress: Affiliate
  requestEmailConfirm: Scalars['Boolean']['output']
  requestRecoveryPassword: Scalars['Boolean']['output']
  sendMessage: Message
  setConsent: Scalars['Boolean']['output']
  signInEmail: Scalars['String']['output']
  signInPrivy: Scalars['String']['output']
  signUpDownAiGameCreation: UpDownAiGameAuthorization
  signUpEmail: Scalars['String']['output']
  signout?: Maybe<Scalars['String']['output']>
  syncRewardsForReferrals: Scalars['Void']['output']
  touchAttribution: Scalars['Boolean']['output']
  unattachDiscord: Scalars['Void']['output']
  unattachTwitter: Scalars['Void']['output']
  updateAvatar: User
  updateInitialLevelIdByUserId: OffchainReferralUserLevel
  updateNotificationsPolicy: EmailNotificationPolicyType
  updatePrivacyPolicy: PrivacyPolicyType
  updateReferral: Referral
  updateReferralSeason: OffchainReferralSeason
  updateUser: User
  verifyWalletSignature: Scalars['String']['output']
}

export type MutationAddAffiliateWalletAddressArgs = {
  walletAddress: Scalars['String']['input']
}

export type MutationAddDemoBullseyePredictArgs = {
  data: AddDemoBullseyePredictInput
}

export type MutationAddDemoUpDownAiPredictArgs = {
  data: AddDemoUpDownAiPredictInput
}

export type MutationAddDemoUpDownPredictArgs = {
  data: AddDemoUpDownPredictInput
}

export type MutationApproveWithdrawRequestArgs = {
  data: ReferralWithdrawRequestOperationInput
}

export type MutationAttachDiscordArgs = {
  data: AttachDiscordInput
}

export type MutationAttachTelegramArgs = {
  data: AttachTelegramInput
}

export type MutationAttachTwitterArgs = {
  data: AttachTwitterInput
}

export type MutationCancelWithdrawRequestArgs = {
  data: ReferralWithdrawRequestOperationInput
}

export type MutationChangeEmailArgs = {
  data: ChangeEmailInput
}

export type MutationChangePasswordArgs = {
  data: ChangePasswordInput
}

export type MutationChangeReferralCodeArgs = {
  input: ChangeOffchainReferralCodeInputType
}

export type MutationCheckChallengeTaskCompletionArgs = {
  data: CheckChallengeTaskCompletionInput
}

export type MutationClaimCashbackArgs = {
  periodId: Scalars['String']['input']
}

export type MutationClaimRewardArgs = {
  data: ClaimRewardInput
}

export type MutationCloseWithdrawRequestArgs = {
  data: CloseReferralWithdrawRequestOperationInput
}

export type MutationConfirmEmailArgs = {
  data: ConfirmEmailInput
}

export type MutationCreateDemoUpDownAiGameArgs = {
  data: CreateDemoUpDownAiGameInput
}

export type MutationCreateGuestSessionArgs = {
  data?: InputMaybe<CreateGuestSessionInput>
}

export type MutationCreateReferralSeasonArgs = {
  input: CreateOffchainReferralSeasonInput
}

export type MutationDeleteCacheArgs = {
  data: DeleteCache
}

export type MutationDeleteReferralSeasonArgs = {
  id: Scalars['String']['input']
}

export type MutationForceUpdateUserBlockchainBalanceArgs = {
  walletAddress: Scalars['String']['input']
}

export type MutationLinkWalletArgs = {
  signature: Scalars['String']['input']
  walletAddress: Scalars['String']['input']
}

export type MutationLinkWalletChallengeArgs = {
  walletAddress: Scalars['String']['input']
}

export type MutationMarkNotificationsReadArgs = {
  data: MarkNotificationsAsReadInput
}

export type MutationMarkReceivedCashbackArgs = {
  input: UpdateCashbackRequestInputType
}

export type MutationRecoveryPasswordArgs = {
  data: RecoveryPasswordInput
}

export type MutationRejectWithdrawRequestArgs = {
  data: CancelReferralWithdrawRequestOperationInput
}

export type MutationRemoveAffiliateWalletAddressArgs = {
  walletAddress: Scalars['String']['input']
}

export type MutationRequestRecoveryPasswordArgs = {
  data: ChangeEmailInput
}

export type MutationSendMessageArgs = {
  data: SendMessageInput
}

export type MutationSetConsentArgs = {
  data: ConsentInput
}

export type MutationSignInEmailArgs = {
  data: SignInEmailAuthInput
}

export type MutationSignInPrivyArgs = {
  data: SignInPrivyInput
}

export type MutationSignUpDownAiGameCreationArgs = {
  data: SignUpDownAiGameCreationInput
}

export type MutationSignUpEmailArgs = {
  data: SignUpEmailAuthInput
}

export type MutationTouchAttributionArgs = {
  data: Scalars['JSON']['input']
}

export type MutationUpdateAvatarArgs = {
  file: Scalars['Upload']['input']
}

export type MutationUpdateInitialLevelIdByUserIdArgs = {
  initialLevelId: Scalars['Float']['input']
  userId: Scalars['String']['input']
}

export type MutationUpdateNotificationsPolicyArgs = {
  changes: ChangeEmailNotificationPolicyInput
}

export type MutationUpdatePrivacyPolicyArgs = {
  changes: ChangePrivacyPolicyInput
}

export type MutationUpdateReferralArgs = {
  data: UpdateReferralInput
}

export type MutationUpdateReferralSeasonArgs = {
  id: Scalars['String']['input']
  input: UpdateOffchainReferralSeasonInput
}

export type MutationUpdateUserArgs = {
  data: UpdateUserInput
}

export type MutationVerifyWalletSignatureArgs = {
  data: VerifyWalletSignatureInput
}

/** Supported notifications */
export type Notification =
  | BonusNotification
  | GameResultNotification
  | HotNotification
  | MentionNotification
  | OneVsOneAcceptedNotification
  | OneVsOneInvitationNotification
  | OneVsOneRefusedNotification
  | SetupGameClosedNotification

/** The supported notification types. */
export enum NotificationType {
  OneVsOneAccepted = 'OneVsOneAccepted',
  OneVsOneInvitation = 'OneVsOneInvitation',
  OneVsOneRefused = 'OneVsOneRefused',
  Bonus = 'bonus',
  GameResult = 'gameResult',
  Mention = 'mention',
  SetupGameClosed = 'setupGameClosed'
}

export type NotificationsPaginated = {
  __typename?: 'NotificationsPaginated'
  notifications: Array<Notification>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type NumberOfGlobalGamesGraphQlEntity = {
  __typename?: 'NumberOfGlobalGamesGraphQLEntity'
  global: Scalars['Float']['output']
}

export type NumberOfOwnReferrals = {
  __typename?: 'NumberOfOwnReferrals'
  numberOfDepositedReferrals: Scalars['Int']['output']
  numberOfDepositedSubReferrals: Scalars['Int']['output']
}

export type NumbersOfUserGamesGraphQlEntity = {
  __typename?: 'NumbersOfUserGamesGraphQLEntity'
  completed: Scalars['Int']['output']
  current: Scalars['Int']['output']
  expired: Scalars['Int']['output']
  personal: Scalars['Int']['output']
}

export type OffchainReferralLevel = {
  __typename?: 'OffchainReferralLevel'
  directCashbackPercentage: Scalars['Float']['output']
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  requiredEarning: Scalars['Float']['output']
  subCashbackPercentage: Scalars['Float']['output']
}

export type OffchainReferralSeason = {
  __typename?: 'OffchainReferralSeason'
  createdAt: Scalars['Timestamp']['output']
  endsAt: Scalars['Timestamp']['output']
  id: Scalars['String']['output']
  startsAt: Scalars['Timestamp']['output']
  status: Scalars['String']['output']
  updatedAt: Scalars['Timestamp']['output']
}

export type OffchainReferralSeasonLeaderBoardEntity = {
  __typename?: 'OffchainReferralSeasonLeaderBoardEntity'
  createdAt: Scalars['Timestamp']['output']
  id: Scalars['String']['output']
  position: Scalars['Int']['output']
  seasonId: Scalars['String']['output']
  totalEarning: Scalars['Float']['output']
  userId: Scalars['String']['output']
}

export type OffchainReferralStatisticsEntity = {
  __typename?: 'OffchainReferralStatisticsEntity'
  commission: Scalars['Float']['output']
  isDeposited: Scalars['Boolean']['output']
  ngr: Scalars['Float']['output']
  userId: Scalars['String']['output']
}

export type OffchainReferralUserLevel = {
  __typename?: 'OffchainReferralUserLevel'
  availableForWithdrawal: Scalars['Float']['output']
  code: Scalars['String']['output']
  currentSeasonIncome: Scalars['Float']['output']
  id: Scalars['String']['output']
  leaderboardPosition: Scalars['Int']['output']
  level?: Maybe<OffchainReferralLevel>
  levelId?: Maybe<Scalars['Int']['output']>
  referralLevel?: Maybe<OffchainReferralLevel>
  remainingToNextLevel: Scalars['Float']['output']
  totalEarning: Scalars['Float']['output']
  totalReferrals: Scalars['Int']['output']
  totalSeasonDepositedReferrals: Scalars['Int']['output']
  user?: Maybe<User>
  userId: Scalars['String']['output']
}

export type OneVsOneAcceptedNotification = {
  __typename?: 'OneVsOneAcceptedNotification'
  createdAt: Scalars['Timestamp']['output']
  id: Scalars['String']['output']
  isRead: Scalars['Boolean']['output']
  payload: OneVsOneAcceptedNotificationPayload
  type: NotificationType
  userId: Scalars['String']['output']
}

export type OneVsOneAcceptedNotificationPayload = {
  __typename?: 'OneVsOneAcceptedNotificationPayload'
  gameId: Scalars['String']['output']
  opponentId: Scalars['String']['output']
}

export type OneVsOneGame = {
  __typename?: 'OneVsOneGame'
  asset: Asset
  chainIdentifier?: Maybe<Scalars['String']['output']>
  chainType?: Maybe<Scalars['String']['output']>
  commission?: Maybe<Scalars['Float']['output']>
  contractAddress?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Timestamp']['output']
  endAt?: Maybe<Scalars['Timestamp']['output']>
  endPrice?: Maybe<Scalars['Float']['output']>
  feedId?: Maybe<Scalars['String']['output']>
  gameType: GameType
  id: Scalars['String']['output']
  isAccepted: Scalars['Boolean']['output']
  isPrivate: Scalars['Boolean']['output']
  opponent?: Maybe<User>
  opponentId?: Maybe<Scalars['String']['output']>
  opponentPredict?: Maybe<OneVsOnePredict>
  owner: User
  ownerId: Scalars['String']['output']
  ownerPredict: OneVsOnePredict
  predictAmount: Scalars['Float']['output']
  startAt?: Maybe<Scalars['Timestamp']['output']>
  startPrice?: Maybe<Scalars['Float']['output']>
  status: GameStatus
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>
  timeframe?: Maybe<Scalars['Int']['output']>
  token?: Maybe<Scalars['String']['output']>
  totalAmount?: Maybe<Scalars['Float']['output']>
  updatedAt: Scalars['Timestamp']['output']
}

export type OneVsOneGameFilters = {
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>
  isExpired?: InputMaybe<Scalars['Boolean']['input']>
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>
  opponentId?: InputMaybe<Scalars['String']['input']>
  ownerId?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<GameStatus>>
  stopPredictAt?: InputMaybe<StopPredictAtInput>
}

export type OneVsOneGameResultNotificationPayload = {
  __typename?: 'OneVsOneGameResultNotificationPayload'
  amount?: Maybe<Scalars['Float']['output']>
  gameType: GameType
  opponent?: Maybe<User>
  outcome?: Maybe<Scalars['Float']['output']>
  status: PredictStatus
}

export type OneVsOneGames = {
  __typename?: 'OneVsOneGames'
  games: Array<OneVsOneGame>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type OneVsOneInvitationNotification = {
  __typename?: 'OneVsOneInvitationNotification'
  createdAt: Scalars['Timestamp']['output']
  id: Scalars['String']['output']
  isRead: Scalars['Boolean']['output']
  payload: OneVsOneInvitationNotificationPayload
  type: NotificationType
  userId: Scalars['String']['output']
}

export type OneVsOneInvitationNotificationPayload = {
  __typename?: 'OneVsOneInvitationNotificationPayload'
  gameId: Scalars['String']['output']
  opponentId: Scalars['String']['output']
}

export type OneVsOneNumberOfGlobalGames = {
  __typename?: 'OneVsOneNumberOfGlobalGames'
  global: Scalars['Float']['output']
}

export type OneVsOneNumbersOfUserGames = {
  __typename?: 'OneVsOneNumbersOfUserGames'
  completed: Scalars['Int']['output']
  current: Scalars['Int']['output']
  expired: Scalars['Int']['output']
  personal: Scalars['Int']['output']
}

export type OneVsOnePredict = {
  __typename?: 'OneVsOnePredict'
  amount: Scalars['Float']['output']
  createdAt: Scalars['Timestamp']['output']
  finalizeTxHash?: Maybe<Scalars['String']['output']>
  game: OneVsOneGame
  gameId: Scalars['String']['output']
  gameType: GameType
  id: Scalars['String']['output']
  index?: Maybe<Scalars['Int']['output']>
  outcome?: Maybe<Scalars['Float']['output']>
  owner: User
  ownerId: Scalars['String']['output']
  playerAddress: Scalars['String']['output']
  pnl?: Maybe<Scalars['Float']['output']>
  price: Scalars['Float']['output']
  status: PredictStatus
  updatedAt: Scalars['Timestamp']['output']
}

export type OneVsOneRefusedNotification = {
  __typename?: 'OneVsOneRefusedNotification'
  createdAt: Scalars['Timestamp']['output']
  id: Scalars['String']['output']
  isRead: Scalars['Boolean']['output']
  payload: OneVsOneRefusedNotificationPayload
  type: NotificationType
  userId: Scalars['String']['output']
}

export type OneVsOneRefusedNotificationPayload = {
  __typename?: 'OneVsOneRefusedNotificationPayload'
  gameId: Scalars['String']['output']
  opponentId: Scalars['String']['output']
}

export type OwnReferralWithdrawRequestsFilters = {
  status?: InputMaybe<Array<ReferralWithdrawRequestStatus>>
}

export type PaginatedCashbackRequests = {
  __typename?: 'PaginatedCashbackRequests'
  requests: Array<CashbackRequest>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type PaginatedInput = {
  skip: Scalars['Int']['input']
  take: Scalars['Int']['input']
}

export type PaginatedOffchainLeaderBoard = {
  __typename?: 'PaginatedOffchainLeaderBoard'
  leaders: Array<OffchainReferralUserLevel>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type PaginatedOffchainReferralSeasonLeaderBoard = {
  __typename?: 'PaginatedOffchainReferralSeasonLeaderBoard'
  games: Array<OffchainReferralSeasonLeaderBoardEntity>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type PaginatedOffchainReferralStatistics = {
  __typename?: 'PaginatedOffchainReferralStatistics'
  result: Array<OffchainReferralStatisticsEntity>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type Predict = {
  __typename?: 'Predict'
  amount: Scalars['Float']['output']
  createdAt: Scalars['Timestamp']['output']
  finalizeTxHash?: Maybe<Scalars['String']['output']>
  game: Game
  gameId: Scalars['String']['output']
  gameType: GameType
  id: Scalars['String']['output']
  index?: Maybe<Scalars['Int']['output']>
  outcome?: Maybe<Scalars['Float']['output']>
  owner: User
  ownerId: Scalars['String']['output']
  playerAddress: Scalars['String']['output']
  pnl?: Maybe<Scalars['Float']['output']>
  status: PredictStatus
  updatedAt: Scalars['Timestamp']['output']
}

/** The supported predict statuses. */
export enum PredictStatus {
  Loss = 'LOSS',
  Open = 'OPEN',
  Reject = 'REJECT',
  Won = 'WON'
}

export type Predicts = {
  __typename?: 'Predicts'
  predicts: Array<Predict>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type PrivacyPolicyType = {
  __typename?: 'PrivacyPolicyType'
  allowInviteIn1vs1Game: Scalars['Boolean']['output']
  allowTagInChat: Scalars['Boolean']['output']
  id: Scalars['String']['output']
  showAchievements: Scalars['Boolean']['output']
  showBettingHistory: Scalars['Boolean']['output']
  showProfile: Scalars['Boolean']['output']
  showSetups: Scalars['Boolean']['output']
  showStats: Scalars['Boolean']['output']
  userId: Scalars['String']['output']
}

export type ProfitForReferralsPredicts = {
  __typename?: 'ProfitForReferralsPredicts'
  availableProfitAmountToWithdraw: Scalars['Float']['output']
  minProfitAmountToWithdraw: Scalars['Float']['output']
}

export type Query = {
  __typename?: 'Query'
  assetPrices: Array<AssetPrice>
  checkNameAvailability: Scalars['Boolean']['output']
  checkReferralAvalability: Referral
  findChatMembers: Array<User>
  findOpponents: Array<User>
  /** Opponents a Human vs AI game can be created against. */
  findUpDownAiOpponents: Array<UpDownAiOpponent>
  getActiveReferralSeason?: Maybe<OffchainReferralSeason>
  getAssetPrice: AssetPrice
  getBullseyeGameCached: BullseyeGame
  getBullseyeGameModes: Array<BullseyeGameMode>
  /** A ranked page of the Bullseye board for a period. Public: no session required. */
  getBullseyeLeaderboard: BullseyeLeaderboard
  /** A closed period's final standings, from the snapshot. Daily and weekly only. Public: no session required. */
  getBullseyeLeaderboardHistory: BullseyeLeaderboard
  getCashbackRequests: PaginatedCashbackRequests
  getCashbackSummary: Array<CashbackPeriodSummary>
  getCurrentBullseyeGame?: Maybe<BullseyeGame>
  /** Latest demo round of a table: OPEN, or the last settled one until the next opens. */
  getCurrentDemoBullseyeGame?: Maybe<DemoBullseyeGame>
  getCurrentDemoUpDownAiGame?: Maybe<DemoUpDownAiGame>
  getCurrentDemoUpDownGame: DemoUpDownGame
  getCurrentOnline: Scalars['Float']['output']
  getCurrentRaceGame: RaceGame
  getCurrentUpDownAiGames: UpDownAiGames
  getCurrentUpDownGame: UpDownGame
  getDemoBullseyeGameById: DemoBullseyeGame
  /** Demo Bullseye tables with their latest demo round. */
  getDemoBullseyeGameModes: Array<DemoBullseyeGameMode>
  getDemoBullseyeQuota: DemoBullseyeQuota
  getDemoUpDownAiGameById: DemoUpDownAiGame
  getDemoUpDownAiQuota: DemoUpDownAiQuota
  getDemoUpDownAiSessionStatistic: DemoUpDownAiSessionStatistic
  getDemoUpDownGameById: DemoUpDownGame
  getDemoUpDownQuota: DemoUpDownQuota
  getDiscordAuthUri: Scalars['String']['output']
  getGamesCommissions: Array<ContractFees>
  getGlobalGamesStatistic: GlobalGamesStatistic
  getGlobalRoom: Room
  /** The guest session's own guesses, newest first. */
  getGuestDemoBullseyePredicts: DemoBullseyePredicts
  getGuestDemoUpDownAiGames: DemoUpDownAiGames
  getGuestDemoUpDownPredicts: DemoUpDownPredicts
  getGuestSession?: Maybe<GuestSession>
  /** Last settled (CLOSE or REJECT) demo rounds of a table. */
  getLastClosedDemoBullseyeGames: DemoBullseyeGames
  getLastClosedDemoUpDownGames: DemoUpDownGames
  getLastClosedUpDownGames: UpDownGames
  getLeaderBordByEndedSeasonId: PaginatedOffchainReferralSeasonLeaderBoard
  getLevels: Array<Level>
  getLiveWinsPredicts: Predicts
  getMessageById: Message
  /** The caller's own row and rank, including when they are outside the visible page. Requires a user session; a guest session is not enough. */
  getMyBullseyeLeaderboardPosition?: Maybe<BullseyeLeaderboardEntry>
  /** The caller's own row and rank, including when they are outside the visible page. Requires a user session; a guest session is not enough. */
  getMyUpDownAiLeaderboardPosition?: Maybe<UpDownAiLeaderboardEntry>
  getNotificationById: Notification
  getNotifications: NotificationsPaginated
  getNotificationsByIds: Array<Notification>
  getNotificationsPolicies: EmailNotificationPolicyType
  getNumberOfOwnDepositedReferrals: NumberOfOwnReferrals
  getNumberOfUserSetupCreatedGames: SetupNumberOfCreatedGamesEntity
  getNumberOfUserSetupJoinedGames: SetupNumbersOfJoinedGamesEntity
  getOneVsOneGame: OneVsOneGame
  getOneVsOneGames: OneVsOneGames
  getOneVsOneNumberOfGLobalGames: NumberOfGlobalGamesGraphQlEntity
  getOneVsOneNumberOfUserGames: NumbersOfUserGamesGraphQlEntity
  getOwnOneVsOneGames: OneVsOneGames
  getOwnReferralWithdrawRequests: ReferralWithdrawRequests
  getPrivacyPolicies: PrivacyPolicyType
  getProfitForReferralsPredicts: ProfitForReferralsPredicts
  getRaceGameCached: RaceGame
  getRefLevelByUserId: OffchainReferralUserLevel
  getReferral: Referral
  getReferralLeaderboard: PaginatedOffchainLeaderBoard
  getReferralLevels: Array<OffchainReferralLevel>
  getReferralSeasons: Array<OffchainReferralSeason>
  getReferralStatistic: ReferralStatistic
  getReferralStatistics: PaginatedOffchainReferralStatistics
  getReferralUserLevel: OffchainReferralUserLevel
  getReferralWithdrawRequests: ReferralWithdrawRequests
  getReferralWithdrawRequestsStatistic: ReferralWithdrawRequestsStatistic
  getReferrerIdByCode: Scalars['String']['output']
  getRoomByType: Room
  getRoomMessagesPaginated: Messages
  getSessionsById: Array<Session>
  getSetupGame: SetupGame
  getSetupGames: SetupGames
  getSetupPredicts: SetupPredicts
  getSmartContracts: Array<ContractEntry>
  getSmartContractsByName: Array<SmartContractEntity>
  getTopUsersRewards: TopUsersRewards
  getTwitterAccountById: TwitterAccount
  getTwitterAuthUri: Scalars['String']['output']
  getUnreadNotificationsCount: Scalars['Int']['output']
  getUpDownAiGame: UpDownAiGame
  getUpDownAiGames: UpDownAiGames
  /** A ranked page of the Up/Down AI board for a period. Public: no session required. */
  getUpDownAiLeaderboard: UpDownAiLeaderboard
  /** A closed period's final standings, from the snapshot. Public: no session required. */
  getUpDownAiLeaderboardHistory: UpDownAiLeaderboard
  /** Balances of every wallet linked to the authenticated user, one per wallet, primary wallet first. */
  getUserBlockchainBalances: Array<UserBlockchainBalance>
  getUserBullseyeGames: BullseyeGames
  getUserBullseyePredicts: BullseyePredicts
  getUserBullseyePredictsStatistic: UserBullseyePredictsStatistic
  getUserByAddress: User
  getUserById: User
  getUserDailyTasks: DailyTasks
  getUserDailyTasksByUserId: DailyTasks
  /** The signed-in user's demo guesses, carried over by mergeGuestSession, newest first. */
  getUserDemoBullseyePredicts: DemoBullseyePredicts
  /** The signed-in user's demo statistic. Separate from the real Bullseye statistic; the client adds the two. */
  getUserDemoBullseyeStatistic: DemoBullseyeUserStatistic
  getUserDemoUpDownAiGames: DemoUpDownAiGames
  getUserDemoUpDownPredicts: DemoUpDownPredicts
  getUserGameStats: UserStats
  getUserGamesStatistic: UserGamesStatistic
  getUserLevel: UserLevel
  getUserOneVsOnePredictsStatistic: UserOneVsOnePredictsStatistic
  getUserRaceGames: RaceGames
  getUserRacePredicts: RacePredicts
  getUserRacePredictsStatistic: UserRacePredictsStatistic
  getUserReward: Reward
  getUserSeasonState: Season
  getUserSeasonStateByUserId: Season
  getUserSetupGames: SetupGames
  getUserSetupGamesStatistic: UserSetupGamesStatistic
  getUserSetupPredicts: SetupPredicts
  getUserSetupPredictsStatistic: UserSetupPredictsStatistic
  getUserUpDownAiPredicts: UpDownAiPredicts
  getUserUpDownAiPredictsStatistic: UserUpDownAiPredictsStatistic
  getUserUpDownPredicts: UpDownPredicts
  getUserUpDownPredictsStatistic: UserUpDownPredictsStatistic
  getVolumeOfThePreviousDay: GameVolume
  getVolumeUsersCommissionPaid: Scalars['Float']['output']
  getWalletChallenge: WalletChallenge
  healthcheck: Scalars['String']['output']
  listAssets: Array<Asset>
  listCandles: Array<Candle>
  me: User
  priceRange: Array<AssetPrice>
  resolveBullseyeUserGamePredicts: Array<BullseyePredict>
  resolvePredictCached?: Maybe<Predict>
  resolveRaceUserGamePredicts: Array<RacePredict>
  resolveSetupPredict: SetupPredict
  /** A user's row and rank for a period. Used by subscriptions; no session required. */
  resolveUserBullseyeLeaderboardPosition?: Maybe<BullseyeLeaderboardEntry>
  /** A user's row and rank for a period. Used by subscriptions; no session required. */
  resolveUserUpDownAiLeaderboardPosition?: Maybe<UpDownAiLeaderboardEntry>
}

export type QueryAssetPricesArgs = {
  data: AssetPricesInput
}

export type QueryCheckNameAvailabilityArgs = {
  data: CheckNameAvailabilityInput
}

export type QueryCheckReferralAvalabilityArgs = {
  data: CheckReferralAvalabilityInput
}

export type QueryFindChatMembersArgs = {
  data: FindUsersInput
}

export type QueryFindOpponentsArgs = {
  data: FindUsersInput
}

export type QueryFindUpDownAiOpponentsArgs = {
  data: FindUpDownAiOpponentsInput
}

export type QueryGetAssetPriceArgs = {
  data: GetAssetPriceInput
}

export type QueryGetBullseyeGameCachedArgs = {
  gameId: Scalars['String']['input']
}

export type QueryGetBullseyeLeaderboardArgs = {
  data: BullseyeLeaderboardInput
}

export type QueryGetBullseyeLeaderboardHistoryArgs = {
  data: BullseyeLeaderboardHistoryInput
}

export type QueryGetCashbackRequestsArgs = {
  input: GetPaginatedCashbackRequestsInputType
}

export type QueryGetCurrentBullseyeGameArgs = {
  data: BullseyeModeIdInput
}

export type QueryGetCurrentDemoBullseyeGameArgs = {
  data: DemoBullseyeModeIdInput
}

export type QueryGetCurrentDemoUpDownGameArgs = {
  data: DemoUpDownChannelInput
}

export type QueryGetCurrentRaceGameArgs = {
  data: RaceContractAddressInput
}

export type QueryGetCurrentUpDownAiGamesArgs = {
  data: UpDownAiCurrentGamesInput
}

export type QueryGetCurrentUpDownGameArgs = {
  data: UpDownContractAddressInput
}

export type QueryGetDemoBullseyeGameByIdArgs = {
  gameId: Scalars['ID']['input']
}

export type QueryGetDemoUpDownAiGameByIdArgs = {
  gameId: Scalars['String']['input']
}

export type QueryGetDemoUpDownGameByIdArgs = {
  gameId: Scalars['String']['input']
}

export type QueryGetDiscordAuthUriArgs = {
  data: GetDiscordAuthUriInput
}

export type QueryGetGuestDemoBullseyePredictsArgs = {
  data: GuestDemoBullseyePredictsInput
}

export type QueryGetGuestDemoUpDownAiGamesArgs = {
  data: GuestDemoUpDownAiGamesInput
}

export type QueryGetGuestDemoUpDownPredictsArgs = {
  data: GuestDemoUpDownPredictsInput
}

export type QueryGetLastClosedDemoBullseyeGamesArgs = {
  data: DemoBullseyeModeIdInput
}

export type QueryGetLastClosedDemoUpDownGamesArgs = {
  data: DemoUpDownChannelInput
}

export type QueryGetLastClosedUpDownGamesArgs = {
  data: UpDownContractAddressInput
}

export type QueryGetLeaderBordByEndedSeasonIdArgs = {
  pagination: PaginatedInput
  seasonId: Scalars['String']['input']
}

export type QueryGetLiveWinsPredictsArgs = {
  pagination: PaginatedInput
}

export type QueryGetMessageByIdArgs = {
  id: Scalars['String']['input']
}

export type QueryGetMyBullseyeLeaderboardPositionArgs = {
  period: BullseyeLeaderboardPeriod
}

export type QueryGetMyUpDownAiLeaderboardPositionArgs = {
  period: UpDownAiLeaderboardPeriod
}

export type QueryGetNotificationByIdArgs = {
  id: Scalars['String']['input']
}

export type QueryGetNotificationsArgs = {
  data: PaginatedInput
}

export type QueryGetNotificationsByIdsArgs = {
  ids: Array<Scalars['String']['input']>
}

export type QueryGetNumberOfOwnDepositedReferralsArgs = {
  isCurrent: Scalars['Boolean']['input']
}

export type QueryGetNumberOfUserSetupCreatedGamesArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetNumberOfUserSetupJoinedGamesArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetOneVsOneGameArgs = {
  id: Scalars['String']['input']
}

export type QueryGetOneVsOneGamesArgs = {
  filters: OneVsOneGameFilters
  pagination: PaginatedInput
}

export type QueryGetOneVsOneNumberOfUserGamesArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetOwnOneVsOneGamesArgs = {
  filters: OneVsOneGameFilters
  pagination: PaginatedInput
}

export type QueryGetOwnReferralWithdrawRequestsArgs = {
  filters: OwnReferralWithdrawRequestsFilters
  pagination: PaginatedInput
}

export type QueryGetRaceGameCachedArgs = {
  gameId: Scalars['String']['input']
}

export type QueryGetRefLevelByUserIdArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetReferralLeaderboardArgs = {
  pagination: PaginatedInput
}

export type QueryGetReferralStatisticsArgs = {
  input: GetUserReferralStatisticsInput
  pagination: PaginatedInput
}

export type QueryGetReferralWithdrawRequestsArgs = {
  filters: ReferralWithdrawRequestsFilters
  pagination: PaginatedInput
}

export type QueryGetReferrerIdByCodeArgs = {
  code: Scalars['String']['input']
}

export type QueryGetRoomByTypeArgs = {
  data: GetRoom
}

export type QueryGetRoomMessagesPaginatedArgs = {
  data: GetRoomMessages
}

export type QueryGetSessionsByIdArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetSetupGameArgs = {
  id: Scalars['String']['input']
}

export type QueryGetSetupGamesArgs = {
  filters: SetupGameFilters
  pagination: PaginatedInput
}

export type QueryGetSetupPredictsArgs = {
  id: Scalars['String']['input']
  pagination: PaginatedInput
}

export type QueryGetSmartContractsByNameArgs = {
  input: ContractsByNameInput
}

export type QueryGetTopUsersRewardsArgs = {
  pagination: PaginatedInput
}

export type QueryGetTwitterAuthUriArgs = {
  data: GetTwitterAuthUriInput
}

export type QueryGetUpDownAiGameArgs = {
  id: Scalars['String']['input']
}

export type QueryGetUpDownAiGamesArgs = {
  filters: UpDownAiGameFilters
  pagination: PaginatedInput
}

export type QueryGetUpDownAiLeaderboardArgs = {
  data: UpDownAiLeaderboardInput
}

export type QueryGetUpDownAiLeaderboardHistoryArgs = {
  data: UpDownAiLeaderboardHistoryInput
}

export type QueryGetUserBullseyeGamesArgs = {
  data: UserBullseyePredictsInput
}

export type QueryGetUserBullseyePredictsArgs = {
  data: UserBullseyePredictsInput
}

export type QueryGetUserBullseyePredictsStatisticArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserByAddressArgs = {
  address: Scalars['String']['input']
}

export type QueryGetUserByIdArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserDailyTasksByUserIdArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserDemoBullseyePredictsArgs = {
  data: UserDemoBullseyePredictsInput
}

export type QueryGetUserDemoUpDownAiGamesArgs = {
  data: UserDemoUpDownAiGamesInput
}

export type QueryGetUserDemoUpDownPredictsArgs = {
  data: UserDemoUpDownPredictsInput
}

export type QueryGetUserGameStatsArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserGamesStatisticArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserLevelArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserOneVsOnePredictsStatisticArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserRaceGamesArgs = {
  data: UserRacePredictsInput
}

export type QueryGetUserRacePredictsArgs = {
  data: UserRacePredictsInput
}

export type QueryGetUserRacePredictsStatisticArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserSeasonStateByUserIdArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserSetupGamesArgs = {
  filters: SetupGameFilters
  pagination: PaginatedInput
}

export type QueryGetUserSetupGamesStatisticArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserSetupPredictsArgs = {
  filters: SetupPredictFilters
  pagination: PaginatedInput
}

export type QueryGetUserSetupPredictsStatisticArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserUpDownAiPredictsArgs = {
  data: UserUpDownAiPredictsInput
}

export type QueryGetUserUpDownAiPredictsStatisticArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserUpDownPredictsArgs = {
  data: UserUpDownPredictsInput
}

export type QueryGetUserUpDownPredictsStatisticArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetVolumeOfThePreviousDayArgs = {
  contractAddress: Scalars['String']['input']
}

export type QueryGetWalletChallengeArgs = {
  data: GetWalletChallengeInput
}

export type QueryListCandlesArgs = {
  data: ListCandlesInput
}

export type QueryPriceRangeArgs = {
  data: AssetPricesRangeInput
}

export type QueryResolveBullseyeUserGamePredictsArgs = {
  gameId: Scalars['String']['input']
  ownerId: Scalars['String']['input']
}

export type QueryResolvePredictCachedArgs = {
  gameId: Scalars['String']['input']
  index?: InputMaybe<Scalars['Float']['input']>
  ownerId: Scalars['String']['input']
}

export type QueryResolveRaceUserGamePredictsArgs = {
  gameId: Scalars['String']['input']
  ownerId: Scalars['String']['input']
}

export type QueryResolveSetupPredictArgs = {
  gameId: Scalars['String']['input']
  ownerId: Scalars['String']['input']
}

export type QueryResolveUserBullseyeLeaderboardPositionArgs = {
  period: BullseyeLeaderboardPeriod
  userId: Scalars['String']['input']
}

export type QueryResolveUserUpDownAiLeaderboardPositionArgs = {
  period: UpDownAiLeaderboardPeriod
  userId: Scalars['String']['input']
}

export type RaceContractAddressInput = {
  contractAddress: Scalars['String']['input']
}

export type RaceGame = {
  __typename?: 'RaceGame'
  chainIdentifier?: Maybe<Scalars['String']['output']>
  chainType?: Maybe<Scalars['String']['output']>
  commission?: Maybe<Scalars['Float']['output']>
  contractAddress?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Timestamp']['output']
  endAt?: Maybe<Scalars['Timestamp']['output']>
  endPrice?: Maybe<Scalars['Float']['output']>
  endPrices: Array<Scalars['Float']['output']>
  endTimestamps: Array<Scalars['Float']['output']>
  feedId?: Maybe<Scalars['String']['output']>
  feedsIds: Array<Scalars['String']['output']>
  gameType: GameType
  id: Scalars['String']['output']
  myPredicts: Array<RacePredict>
  pool: RaceGamePoolInfo
  predicts: Array<RacePredict>
  priceDiffs: Array<Scalars['Float']['output']>
  startAt?: Maybe<Scalars['Timestamp']['output']>
  startPrice?: Maybe<Scalars['Float']['output']>
  startPrices: Array<Scalars['Float']['output']>
  startTimestamps: Array<Scalars['Float']['output']>
  status: GameStatus
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>
  timeframe?: Maybe<Scalars['Int']['output']>
  token?: Maybe<Scalars['String']['output']>
  totalAmount?: Maybe<Scalars['Float']['output']>
  updatedAt: Scalars['Timestamp']['output']
  wonFeedId?: Maybe<Scalars['String']['output']>
}

export type RaceGamePoolInfo = {
  __typename?: 'RaceGamePoolInfo'
  poolAmount: Scalars['Float']['output']
  predictsCount: Scalars['Float']['output']
}

export type RaceGames = {
  __typename?: 'RaceGames'
  games: Array<RaceGame>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type RacePredict = {
  __typename?: 'RacePredict'
  amount: Scalars['Float']['output']
  createdAt: Scalars['Timestamp']['output']
  feedId: Scalars['String']['output']
  finalizeTxHash?: Maybe<Scalars['String']['output']>
  game?: Maybe<RaceGame>
  gameId: Scalars['String']['output']
  gameType: GameType
  id: Scalars['String']['output']
  index: Scalars['Int']['output']
  outcome?: Maybe<Scalars['Float']['output']>
  owner?: Maybe<User>
  ownerId: Scalars['String']['output']
  playerAddress: Scalars['String']['output']
  pnl?: Maybe<Scalars['Float']['output']>
  status: PredictStatus
  updatedAt: Scalars['Timestamp']['output']
}

export type RacePredicts = {
  __typename?: 'RacePredicts'
  predicts: Array<RacePredict>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type RecoveryPasswordInput = {
  password: Scalars['String']['input']
  token: Scalars['String']['input']
}

export type Referral = {
  __typename?: 'Referral'
  active: Scalars['Boolean']['output']
  code: Scalars['String']['output']
  createdAt: Scalars['Timestamp']['output']
  oweReferralProfits: Scalars['Float']['output']
  referrer?: Maybe<User>
  referrlasAmount: Scalars['Int']['output']
  undeclaredReferralProfits: Scalars['Float']['output']
  updatedAt: Scalars['Timestamp']['output']
  user?: Maybe<User>
  userId: Scalars['String']['output']
}

export type ReferralStatistic = {
  __typename?: 'ReferralStatistic'
  numberOfInvited: Scalars['Int']['output']
  numberOfSecondLevelInvited: Scalars['Int']['output']
}

export type ReferralWithdrawRequest = {
  __typename?: 'ReferralWithdrawRequest'
  amount: Scalars['Float']['output']
  cancelReason?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Timestamp']['output']
  gamesMeta: ReferralWithdrawRequestGameMeta
  id: Scalars['String']['output']
  referral: Referral
  status: ReferralWithdrawRequestStatus
  transactionHash?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Timestamp']['output']
  user: User
}

export type ReferralWithdrawRequestGameMeta = {
  __typename?: 'ReferralWithdrawRequestGameMeta'
  count: Scalars['Int']['output']
  gameType: Scalars['String']['output']
  totalAmount: Scalars['Float']['output']
}

export type ReferralWithdrawRequestOperationInput = {
  requestId: Scalars['String']['input']
}

/** The supported referral withdraw request statuses. */
export enum ReferralWithdrawRequestStatus {
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ReferralWithdrawRequests = {
  __typename?: 'ReferralWithdrawRequests'
  requests: Array<ReferralWithdrawRequest>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type ReferralWithdrawRequestsFilters = {
  referrersIds?: InputMaybe<Array<Scalars['String']['input']>>
  status?: InputMaybe<Array<ReferralWithdrawRequestStatus>>
}

export type ReferralWithdrawRequestsStatistic = {
  __typename?: 'ReferralWithdrawRequestsStatistic'
  openAmount: Scalars['Float']['output']
  oweAmount: Scalars['Float']['output']
  paidAmount: Scalars['Float']['output']
  pendingAmount: Scalars['Float']['output']
}

export type Reward = {
  __typename?: 'Reward'
  currentPlace?: Maybe<Scalars['Int']['output']>
  id: Scalars['String']['output']
  lastPlace?: Maybe<Scalars['Int']['output']>
  lastPlaceOnLeaderboard: Scalars['Int']['output']
  placeChange?: Maybe<Scalars['Int']['output']>
  referralRewards: Scalars['Float']['output']
  rewards: Scalars['Float']['output']
  rewardsForChallenges: Scalars['Float']['output']
  user?: Maybe<User>
}

export type Room = {
  __typename?: 'Room'
  id: Scalars['String']['output']
}

export type Season = {
  __typename?: 'Season'
  challenges: Array<SeasonChallenge>
  countCompletedChallegnes: Scalars['Int']['output']
  description: Scalars['String']['output']
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type SeasonChallenge = {
  __typename?: 'SeasonChallenge'
  description: Scalars['String']['output']
  id: Scalars['String']['output']
  isCompleted: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  number: Scalars['Int']['output']
  tasks: Array<ChallengeTask>
}

export type SendMessageInput = {
  replyToId?: InputMaybe<Scalars['String']['input']>
  roomId: Scalars['String']['input']
  text: Scalars['Markdown']['input']
}

export type Session = {
  __typename?: 'Session'
  active: Scalars['Boolean']['output']
  createdAt: Scalars['Timestamp']['output']
  id: Scalars['String']['output']
  updatedAt: Scalars['Timestamp']['output']
  userId: Scalars['String']['output']
}

export type SetupGame = {
  __typename?: 'SetupGame'
  asset: Asset
  chainIdentifier?: Maybe<Scalars['String']['output']>
  chainType?: Maybe<Scalars['String']['output']>
  commission?: Maybe<Scalars['Float']['output']>
  contractAddress?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Timestamp']['output']
  endAt?: Maybe<Scalars['Timestamp']['output']>
  endPrice?: Maybe<Scalars['Float']['output']>
  feedId?: Maybe<Scalars['String']['output']>
  gameType: GameType
  id: Scalars['String']['output']
  isLong: Scalars['Boolean']['output']
  myPredict?: Maybe<SetupPredict>
  owner: User
  ownerId: Scalars['String']['output']
  ownerProfit?: Maybe<Scalars['Float']['output']>
  startAt?: Maybe<Scalars['Timestamp']['output']>
  startPrice?: Maybe<Scalars['Float']['output']>
  status: GameStatus
  stopLoss: Scalars['Float']['output']
  stopLossPool: SetupGamePoolInfo
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>
  takeProfit: Scalars['Float']['output']
  takeProfitPool: SetupGamePoolInfo
  timeframe?: Maybe<Scalars['Int']['output']>
  token?: Maybe<Scalars['String']['output']>
  totalAmount?: Maybe<Scalars['Float']['output']>
  updatedAt: Scalars['Timestamp']['output']
}

export type SetupGameClosedNotification = {
  __typename?: 'SetupGameClosedNotification'
  createdAt: Scalars['Timestamp']['output']
  id: Scalars['String']['output']
  isRead: Scalars['Boolean']['output']
  payload: SetupGameClosedNotificationPayload
  type: NotificationType
  userId: Scalars['String']['output']
}

export type SetupGameClosedNotificationPayload = {
  __typename?: 'SetupGameClosedNotificationPayload'
  gameId: Scalars['String']['output']
  ownerProfit: Scalars['Float']['output']
}

export type SetupGameFilters = {
  isExpired?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<Array<GameStatus>>
}

export type SetupGamePoolInfo = {
  __typename?: 'SetupGamePoolInfo'
  multiplier: Scalars['Float']['output']
  poolAmount: Scalars['Float']['output']
  predictsCount: Scalars['Float']['output']
}

export type SetupGameResultNotificationPayload = {
  __typename?: 'SetupGameResultNotificationPayload'
  amount?: Maybe<Scalars['Float']['output']>
  gameType: GameType
  outcome?: Maybe<Scalars['Float']['output']>
  status: PredictStatus
}

export type SetupGames = {
  __typename?: 'SetupGames'
  games: Array<SetupGame>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type SetupNumberOfCreatedGames = {
  __typename?: 'SetupNumberOfCreatedGames'
  active: Scalars['Int']['output']
  closed: Scalars['Int']['output']
}

export type SetupNumberOfCreatedGamesEntity = {
  __typename?: 'SetupNumberOfCreatedGamesEntity'
  active: Scalars['Int']['output']
  closed: Scalars['Int']['output']
}

export type SetupNumbersOfJoinedGames = {
  __typename?: 'SetupNumbersOfJoinedGames'
  active: Scalars['Int']['output']
  completed: Scalars['Int']['output']
  unclaimed: Scalars['Int']['output']
}

export type SetupNumbersOfJoinedGamesEntity = {
  __typename?: 'SetupNumbersOfJoinedGamesEntity'
  active: Scalars['Int']['output']
  completed: Scalars['Int']['output']
  unclaimed: Scalars['Int']['output']
}

export type SetupPredict = {
  __typename?: 'SetupPredict'
  amount: Scalars['Float']['output']
  createdAt: Scalars['Timestamp']['output']
  finalizeTxHash?: Maybe<Scalars['String']['output']>
  game: SetupGame
  gameId: Scalars['String']['output']
  gameType: GameType
  id: Scalars['String']['output']
  index?: Maybe<Scalars['Int']['output']>
  isLong: Scalars['Boolean']['output']
  isRetrieved: Scalars['Boolean']['output']
  outcome?: Maybe<Scalars['Float']['output']>
  owner: User
  ownerId: Scalars['String']['output']
  playerAddress: Scalars['String']['output']
  pnl?: Maybe<Scalars['Float']['output']>
  status: PredictStatus
  updatedAt: Scalars['Timestamp']['output']
}

export type SetupPredictFilters = {
  isRetrieved?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<Array<PredictStatus>>
}

export type SetupPredicts = {
  __typename?: 'SetupPredicts'
  predicts: Array<SetupPredict>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type SignInEmailAuthInput = {
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type SignInPrivyInput = {
  accessToken: Scalars['String']['input']
  referrerId?: InputMaybe<Scalars['String']['input']>
  username?: InputMaybe<Scalars['String']['input']>
}

export type SignUpDownAiGameCreationInput = {
  contractAddress: Scalars['String']['input']
  /** Predict window duration in seconds. Must be one of 60, 120, 300. */
  duration: Scalars['Int']['input']
  /** Hex-encoded 32-byte oracle feed id. */
  feedId: Scalars['String']['input']
  /** Stake as a u64 integer string (token base units). */
  minDeposit: Scalars['String']['input']
  /** Opponent user id. Must be an entry of findUpDownAiOpponents. */
  opponentId: Scalars['String']['input']
  /** Wallet the user plays with. Must be one of the wallets linked to the authenticated user. */
  walletAddress: Scalars['String']['input']
}

export type SignUpEmailAuthInput = {
  email: Scalars['String']['input']
  name?: InputMaybe<Scalars['String']['input']>
  password: Scalars['String']['input']
  referrerId?: InputMaybe<Scalars['String']['input']>
}

export type SmartContractEntity = {
  __typename?: 'SmartContractEntity'
  active: Scalars['Boolean']['output']
  chainIdentifier: Scalars['String']['output']
  chainType: Scalars['String']['output']
  contractAddress: Scalars['String']['output']
  contractName: Scalars['String']['output']
  meta?: Maybe<Meta>
  version: Scalars['Float']['output']
}

export type StopPredictAtInput = {
  equals?: InputMaybe<Scalars['Timestamp']['input']>
  gt?: InputMaybe<Scalars['Timestamp']['input']>
  gte?: InputMaybe<Scalars['Timestamp']['input']>
  lt?: InputMaybe<Scalars['Timestamp']['input']>
  lte?: InputMaybe<Scalars['Timestamp']['input']>
}

export type Subscription = {
  __typename?: 'Subscription'
  assetPriceChanged: AssetPrice
  bullseyeGameChanged: BullseyeGame
  /** Live Bullseye board signal for a period. Public over the guest WebSocket; no user session required. Payload is the period and bucket; the client refetches the board. */
  bullseyeLeaderboardChanged: BullseyeLeaderboardUpdate
  candleChanged: Candle
  /** Live updates of a demo Bullseye table: round opened, guess placed, round settled. Public channel. */
  demoBullseyeGameChanged: DemoBullseyeGame
  /** Live updates for the caller's own demo Human vs AI round. */
  demoUpDownAiGameChanged: DemoUpDownAiGame
  demoUpDownGameChanged: DemoUpDownGame
  liveWinsPredicts: Predict
  /** Live updates for the caller's own Bullseye rank and score. Requires a user session; a guest session is not enough. */
  myBullseyeLeaderboardPositionChanged: BullseyeLeaderboardPositionUpdate
  /** Live updates for the caller's own Up/Down AI rank and score. Requires a user session; a guest session is not enough. */
  myUpDownAiLeaderboardPositionChanged: UpDownAiLeaderboardPositionUpdate
  notifications: Notification
  notificationsList: Array<Notification>
  onSetupNumbersOfCreatedGamesChanged: SetupNumberOfCreatedGames
  onSetupNumbersOfJoinedGamesChanged: SetupNumbersOfJoinedGames
  onVolumeChanged: GameVolumeOfThePreviousDay
  oneVsOneCountGlobalGamesChanged: OneVsOneNumberOfGlobalGames
  oneVsOneCountUserGamesChanged: OneVsOneNumbersOfUserGames
  oneVsOneGameChanged: OneVsOneGame
  oneVsOneGameCreated: OneVsOneGame
  oneVsOneGamesChanged: OneVsOneGame
  online: Scalars['Float']['output']
  raceGameChanged: RaceGame
  rewardChanged: Reward
  roomMessages: Message
  setupGameChanged: SetupGame
  setupGameCreated: SetupGame
  setupGamesChanged: SetupGame
  upDownAiGameChanged: UpDownAiGame
  /** Live Up/Down AI board signal for a period. Public over the guest WebSocket; no user session required. Payload is the period and bucket; the client refetches the board. */
  upDownAiLeaderboardChanged: UpDownAiLeaderboardUpdate
  upDownGameChanged: UpDownGame
  userBlockchainBalanceChanged: UserBlockchainBalance
  userDailyTasksChanged: Array<ChallengeTask>
  userSeasonChanged: Season
  userSetupPredictsChanged: SetupPredict
}

export type SubscriptionAssetPriceChangedArgs = {
  assetId: Scalars['String']['input']
}

export type SubscriptionBullseyeGameChangedArgs = {
  modeId: Scalars['ID']['input']
}

export type SubscriptionBullseyeLeaderboardChangedArgs = {
  period: BullseyeLeaderboardPeriod
}

export type SubscriptionCandleChangedArgs = {
  assetId: Scalars['String']['input']
  timeframe: Scalars['Int']['input']
}

export type SubscriptionDemoBullseyeGameChangedArgs = {
  modeId: Scalars['ID']['input']
}

export type SubscriptionDemoUpDownGameChangedArgs = {
  channelId: Scalars['String']['input']
}

export type SubscriptionOnVolumeChangedArgs = {
  contractAddress: Scalars['String']['input']
}

export type SubscriptionOneVsOneGameChangedArgs = {
  gameId: Scalars['String']['input']
}

export type SubscriptionRaceGameChangedArgs = {
  contractAddress: Scalars['String']['input']
}

export type SubscriptionRoomMessagesArgs = {
  roomId: Scalars['String']['input']
}

export type SubscriptionSetupGameChangedArgs = {
  gameId: Scalars['String']['input']
}

export type SubscriptionUpDownAiLeaderboardChangedArgs = {
  period: UpDownAiLeaderboardPeriod
}

export type SubscriptionUpDownGameChangedArgs = {
  contractAddress: Scalars['String']['input']
}

export type TopUsersRewards = {
  __typename?: 'TopUsersRewards'
  myReward: Reward
  rewards: Array<Reward>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type TwitterAccount = {
  __typename?: 'TwitterAccount'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  profileImageUrl?: Maybe<Scalars['String']['output']>
  username?: Maybe<Scalars['String']['output']>
}

export type UpDownAiCurrentGamesInput = {
  contractAddress: Scalars['String']['input']
}

export type UpDownAiGame = {
  __typename?: 'UpDownAiGame'
  asset: Asset
  chainIdentifier?: Maybe<Scalars['String']['output']>
  chainType?: Maybe<Scalars['String']['output']>
  commission?: Maybe<Scalars['Float']['output']>
  contractAddress?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Timestamp']['output']
  deposit: Scalars['Float']['output']
  /** The round's difficulty: the opponent's Human vs AI catalogue entry. Null when it has none. */
  difficulty?: Maybe<BotDifficulty>
  endAt?: Maybe<Scalars['Timestamp']['output']>
  endPrice?: Maybe<Scalars['Float']['output']>
  feedId?: Maybe<Scalars['String']['output']>
  gameType: GameType
  id: Scalars['String']['output']
  isUp?: Maybe<Scalars['Boolean']['output']>
  opponent: User
  opponentId: Scalars['String']['output']
  opponentPredict?: Maybe<UpDownAiPredict>
  owner: User
  ownerId: Scalars['String']['output']
  ownerPredict?: Maybe<UpDownAiPredict>
  startAt?: Maybe<Scalars['Timestamp']['output']>
  startPrice?: Maybe<Scalars['Float']['output']>
  status: GameStatus
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>
  timeframe?: Maybe<Scalars['Int']['output']>
  token?: Maybe<Scalars['String']['output']>
  totalAmount?: Maybe<Scalars['Float']['output']>
  updatedAt: Scalars['Timestamp']['output']
}

export type UpDownAiGameAuthorization = {
  __typename?: 'UpDownAiGameAuthorization'
  /** Chainlink access controller for create_game (base58). */
  accessController: Scalars['String']['output']
  /** Chainlink Data Streams Verifier program for create_game (base58). */
  chainlinkVerifierProgram: Scalars['String']['output']
  /** Unix seconds. Must be passed unchanged into create_game — altering it invalidates the signature. */
  endTime: Scalars['Int']['output']
  /** Fee in basis points. Must be passed unchanged into create_game. */
  feeBps: Scalars['Int']['output']
  /** Hex-encoded 32-byte feed id. Must be passed unchanged into create_game. */
  feedId: Scalars['String']['output']
  /** Feed whitelist account of the oracle wrapper for create_game (base58). */
  feedWhitelist: Scalars['String']['output']
  /** Address lookup table (base58) to send create_game as a v0 transaction; required with a real Chainlink report. */
  lookupTable?: Maybe<Scalars['String']['output']>
  /** Base64 sha256(payload) digest (32 bytes). Pass unchanged to Ed25519Program — do not re-hash. */
  message: Scalars['String']['output']
  /** Stake as a u64 integer string. Must be passed unchanged into create_game. */
  minDeposit: Scalars['String']['output']
  /** Token mint. Must be passed unchanged into create_game. */
  mint: Scalars['String']['output']
  /** UUID v4. Convert to raw 16 bytes for create_game — do not regenerate client-side. */
  nonce: Scalars['String']['output']
  /** Opponent wallet. Must be passed unchanged into create_game as its `bot` account. */
  opponent: Scalars['String']['output']
  /** Base64 Ed25519 signature (64 bytes). Pass unchanged to Ed25519Program. */
  signature: Scalars['String']['output']
  /** Game master public key. Must equal on-chain config.game_master and be passed to Ed25519Program. */
  signer: Scalars['String']['output']
  /** Unix seconds. Must be passed unchanged into create_game — altering it invalidates the signature. */
  stopPredictAt: Scalars['Int']['output']
  /** Base64 oracle report that fixes the starting price; its sha256 is signed. Pass the decoded bytes unchanged as create_game unverified_report — do not build a report client-side. */
  unverifiedReport: Scalars['String']['output']
  /** Chainlink Verifier state account for create_game (base58). */
  verifierAccount: Scalars['String']['output']
  /** Report config account derived from unverifiedReport, for create_game (base58). */
  verifierConfig: Scalars['String']['output']
  /** Oracle wrapper program (config.verifier) for create_game (base58). */
  verifierProgram: Scalars['String']['output']
}

export type UpDownAiGameFilters = {
  contractAddress?: InputMaybe<Scalars['String']['input']>
  gameId?: InputMaybe<Array<Scalars['String']['input']>>
  status?: InputMaybe<Array<GameStatus>>
  stopPredictAt?: InputMaybe<StopPredictAtInput>
}

export type UpDownAiGames = {
  __typename?: 'UpDownAiGames'
  games: Array<UpDownAiGame>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type UpDownAiLeaderboard = {
  __typename?: 'UpDownAiLeaderboard'
  entries: Array<UpDownAiLeaderboardEntry>
  /** Exclusive UTC end of the period, used for a reset countdown. Null for all-time. */
  periodEnd?: Maybe<Scalars['Timestamp']['output']>
  /** Inclusive UTC start of the period. Null for all-time. */
  periodStart?: Maybe<Scalars['Timestamp']['output']>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type UpDownAiLeaderboardEntry = {
  __typename?: 'UpDownAiLeaderboardEntry'
  bestStreak: Scalars['Int']['output']
  currentStreak: Scalars['Int']['output']
  rank: Scalars['Int']['output']
  /** True signed period score. Negative values are valid. */
  score: Scalars['Int']['output']
  settledRounds: Scalars['Int']['output']
  user: User
  winRate: Scalars['Float']['output']
}

export type UpDownAiLeaderboardHistoryInput = {
  /** Closed bucket id: YYYY-MM-DD for daily, GGGG-Www for weekly. */
  bucket: Scalars['String']['input']
  pagination: PaginatedInput
  period: UpDownAiLeaderboardPeriod
}

export type UpDownAiLeaderboardInput = {
  pagination: PaginatedInput
  period: UpDownAiLeaderboardPeriod
}

/** Live Up/Down AI leaderboard period. History supports daily and weekly only. */
export enum UpDownAiLeaderboardPeriod {
  AllTime = 'ALL_TIME',
  Daily = 'DAILY',
  Weekly = 'WEEKLY'
}

export type UpDownAiLeaderboardPositionUpdate = {
  __typename?: 'UpDownAiLeaderboardPositionUpdate'
  bestStreak: Scalars['Int']['output']
  currentStreak: Scalars['Int']['output']
  period: UpDownAiLeaderboardPeriod
  rank: Scalars['Int']['output']
  /** previousRank - currentRank. Positive means the player moved up. */
  rankDelta: Scalars['Int']['output']
  /** True signed period score. Negative values are valid. */
  score: Scalars['Int']['output']
  settledRounds: Scalars['Int']['output']
  user: User
  winRate: Scalars['Float']['output']
}

export type UpDownAiLeaderboardUpdate = {
  __typename?: 'UpDownAiLeaderboardUpdate'
  /** Current bucket id. Null for all-time. */
  bucket?: Maybe<Scalars['String']['output']>
  period: UpDownAiLeaderboardPeriod
  /** True when the live bucket rolled over. Clients must refetch the current board. */
  periodChanged: Scalars['Boolean']['output']
}

export type UpDownAiOpponent = {
  __typename?: 'UpDownAiOpponent'
  difficulty: BotDifficulty
  user: User
}

export type UpDownAiPredict = {
  __typename?: 'UpDownAiPredict'
  amount: Scalars['Float']['output']
  createdAt: Scalars['Timestamp']['output']
  finalizeTxHash?: Maybe<Scalars['String']['output']>
  game: UpDownAiGame
  gameId: Scalars['String']['output']
  gameType: GameType
  id: Scalars['String']['output']
  index?: Maybe<Scalars['Int']['output']>
  isLong: Scalars['Boolean']['output']
  outcome?: Maybe<Scalars['Float']['output']>
  owner: User
  ownerId: Scalars['String']['output']
  playerAddress: Scalars['String']['output']
  pnl?: Maybe<Scalars['Float']['output']>
  status: PredictStatus
  updatedAt: Scalars['Timestamp']['output']
  winStreakLength: Scalars['Int']['output']
}

export type UpDownAiPredicts = {
  __typename?: 'UpDownAiPredicts'
  predicts: Array<UpDownAiPredict>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type UpDownContractAddressInput = {
  contractAddress: Scalars['String']['input']
}

export type UpDownGame = {
  __typename?: 'UpDownGame'
  chainIdentifier?: Maybe<Scalars['String']['output']>
  chainType?: Maybe<Scalars['String']['output']>
  commission?: Maybe<Scalars['Float']['output']>
  contractAddress?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Timestamp']['output']
  downPool: UpDownGamePoolInfo
  endAt?: Maybe<Scalars['Timestamp']['output']>
  endPrice?: Maybe<Scalars['Float']['output']>
  feedId?: Maybe<Scalars['String']['output']>
  gameType: GameType
  id: Scalars['String']['output']
  isUp?: Maybe<Scalars['Boolean']['output']>
  myPredict?: Maybe<UpDownPredict>
  startAt?: Maybe<Scalars['Timestamp']['output']>
  startPrice?: Maybe<Scalars['Float']['output']>
  status: GameStatus
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>
  timeframe?: Maybe<Scalars['Int']['output']>
  token?: Maybe<Scalars['String']['output']>
  totalAmount?: Maybe<Scalars['Float']['output']>
  upPool: UpDownGamePoolInfo
  updatedAt: Scalars['Timestamp']['output']
}

export type UpDownGamePoolInfo = {
  __typename?: 'UpDownGamePoolInfo'
  poolAmount: Scalars['Float']['output']
  predicts: Array<UpDownPredict>
  predictsCount: Scalars['Float']['output']
}

export type UpDownGameResultNotificationPayload = {
  __typename?: 'UpDownGameResultNotificationPayload'
  amount?: Maybe<Scalars['Float']['output']>
  gameType: GameType
  outcome?: Maybe<Scalars['Float']['output']>
  status: PredictStatus
}

export type UpDownGames = {
  __typename?: 'UpDownGames'
  games: Array<UpDownGame>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type UpDownPredict = {
  __typename?: 'UpDownPredict'
  amount: Scalars['Float']['output']
  createdAt: Scalars['Timestamp']['output']
  finalizeTxHash?: Maybe<Scalars['String']['output']>
  game?: Maybe<UpDownGame>
  gameId: Scalars['String']['output']
  gameType: GameType
  id: Scalars['String']['output']
  index?: Maybe<Scalars['Int']['output']>
  isLong: Scalars['Boolean']['output']
  outcome?: Maybe<Scalars['Float']['output']>
  owner?: Maybe<User>
  ownerId: Scalars['String']['output']
  playerAddress: Scalars['String']['output']
  pnl?: Maybe<Scalars['Float']['output']>
  status: PredictStatus
  updatedAt: Scalars['Timestamp']['output']
  winStreakLength: Scalars['Int']['output']
}

export type UpDownPredicts = {
  __typename?: 'UpDownPredicts'
  predicts: Array<UpDownPredict>
  skip: Scalars['Int']['output']
  take: Scalars['Int']['output']
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>
}

export type UpdateCashbackRequestInputType = {
  requestId: Scalars['String']['input']
  status: CashbackStatus
  txHash: Scalars['String']['input']
}

export type UpdateOffchainReferralSeasonInput = {
  endsAt?: InputMaybe<Scalars['Timestamp']['input']>
  startsAt?: InputMaybe<Scalars['Timestamp']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

export type UpdateReferralInput = {
  code: Scalars['String']['input']
}

export type UpdateUserInput = {
  bio?: InputMaybe<Scalars['String']['input']>
  birthday?: InputMaybe<Scalars['Timestamp']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type User = {
  __typename?: 'User'
  avatarKeys: Array<Scalars['String']['output']>
  avatarUris: Array<Scalars['String']['output']>
  bio: Scalars['String']['output']
  birthday?: Maybe<Scalars['Timestamp']['output']>
  createdAt: Scalars['Timestamp']['output']
  discord?: Maybe<UserDiscordAccount>
  discordRoles: Array<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  emailConfirmed?: Maybe<Scalars['Boolean']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  hasPassword?: Maybe<Scalars['Boolean']['output']>
  hasPlayed: Scalars['Boolean']['output']
  id: Scalars['String']['output']
  isBlocked?: Maybe<Scalars['Boolean']['output']>
  isInfluencer: Scalars['Boolean']['output']
  isOnline: Scalars['Boolean']['output']
  isTest?: Maybe<Scalars['Boolean']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  level?: Maybe<UserLevel>
  name: Scalars['String']['output']
  primaryWalletAddress?: Maybe<Scalars['String']['output']>
  /** @deprecated Not used */
  request?: Maybe<Array<Scalars['String']['output']>>
  role?: Maybe<UserRole>
  telegram?: Maybe<UserTelegramAccount>
  twitter?: Maybe<TwitterAccount>
  updatedAt: Scalars['Timestamp']['output']
  wallets: Array<UserWallet>
}

export type UserBlockchainBalance = {
  __typename?: 'UserBlockchainBalance'
  chainIdentifier: Scalars['String']['output']
  nativeBalance: Scalars['Float']['output']
  tokenBalance: Scalars['Float']['output']
  tokenDeposited: Scalars['Float']['output']
  walletAddress: Scalars['String']['output']
}

export type UserBullseyePredictsInput = {
  contractAddress: Scalars['String']['input']
  pagination: PaginatedInput
}

export type UserBullseyePredictsStatistic = {
  __typename?: 'UserBullseyePredictsStatistic'
  earned?: Maybe<Scalars['Float']['output']>
  totalGames: Scalars['Int']['output']
  totalWins: Scalars['Int']['output']
  winPercentage: Scalars['Float']['output']
}

export type UserChallengeTask = {
  __typename?: 'UserChallengeTask'
  id: Scalars['String']['output']
  isBonusReceived: Scalars['Boolean']['output']
  progress?: Maybe<Scalars['Float']['output']>
  status: UserChallengeTaskStatus
  taskId: Scalars['String']['output']
  userId: Scalars['String']['output']
}

/** The supported user challenges tasks. */
export enum UserChallengeTaskStatus {
  Claimed = 'CLAIMED',
  Completed = 'COMPLETED',
  NotCompleted = 'NOT_COMPLETED'
}

export type UserDemoBullseyePredictsInput = {
  modeId?: InputMaybe<Scalars['ID']['input']>
  pagination: PaginatedInput
}

export type UserDemoUpDownAiGamesInput = {
  channelId?: InputMaybe<Scalars['String']['input']>
  pagination: PaginatedInput
}

export type UserDemoUpDownPredictsInput = {
  channelId?: InputMaybe<Scalars['String']['input']>
  pagination: PaginatedInput
}

export type UserDiscordAccount = {
  __typename?: 'UserDiscordAccount'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  roles: Array<Scalars['String']['output']>
}

export type UserGamesStatistic = {
  __typename?: 'UserGamesStatistic'
  earned?: Maybe<Scalars['Float']['output']>
  largestWin?: Maybe<Predict>
  totalGames: Scalars['Int']['output']
  totalWins: Scalars['Int']['output']
  wagered?: Maybe<Scalars['Float']['output']>
  winPercentage: Scalars['Float']['output']
}

export type UserLevel = {
  __typename?: 'UserLevel'
  cashbackRequests?: Maybe<Array<CashbackRequest>>
  claimedOnLevel?: Maybe<Scalars['Int']['output']>
  commissionsPaid: Scalars['Float']['output']
  id: Scalars['String']['output']
  isCashBackReceived?: Maybe<Scalars['Boolean']['output']>
  level?: Maybe<Level>
  levelId?: Maybe<Scalars['Int']['output']>
  progressPercent?: Maybe<Scalars['Float']['output']>
  requestedOnCashBackValue?: Maybe<Scalars['Float']['output']>
  txHash?: Maybe<Scalars['String']['output']>
  user?: Maybe<User>
  userId: Scalars['String']['output']
}

export type UserOneVsOnePredictsStatistic = {
  __typename?: 'UserOneVsOnePredictsStatistic'
  earned?: Maybe<Scalars['Float']['output']>
  totalGames: Scalars['Int']['output']
  totalWins: Scalars['Int']['output']
  winPercentage: Scalars['Float']['output']
}

export type UserRacePredictsInput = {
  contractAddress: Scalars['String']['input']
  pagination: PaginatedInput
}

export type UserRacePredictsStatistic = {
  __typename?: 'UserRacePredictsStatistic'
  earned?: Maybe<Scalars['Float']['output']>
  totalGames: Scalars['Int']['output']
  totalWins: Scalars['Int']['output']
  winPercentage: Scalars['Float']['output']
}

/** The supported users roles. */
export enum UserRole {
  Admin = 'ADMIN',
  User = 'USER',
  WithdrawalOperator = 'WITHDRAWAL_OPERATOR'
}

export type UserSetupGamesStatistic = {
  __typename?: 'UserSetupGamesStatistic'
  earned?: Maybe<Scalars['Float']['output']>
  totalGames: Scalars['Int']['output']
  totalPlayersOnGames: Scalars['Int']['output']
  totalRejectedGames: Scalars['Int']['output']
  totalRejectedGamesPercentage?: Maybe<Scalars['Float']['output']>
  totalStopLossClosedGames: Scalars['Int']['output']
  totalStopLossClosedGamesPercentage?: Maybe<Scalars['Float']['output']>
  totalTakeProfitClosedGames: Scalars['Int']['output']
  totalTakeProfitClosedGamesPercentage?: Maybe<Scalars['Float']['output']>
}

export type UserSetupPredictsStatistic = {
  __typename?: 'UserSetupPredictsStatistic'
  earned?: Maybe<Scalars['Float']['output']>
  totalGames: Scalars['Int']['output']
  totalWins: Scalars['Int']['output']
  winPercentage: Scalars['Float']['output']
}

export type UserStats = {
  __typename?: 'UserStats'
  bonusVolume: Scalars['Float']['output']
  games: Scalars['Float']['output']
  maxWin: Scalars['Float']['output']
  realVolume: Scalars['Float']['output']
  wins: Scalars['Float']['output']
}

export type UserTelegramAccount = {
  __typename?: 'UserTelegramAccount'
  firstName: Scalars['String']['output']
  lastName?: Maybe<Scalars['String']['output']>
  telegramId: Scalars['Float']['output']
  username: Scalars['String']['output']
}

export type UserUpDownAiPredictsInput = {
  contractAddress: Scalars['String']['input']
  pagination: PaginatedInput
}

export type UserUpDownAiPredictsStatistic = {
  __typename?: 'UserUpDownAiPredictsStatistic'
  earned?: Maybe<Scalars['Float']['output']>
  totalGames: Scalars['Int']['output']
  totalWins: Scalars['Int']['output']
  winPercentage: Scalars['Float']['output']
}

export type UserUpDownPredictsInput = {
  contractAddress: Scalars['String']['input']
  pagination: PaginatedInput
}

export type UserUpDownPredictsStatistic = {
  __typename?: 'UserUpDownPredictsStatistic'
  earned?: Maybe<Scalars['Float']['output']>
  totalGames: Scalars['Int']['output']
  totalWins: Scalars['Int']['output']
  winPercentage: Scalars['Float']['output']
}

export type UserWallet = {
  __typename?: 'UserWallet'
  address: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  isPrimary: Scalars['Boolean']['output']
}

export type VerifyWalletSignatureInput = {
  referrerId?: InputMaybe<Scalars['String']['input']>
  signature: Scalars['String']['input']
  username?: InputMaybe<Scalars['String']['input']>
  walletAddress: Scalars['String']['input']
}

export type WalletChallenge = {
  __typename?: 'WalletChallenge'
  challenge: Scalars['String']['output']
}

export type WalletLinkChallenge = {
  __typename?: 'WalletLinkChallenge'
  challenge: Scalars['String']['output']
}

export type AssetPayloadQueryVariables = Exact<{
  data: AssetPricesInput
}>

export type AssetPayloadQuery = {
  __typename?: 'Query'
  assetPrices: Array<{ __typename?: 'AssetPrice'; payload: string }>
}

export type TouchAttributionMutationVariables = Exact<{
  data: Scalars['JSON']['input']
}>

export type TouchAttributionMutation = {
  __typename?: 'Mutation'
  touchAttribution: boolean
}

export type CheckReferralAvailabilityQueryVariables = Exact<{
  data: CheckReferralAvalabilityInput
}>

export type CheckReferralAvailabilityQuery = {
  __typename?: 'Query'
  checkReferralAvalability: {
    __typename?: 'Referral'
    active: boolean
    user?: { __typename?: 'User'; id: string } | null
  }
}

export type CheckNameAvailabilityQueryVariables = Exact<{
  data: CheckNameAvailabilityInput
}>

export type CheckNameAvailabilityQuery = {
  __typename?: 'Query'
  checkNameAvailability: boolean
}

export type MeSocialFragment = {
  __typename: 'User'
  id: string
  name: string
  bio: string
  avatarKeys: Array<string>
  discordRoles: Array<string>
  avatarUris: Array<string>
  isInfluencer: boolean
  primaryWalletAddress?: string | null
  wallets: Array<{
    __typename?: 'UserWallet'
    id: string
    address: string
    isPrimary: boolean
    createdAt: string
  }>
  discord?: {
    __typename?: 'UserDiscordAccount'
    id: string
    name: string
    roles: Array<string>
  } | null
  twitter?: {
    __typename?: 'TwitterAccount'
    id: string
    name?: string | null
  } | null
} & { ' $fragmentName'?: 'MeSocialFragment' }

export type MeFragment = {
  __typename: 'User'
  id: string
  name: string
  bio: string
  role?: UserRole | null
  createdAt: number
  avatarKeys: Array<string>
  discordRoles: Array<string>
  avatarUris: Array<string>
  isInfluencer: boolean
  primaryWalletAddress?: string | null
  hasPlayed: boolean
  level?: {
    __typename?: 'UserLevel'
    levelId?: number | null
    level?: { __typename?: 'Level'; name: string } | null
  } | null
  wallets: Array<{
    __typename?: 'UserWallet'
    id: string
    address: string
    isPrimary: boolean
    createdAt: string
  }>
} & { ' $fragmentName'?: 'MeFragment' }

export type GetReferralQueryVariables = Exact<{ [key: string]: never }>

export type GetReferralQuery = {
  __typename?: 'Query'
  getReferral: { __typename?: 'Referral'; code: string }
}

export type SignoutMutationVariables = Exact<{ [key: string]: never }>

export type SignoutMutation = {
  __typename?: 'Mutation'
  signout?: string | null
}

export type MeSocialQueryVariables = Exact<{ [key: string]: never }>

export type MeSocialQuery = {
  __typename?: 'Query'
  me: { __typename?: 'User' } & {
    ' $fragmentRefs'?: { MeSocialFragment: MeSocialFragment }
  }
}

export type MeQueryVariables = Exact<{ [key: string]: never }>

export type MeQuery = {
  __typename?: 'Query'
  me: { __typename?: 'User' } & {
    ' $fragmentRefs'?: { MeFragment: MeFragment }
  }
}

export type SignInPrivyMutationVariables = Exact<{
  data: SignInPrivyInput
}>

export type SignInPrivyMutation = {
  __typename?: 'Mutation'
  signInPrivy: string
}

export type GetRakebackSummaryStubQueryVariables = Exact<{
  [key: string]: never
}>

export type GetRakebackSummaryStubQuery = { __typename: 'Query' }

export type GetUserBlockchainBalancesQueryVariables = Exact<{
  [key: string]: never
}>

export type GetUserBlockchainBalancesQuery = {
  __typename?: 'Query'
  getUserBlockchainBalances: Array<{
    __typename?: 'UserBlockchainBalance'
    walletAddress: string
    nativeBalance: number
    tokenBalance: number
    tokenDeposited: number
    chainIdentifier: string
  }>
}

export type GetUserPendingRakebackGamesStubQueryVariables = Exact<{
  [key: string]: never
}>

export type GetUserPendingRakebackGamesStubQuery = { __typename: 'Query' }

export type GetUserPendingSetupGamesStubQueryVariables = Exact<{
  [key: string]: never
}>

export type GetUserPendingSetupGamesStubQuery = { __typename: 'Query' }

export type ForceUpdateUserBlockchainBalanceMutationVariables = Exact<{
  walletAddress: Scalars['String']['input']
}>

export type ForceUpdateUserBlockchainBalanceMutation = {
  __typename?: 'Mutation'
  forceUpdateUserBlockchainBalance: {
    __typename?: 'UserBlockchainBalance'
    walletAddress: string
    nativeBalance: number
    tokenBalance: number
    tokenDeposited: number
    chainIdentifier: string
  }
}

export type UserBlockchainBalanceChangedSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type UserBlockchainBalanceChangedSubscription = {
  __typename?: 'Subscription'
  userBlockchainBalanceChanged: {
    __typename?: 'UserBlockchainBalance'
    walletAddress: string
    nativeBalance: number
    tokenBalance: number
    tokenDeposited: number
    chainIdentifier: string
  }
}

export type GetCurrentOnlineQueryVariables = Exact<{ [key: string]: never }>

export type GetCurrentOnlineQuery = {
  __typename?: 'Query'
  getCurrentOnline: number
}

export type GetRoomByTypeQueryVariables = Exact<{
  data: GetRoom
}>

export type GetRoomByTypeQuery = {
  __typename?: 'Query'
  getRoomByType: { __typename?: 'Room'; id: string }
}

export type GetRoomMessagesPaginatedQueryVariables = Exact<{
  data: GetRoomMessages
}>

export type GetRoomMessagesPaginatedQuery = {
  __typename?: 'Query'
  getRoomMessagesPaginated: {
    __typename?: 'Messages'
    prevToken?: string | null
    nextToken?: string | null
    messages: Array<{
      __typename?: 'Message'
      id: string
      text: string
      roomId: string
      createdAt: number
      sender?: {
        __typename?: 'User'
        id: string
        name: string
        avatarUris: Array<string>
        avatarKeys: Array<string>
        discordRoles: Array<string>
        level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
      } | null
      replyTo?: { __typename?: 'Message'; id: string } | null
    }>
  }
}

export type SendMessageMutationVariables = Exact<{
  data: SendMessageInput
}>

export type SendMessageMutation = {
  __typename?: 'Mutation'
  sendMessage: {
    __typename?: 'Message'
    id: string
    text: string
    roomId: string
    createdAt: number
    sender?: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      avatarKeys: Array<string>
      discordRoles: Array<string>
    } | null
    replyTo?: { __typename?: 'Message'; id: string } | null
  }
}

export type OnlineSubscriptionVariables = Exact<{ [key: string]: never }>

export type OnlineSubscription = { __typename?: 'Subscription'; online: number }

export type RoomMessagesSubscriptionVariables = Exact<{
  roomId: Scalars['String']['input']
}>

export type RoomMessagesSubscription = {
  __typename?: 'Subscription'
  roomMessages: {
    __typename?: 'Message'
    id: string
    text: string
    roomId: string
    createdAt: number
    sender?: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      avatarKeys: Array<string>
      discordRoles: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    } | null
    replyTo?: { __typename?: 'Message'; id: string } | null
  }
}

export type SetConsentMutationVariables = Exact<{
  data: ConsentInput
}>

export type SetConsentMutation = {
  __typename?: 'Mutation'
  setConsent: boolean
}

export type FragmentBetShallowStubQueryVariables = Exact<{
  [key: string]: never
}>

export type FragmentBetShallowStubQuery = { __typename: 'Query' }

export type GetNotificationsQueryVariables = Exact<{
  data: PaginatedInput
}>

export type GetNotificationsQuery = {
  __typename?: 'Query'
  getNotifications: {
    __typename?: 'NotificationsPaginated'
    skip: number
    take: number
    notifications: Array<
      | {
          __typename: 'BonusNotification'
          id: string
          userId: string
          type: NotificationType
          isRead: boolean
          createdAt: number
          title: string
          description?: string | null
          amount: number
          assetId: string
        }
      | {
          __typename: 'GameResultNotification'
          createdAt: number
          id: string
          isRead: boolean
          type: NotificationType
          userId: string
          payload:
            | {
                __typename: 'BullseyeGameResultNotificationPayload'
                amount?: number | null
                gameType: GameType
                isExact?: boolean | null
                outcome?: number | null
                status: PredictStatus
                winnerOutcome?: number | null
                winner?: { __typename?: 'User'; id: string } | null
              }
            | {
                __typename: 'OneVsOneGameResultNotificationPayload'
                amount?: number | null
                gameType: GameType
                outcome?: number | null
                status: PredictStatus
                opponent?: { __typename?: 'User'; id: string } | null
              }
            | {
                __typename: 'SetupGameResultNotificationPayload'
                amount?: number | null
                gameType: GameType
                outcome?: number | null
                status: PredictStatus
              }
            | {
                __typename: 'UpDownGameResultNotificationPayload'
                amount?: number | null
                gameType: GameType
                outcome?: number | null
                status: PredictStatus
              }
        }
      | {
          __typename: 'HotNotification'
          createdAt: number
          id: string
          isRead: boolean
          type: NotificationType
          updatedAt: number
          userId: string
        }
      | {
          __typename: 'MentionNotification'
          createdAt: number
          id: string
          isRead: boolean
          messageId: string
          type: NotificationType
          userId: string
        }
      | {
          __typename: 'OneVsOneAcceptedNotification'
          id: string
          userId: string
          type: NotificationType
          isRead: boolean
          createdAt: number
          payload: {
            __typename?: 'OneVsOneAcceptedNotificationPayload'
            gameId: string
            opponentId: string
          }
        }
      | {
          __typename: 'OneVsOneInvitationNotification'
          id: string
          userId: string
          type: NotificationType
          isRead: boolean
          createdAt: number
          payload: {
            __typename?: 'OneVsOneInvitationNotificationPayload'
            gameId: string
            opponentId: string
          }
        }
      | {
          __typename: 'OneVsOneRefusedNotification'
          id: string
          userId: string
          type: NotificationType
          isRead: boolean
          createdAt: number
          payload: {
            __typename?: 'OneVsOneRefusedNotificationPayload'
            gameId: string
            opponentId: string
          }
        }
      | {
          __typename: 'SetupGameClosedNotification'
          id: string
          userId: string
          type: NotificationType
          isRead: boolean
          createdAt: number
          payload: {
            __typename?: 'SetupGameClosedNotificationPayload'
            gameId: string
            ownerProfit: number
          }
        }
    >
  }
}

export type GetVolumeOfThePreviousDayQueryVariables = Exact<{
  contractAddress: Scalars['String']['input']
}>

export type GetVolumeOfThePreviousDayQuery = {
  __typename?: 'Query'
  getVolumeOfThePreviousDay: { __typename?: 'GameVolume'; volume: number }
}

export type GetSmartContractsQueryVariables = Exact<{ [key: string]: never }>

export type GetSmartContractsQuery = {
  __typename?: 'Query'
  getSmartContracts: Array<{
    __typename?: 'ContractEntry'
    contractName: string
    contracts: Array<{
      __typename?: 'SmartContractEntity'
      active: boolean
      chainIdentifier: string
      chainType: string
      contractAddress: string
      contractName: string
      version: number
      meta?: {
        __typename?: 'Meta'
        amount?: number | null
        fee?: number | null
        ownerFee?: number | null
        token?: string | null
        asset?: string | null
        isMultiParticipation?: boolean | null
      } | null
    }>
  }>
}

export type GetUnreadNotificationsCountQueryVariables = Exact<{
  [key: string]: never
}>

export type GetUnreadNotificationsCountQuery = {
  __typename?: 'Query'
  getUnreadNotificationsCount: number
}

export type MarkNotificationsReadMutationVariables = Exact<{
  data: MarkNotificationsAsReadInput
}>

export type MarkNotificationsReadMutation = {
  __typename?: 'Mutation'
  markNotificationsRead?: any | null
}

export type OnVolumeChangedSubscriptionVariables = Exact<{
  contractAddress: Scalars['String']['input']
}>

export type OnVolumeChangedSubscription = {
  __typename?: 'Subscription'
  onVolumeChanged: { __typename?: 'GameVolumeOfThePreviousDay'; volume: number }
}

export type NotificationsListSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type NotificationsListSubscription = {
  __typename?: 'Subscription'
  notificationsList: Array<
    | {
        __typename: 'BonusNotification'
        id: string
        userId: string
        type: NotificationType
        isRead: boolean
        createdAt: number
        title: string
        description?: string | null
        amount: number
        assetId: string
      }
    | {
        __typename: 'GameResultNotification'
        createdAt: number
        id: string
        isRead: boolean
        type: NotificationType
        userId: string
        payload:
          | {
              __typename: 'BullseyeGameResultNotificationPayload'
              amount?: number | null
              gameType: GameType
              isExact?: boolean | null
              outcome?: number | null
              status: PredictStatus
              winnerOutcome?: number | null
              winner?: {
                __typename?: 'User'
                id: string
                avatarKeys: Array<string>
              } | null
            }
          | {
              __typename: 'OneVsOneGameResultNotificationPayload'
              amount?: number | null
              gameType: GameType
              outcome?: number | null
              status: PredictStatus
              opponent?: {
                __typename?: 'User'
                id: string
                avatarKeys: Array<string>
              } | null
            }
          | {
              __typename: 'SetupGameResultNotificationPayload'
              amount?: number | null
              gameType: GameType
              outcome?: number | null
              status: PredictStatus
            }
          | {
              __typename: 'UpDownGameResultNotificationPayload'
              amount?: number | null
              gameType: GameType
              outcome?: number | null
              status: PredictStatus
            }
      }
    | {
        __typename: 'HotNotification'
        createdAt: number
        id: string
        isRead: boolean
        type: NotificationType
        updatedAt: number
        userId: string
      }
    | {
        __typename: 'MentionNotification'
        createdAt: number
        id: string
        isRead: boolean
        messageId: string
        type: NotificationType
        userId: string
      }
    | {
        __typename: 'OneVsOneAcceptedNotification'
        id: string
        userId: string
        type: NotificationType
        isRead: boolean
        createdAt: number
        payload: {
          __typename?: 'OneVsOneAcceptedNotificationPayload'
          gameId: string
          opponentId: string
        }
      }
    | {
        __typename: 'OneVsOneInvitationNotification'
        id: string
        userId: string
        type: NotificationType
        isRead: boolean
        createdAt: number
        payload: {
          __typename?: 'OneVsOneInvitationNotificationPayload'
          gameId: string
          opponentId: string
        }
      }
    | {
        __typename: 'OneVsOneRefusedNotification'
        id: string
        userId: string
        type: NotificationType
        isRead: boolean
        createdAt: number
        payload: {
          __typename?: 'OneVsOneRefusedNotificationPayload'
          gameId: string
          opponentId: string
        }
      }
    | {
        __typename: 'SetupGameClosedNotification'
        id: string
        userId: string
        type: NotificationType
        isRead: boolean
        createdAt: number
        payload: {
          __typename?: 'SetupGameClosedNotificationPayload'
          gameId: string
          ownerProfit: number
        }
      }
  >
}

export type NotificationsSubscriptionVariables = Exact<{ [key: string]: never }>

export type NotificationsSubscription = {
  __typename?: 'Subscription'
  notifications:
    | {
        __typename: 'BonusNotification'
        id: string
        userId: string
        type: NotificationType
        isRead: boolean
        createdAt: number
        title: string
        description?: string | null
        amount: number
        assetId: string
      }
    | {
        __typename: 'GameResultNotification'
        createdAt: number
        id: string
        isRead: boolean
        type: NotificationType
        userId: string
        payload:
          | {
              __typename: 'BullseyeGameResultNotificationPayload'
              amount?: number | null
              gameType: GameType
              isExact?: boolean | null
              outcome?: number | null
              status: PredictStatus
              winnerOutcome?: number | null
              winner?: {
                __typename?: 'User'
                id: string
                avatarKeys: Array<string>
              } | null
            }
          | {
              __typename: 'OneVsOneGameResultNotificationPayload'
              amount?: number | null
              gameType: GameType
              outcome?: number | null
              status: PredictStatus
              opponent?: {
                __typename?: 'User'
                id: string
                avatarKeys: Array<string>
              } | null
            }
          | {
              __typename: 'SetupGameResultNotificationPayload'
              amount?: number | null
              gameType: GameType
              outcome?: number | null
              status: PredictStatus
            }
          | {
              __typename: 'UpDownGameResultNotificationPayload'
              amount?: number | null
              gameType: GameType
              outcome?: number | null
              status: PredictStatus
            }
      }
    | {
        __typename: 'HotNotification'
        createdAt: number
        id: string
        isRead: boolean
        type: NotificationType
        updatedAt: number
        userId: string
      }
    | {
        __typename: 'MentionNotification'
        createdAt: number
        id: string
        isRead: boolean
        messageId: string
        type: NotificationType
        userId: string
      }
    | {
        __typename: 'OneVsOneAcceptedNotification'
        id: string
        userId: string
        type: NotificationType
        isRead: boolean
        createdAt: number
        payload: {
          __typename?: 'OneVsOneAcceptedNotificationPayload'
          gameId: string
          opponentId: string
        }
      }
    | {
        __typename: 'OneVsOneInvitationNotification'
        id: string
        userId: string
        type: NotificationType
        isRead: boolean
        createdAt: number
        payload: {
          __typename?: 'OneVsOneInvitationNotificationPayload'
          gameId: string
          opponentId: string
        }
      }
    | {
        __typename: 'OneVsOneRefusedNotification'
        id: string
        userId: string
        type: NotificationType
        isRead: boolean
        createdAt: number
        payload: {
          __typename?: 'OneVsOneRefusedNotificationPayload'
          gameId: string
          opponentId: string
        }
      }
    | {
        __typename: 'SetupGameClosedNotification'
        id: string
        userId: string
        type: NotificationType
        isRead: boolean
        createdAt: number
        payload: {
          __typename?: 'SetupGameClosedNotificationPayload'
          gameId: string
          ownerProfit: number
        }
      }
}

export type CreateGuestSessionMutationVariables = Exact<{
  data?: InputMaybe<CreateGuestSessionInput>
}>

export type CreateGuestSessionMutation = {
  __typename?: 'Mutation'
  createGuestSession: {
    __typename?: 'GuestSession'
    id: string
    userId?: string | null
    claimedAt?: number | null
    expiresAt?: number | null
  }
}

export type GetGuestSessionQueryVariables = Exact<{ [key: string]: never }>

export type GetGuestSessionQuery = {
  __typename?: 'Query'
  getGuestSession?: {
    __typename?: 'GuestSession'
    id: string
    userId?: string | null
    claimedAt?: number | null
    expiresAt?: number | null
  } | null
}

export type MergeGuestSessionMutationVariables = Exact<{ [key: string]: never }>

export type MergeGuestSessionMutation = {
  __typename?: 'Mutation'
  mergeGuestSession: {
    __typename?: 'MergeGuestSessionResult'
    alreadyClaimed: boolean
    roundsMigrated: number
    wins: number
    upDown: {
      __typename?: 'MergeGuestSessionModeResult'
      roundsMigrated: number
      wins: number
      scoreMigrated: number
      rankDaily?: number | null
      rankWeekly?: number | null
      rankAlltime?: number | null
    }
    upDownAi: {
      __typename?: 'MergeGuestSessionModeResult'
      roundsMigrated: number
      wins: number
      scoreMigrated: number
      rankDaily?: number | null
      rankWeekly?: number | null
      rankAlltime?: number | null
    }
    bullseye: {
      __typename?: 'MergeGuestSessionBullseyeResult'
      roundsMigrated: number
      wins: number
      scoreMigrated: number
      settledRounds: number
      exactHits: number
      avgErrorPct?: number | null
      rankDaily?: number | null
      rankWeekly?: number | null
      rankAlltime?: number | null
    }
  }
}

export type GetLiveWinsPredictsQueryVariables = Exact<{ [key: string]: never }>

export type GetLiveWinsPredictsQuery = {
  __typename?: 'Query'
  getLiveWinsPredicts: {
    __typename?: 'Predicts'
    skip: number
    take: number
    predicts: Array<{
      __typename?: 'Predict'
      id: string
      gameId: string
      gameType: GameType
      ownerId: string
      status: PredictStatus
      amount: number
      createdAt: number
      outcome?: number | null
      pnl?: number | null
      updatedAt: number
      game: { __typename?: 'Game'; contractAddress?: string | null }
      owner: {
        __typename?: 'User'
        id: string
        name: string
        avatarUris: Array<string>
        level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
      }
    }>
  }
}

export type LiveWinsPredictsSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type LiveWinsPredictsSubscription = {
  __typename?: 'Subscription'
  liveWinsPredicts: {
    __typename?: 'Predict'
    id: string
    gameId: string
    gameType: GameType
    ownerId: string
    status: PredictStatus
    amount: number
    createdAt: number
    outcome?: number | null
    pnl?: number | null
    updatedAt: number
    owner: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
    }
  }
}

export type ListAssetsQueryVariables = Exact<{ [key: string]: never }>

export type ListAssetsQuery = {
  __typename?: 'Query'
  listAssets: Array<{
    __typename?: 'Asset'
    id: string
    name: string
    precision: number
    feedId: string
    feedNumber: number
    supportedResolutions: Array<number>
    price: {
      __typename?: 'AssetPrice'
      formattedValue: number
      payload: string
    }
    last7days: Array<{
      __typename?: 'AssetPrice'
      formattedValue: number
      timestamp: number
    }>
    price24h: {
      __typename?: 'AssetPrice'
      formattedValue: number
      timestamp: number
    }
  }>
}

export type GetCurrentRaceGameQueryVariables = Exact<{
  data: RaceContractAddressInput
}>

export type GetCurrentRaceGameQuery = {
  __typename?: 'Query'
  getCurrentRaceGame: {
    __typename?: 'RaceGame'
    id: string
    gameType: GameType
    feedId?: string | null
    startAt?: number | null
    stopPredictAt?: number | null
    endAt?: number | null
    startPrice?: number | null
    endPrice?: number | null
    timeframe?: number | null
    status: GameStatus
    commission?: number | null
    totalAmount?: number | null
    contractAddress?: string | null
    token?: string | null
    createdAt: number
    updatedAt: number
    feedsIds: Array<string>
    startPrices: Array<number>
    endPrices: Array<number>
    startTimestamps: Array<number>
    endTimestamps: Array<number>
    priceDiffs: Array<number>
    wonFeedId?: string | null
    myPredicts: Array<{
      __typename?: 'RacePredict'
      id: string
      gameId: string
      gameType: GameType
      ownerId: string
      status: PredictStatus
      amount: number
      createdAt: number
      outcome?: number | null
      pnl?: number | null
      finalizeTxHash?: string | null
      updatedAt: number
      feedId: string
      owner?: {
        __typename: 'User'
        id: string
        name: string
        bio: string
        role?: UserRole | null
        createdAt: number
        avatarKeys: Array<string>
        discordRoles: Array<string>
        avatarUris: Array<string>
        isInfluencer: boolean
        level?: {
          __typename?: 'UserLevel'
          levelId?: number | null
          level?: { __typename?: 'Level'; name: string } | null
        } | null
      } | null
    }>
    predicts: Array<{
      __typename?: 'RacePredict'
      id: string
      gameId: string
      gameType: GameType
      ownerId: string
      status: PredictStatus
      amount: number
      createdAt: number
      outcome?: number | null
      pnl?: number | null
      finalizeTxHash?: string | null
      updatedAt: number
      feedId: string
      owner?: {
        __typename: 'User'
        id: string
        name: string
        bio: string
        role?: UserRole | null
        createdAt: number
        avatarKeys: Array<string>
        discordRoles: Array<string>
        avatarUris: Array<string>
        isInfluencer: boolean
        level?: {
          __typename?: 'UserLevel'
          levelId?: number | null
          level?: { __typename?: 'Level'; name: string } | null
        } | null
      } | null
    }>
    pool: {
      __typename?: 'RaceGamePoolInfo'
      predictsCount: number
      poolAmount: number
    }
  }
}

export type GetUserRaceGamesQueryVariables = Exact<{
  data: UserRacePredictsInput
}>

export type GetUserRaceGamesQuery = {
  __typename?: 'Query'
  getUserRaceGames: {
    __typename?: 'RaceGames'
    skip: number
    take: number
    total?: number | null
    games: Array<{
      __typename?: 'RaceGame'
      id: string
      gameType: GameType
      feedId?: string | null
      startAt?: number | null
      stopPredictAt?: number | null
      endAt?: number | null
      startPrice?: number | null
      endPrice?: number | null
      timeframe?: number | null
      status: GameStatus
      commission?: number | null
      totalAmount?: number | null
      contractAddress?: string | null
      token?: string | null
      createdAt: number
      updatedAt: number
      feedsIds: Array<string>
      startPrices: Array<number>
      endPrices: Array<number>
      startTimestamps: Array<number>
      endTimestamps: Array<number>
      priceDiffs: Array<number>
      wonFeedId?: string | null
      myPredicts: Array<{
        __typename?: 'RacePredict'
        id: string
        gameId: string
        gameType: GameType
        ownerId: string
        playerAddress: string
        status: PredictStatus
        amount: number
        createdAt: number
        outcome?: number | null
        pnl?: number | null
        finalizeTxHash?: string | null
        updatedAt: number
        index: number
        feedId: string
      }>
    }>
  }
}

export type RaceGameChangedSubscriptionVariables = Exact<{
  contractAddress: Scalars['String']['input']
}>

export type RaceGameChangedSubscription = {
  __typename?: 'Subscription'
  raceGameChanged: {
    __typename?: 'RaceGame'
    id: string
    gameType: GameType
    feedId?: string | null
    startAt?: number | null
    stopPredictAt?: number | null
    endAt?: number | null
    startPrice?: number | null
    endPrice?: number | null
    timeframe?: number | null
    status: GameStatus
    commission?: number | null
    totalAmount?: number | null
    contractAddress?: string | null
    token?: string | null
    createdAt: number
    updatedAt: number
    feedsIds: Array<string>
    startPrices: Array<number>
    endPrices: Array<number>
    startTimestamps: Array<number>
    endTimestamps: Array<number>
    priceDiffs: Array<number>
    wonFeedId?: string | null
    myPredicts: Array<{
      __typename?: 'RacePredict'
      id: string
      gameId: string
      gameType: GameType
      ownerId: string
      status: PredictStatus
      amount: number
      createdAt: number
      outcome?: number | null
      pnl?: number | null
      finalizeTxHash?: string | null
      updatedAt: number
      feedId: string
      owner?: {
        __typename: 'User'
        id: string
        name: string
        bio: string
        role?: UserRole | null
        createdAt: number
        avatarKeys: Array<string>
        discordRoles: Array<string>
        avatarUris: Array<string>
        isInfluencer: boolean
        level?: {
          __typename?: 'UserLevel'
          levelId?: number | null
          level?: { __typename?: 'Level'; name: string } | null
        } | null
      } | null
    }>
    predicts: Array<{
      __typename?: 'RacePredict'
      id: string
      gameId: string
      gameType: GameType
      ownerId: string
      status: PredictStatus
      amount: number
      createdAt: number
      outcome?: number | null
      pnl?: number | null
      finalizeTxHash?: string | null
      updatedAt: number
      feedId: string
      owner?: {
        __typename: 'User'
        id: string
        name: string
        bio: string
        role?: UserRole | null
        createdAt: number
        avatarKeys: Array<string>
        discordRoles: Array<string>
        avatarUris: Array<string>
        isInfluencer: boolean
        level?: {
          __typename?: 'UserLevel'
          levelId?: number | null
          level?: { __typename?: 'Level'; name: string } | null
        } | null
      } | null
    }>
    pool: {
      __typename?: 'RaceGamePoolInfo'
      predictsCount: number
      poolAmount: number
    }
  }
}

export type AddOneVsOneBetStubQueryVariables = Exact<{ [key: string]: never }>

export type AddOneVsOneBetStubQuery = { __typename: 'Query' }

export type CreateOneVsOneGameStubQueryVariables = Exact<{
  [key: string]: never
}>

export type CreateOneVsOneGameStubQuery = { __typename: 'Query' }

export type FindOpponentsQueryVariables = Exact<{
  data: FindUsersInput
}>

export type FindOpponentsQuery = {
  __typename?: 'Query'
  findOpponents: Array<{
    __typename?: 'User'
    name: string
    id: string
    avatarUris: Array<string>
    primaryWalletAddress?: string | null
    level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
  }>
}

export type GetOneVsOneGamesCountStubQueryVariables = Exact<{
  [key: string]: never
}>

export type GetOneVsOneGamesCountStubQuery = { __typename: 'Query' }

export type GetOneVsOneGameQueryVariables = Exact<{
  getOneVsOneGame: Scalars['String']['input']
}>

export type GetOneVsOneGameQuery = {
  __typename?: 'Query'
  getOneVsOneGame: {
    __typename?: 'OneVsOneGame'
    isAccepted: boolean
    gameType: GameType
    feedId?: string | null
    endPrice?: number | null
    endAt?: number | null
    id: string
    isPrivate: boolean
    contractAddress?: string | null
    token?: string | null
    stopPredictAt?: number | null
    ownerId: string
    startPrice?: number | null
    status: GameStatus
    asset: { __typename?: 'Asset'; id: string; name: string; precision: number }
    opponentPredict?: {
      __typename?: 'OneVsOnePredict'
      ownerId: string
      amount: number
      gameId: string
      gameType: GameType
      id: string
      price: number
      status: PredictStatus
      pnl?: number | null
    } | null
    owner: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    }
    opponent?: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    } | null
    ownerPredict: {
      __typename?: 'OneVsOnePredict'
      ownerId: string
      amount: number
      gameId: string
      gameType: GameType
      id: string
      price: number
      status: PredictStatus
      pnl?: number | null
    }
  }
}

export type GetOneVsOneGamesQueryVariables = Exact<{
  filters: OneVsOneGameFilters
  pagination: PaginatedInput
}>

export type GetOneVsOneGamesQuery = {
  __typename?: 'Query'
  getOneVsOneGames: {
    __typename?: 'OneVsOneGames'
    skip: number
    take: number
    total?: number | null
    games: Array<{
      __typename?: 'OneVsOneGame'
      feedId?: string | null
      gameType: GameType
      id: string
      isPrivate: boolean
      isAccepted: boolean
      endAt?: number | null
      startPrice?: number | null
      timeframe?: number | null
      ownerId: string
      stopPredictAt?: number | null
      contractAddress?: string | null
      token?: string | null
      owner: {
        __typename?: 'User'
        id: string
        name: string
        avatarUris: Array<string>
        level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
      }
      opponent?: {
        __typename?: 'User'
        id: string
        name: string
        avatarUris: Array<string>
        level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
      } | null
      ownerPredict: {
        __typename?: 'OneVsOnePredict'
        amount: number
        price: number
        gameId: string
      }
    }>
  }
}

export type GetOneVsOneUpDownGameStubQueryVariables = Exact<{
  [key: string]: never
}>

export type GetOneVsOneUpDownGameStubQuery = { __typename: 'Query' }

export type GetOneVsOneUpDownGamesStubQueryVariables = Exact<{
  [key: string]: never
}>

export type GetOneVsOneUpDownGamesStubQuery = { __typename: 'Query' }

export type GetOwnOneVsOneGamesQueryVariables = Exact<{
  filters: OneVsOneGameFilters
  pagination: PaginatedInput
}>

export type GetOwnOneVsOneGamesQuery = {
  __typename?: 'Query'
  getOwnOneVsOneGames: {
    __typename?: 'OneVsOneGames'
    total?: number | null
    games: Array<{
      __typename?: 'OneVsOneGame'
      feedId?: string | null
      gameType: GameType
      id: string
      isPrivate: boolean
      isAccepted: boolean
      endAt?: number | null
      startPrice?: number | null
      timeframe?: number | null
      ownerId: string
      stopPredictAt?: number | null
      contractAddress?: string | null
      token?: string | null
      status: GameStatus
      owner: {
        __typename?: 'User'
        id: string
        name: string
        avatarUris: Array<string>
        level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
      }
      opponent?: {
        __typename?: 'User'
        name: string
        avatarUris: Array<string>
        level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
      } | null
      opponentPredict?: {
        __typename?: 'OneVsOnePredict'
        amount: number
        playerAddress: string
        price: number
        status: PredictStatus
        pnl?: number | null
        owner: {
          __typename?: 'User'
          name: string
          avatarUris: Array<string>
          level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
        }
      } | null
      ownerPredict: {
        __typename?: 'OneVsOnePredict'
        amount: number
        playerAddress: string
        price: number
        status: PredictStatus
        pnl?: number | null
        gameId: string
      }
    }>
  }
}

export type GetOwnOneVsOneUpDownGamesStubQueryVariables = Exact<{
  [key: string]: never
}>

export type GetOwnOneVsOneUpDownGamesStubQuery = { __typename: 'Query' }

export type RejectOneVsOneGameStubQueryVariables = Exact<{
  [key: string]: never
}>

export type RejectOneVsOneGameStubQuery = { __typename: 'Query' }

export type RejectOneVsOneGameInvitationStubQueryVariables = Exact<{
  [key: string]: never
}>

export type RejectOneVsOneGameInvitationStubQuery = { __typename: 'Query' }

export type OneVsOneGameChangedSubscriptionVariables = Exact<{
  gameId: Scalars['String']['input']
}>

export type OneVsOneGameChangedSubscription = {
  __typename?: 'Subscription'
  oneVsOneGameChanged: {
    __typename?: 'OneVsOneGame'
    isAccepted: boolean
    gameType: GameType
    feedId?: string | null
    endPrice?: number | null
    endAt?: number | null
    id: string
    isPrivate: boolean
    stopPredictAt?: number | null
    contractAddress?: string | null
    token?: string | null
    ownerId: string
    startPrice?: number | null
    status: GameStatus
    asset: { __typename?: 'Asset'; id: string; name: string; precision: number }
    opponentPredict?: {
      __typename?: 'OneVsOnePredict'
      ownerId: string
      gameId: string
      amount: number
      gameType: GameType
      id: string
      price: number
      status: PredictStatus
      pnl?: number | null
    } | null
    owner: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
    }
    opponent?: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
    } | null
    ownerPredict: {
      __typename?: 'OneVsOnePredict'
      ownerId: string
      gameId: string
      amount: number
      gameType: GameType
      id: string
      price: number
      status: PredictStatus
      pnl?: number | null
    }
  }
}

export type OneVsOneGameCreatedSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type OneVsOneGameCreatedSubscription = {
  __typename?: 'Subscription'
  oneVsOneGameCreated: {
    __typename?: 'OneVsOneGame'
    feedId?: string | null
    gameType: GameType
    id: string
    isPrivate: boolean
    contractAddress?: string | null
    endAt?: number | null
    startPrice?: number | null
    timeframe?: number | null
    ownerId: string
    stopPredictAt?: number | null
    token?: string | null
    owner: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    }
    opponent?: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    } | null
    ownerPredict: {
      __typename?: 'OneVsOnePredict'
      amount: number
      price: number
      gameId: string
    }
  }
}

export type OneVsOneGamesChangedSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type OneVsOneGamesChangedSubscription = {
  __typename?: 'Subscription'
  oneVsOneGamesChanged: {
    __typename?: 'OneVsOneGame'
    isAccepted: boolean
    gameType: GameType
    feedId?: string | null
    endPrice?: number | null
    endAt?: number | null
    id: string
    isPrivate: boolean
    stopPredictAt?: number | null
    token?: string | null
    ownerId: string
    startPrice?: number | null
    status: GameStatus
    asset: { __typename?: 'Asset'; id: string; name: string; precision: number }
    opponentPredict?: {
      __typename?: 'OneVsOnePredict'
      amount: number
      price: number
      status: PredictStatus
      pnl?: number | null
      ownerId: string
    } | null
    owner: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
    }
    opponent?: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
    } | null
    ownerPredict: {
      __typename?: 'OneVsOnePredict'
      ownerId: string
      amount: number
      gameId: string
      gameType: GameType
      id: string
      price: number
      status: PredictStatus
      pnl?: number | null
    }
  }
}

export type OneVsOneCountGlobalGamesChangedSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type OneVsOneCountGlobalGamesChangedSubscription = {
  __typename?: 'Subscription'
  oneVsOneCountGlobalGamesChanged: {
    __typename?: 'OneVsOneNumberOfGlobalGames'
    global: number
  }
}

export type OneVsOneUpDownGameChangedStubQueryVariables = Exact<{
  [key: string]: never
}>

export type OneVsOneUpDownGameChangedStubQuery = { __typename: 'Query' }

export type OneVsOneUpDownGameCreatedStubQueryVariables = Exact<{
  [key: string]: never
}>

export type OneVsOneUpDownGameCreatedStubQuery = { __typename: 'Query' }

export type OneVsOneCountUserGamesChangedSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type OneVsOneCountUserGamesChangedSubscription = {
  __typename?: 'Subscription'
  oneVsOneCountUserGamesChanged: {
    __typename?: 'OneVsOneNumbersOfUserGames'
    current: number
    completed: number
    expired: number
    personal: number
  }
}

export type BullsEyeGameFragment = {
  __typename?: 'BullseyeGame'
  id: string
  gameType: GameType
  feedId?: string | null
  startAt?: number | null
  stopPredictAt?: number | null
  endAt?: number | null
  startPrice?: number | null
  endPrice?: number | null
  timeframe: number
  status: GameStatus
  contractAddress?: string | null
  createdAt: number
  updatedAt: number
  amount: number
  token?: string | null
  myPredicts: Array<{
    __typename?: 'BullseyePredict'
    id: string
    gameId: string
    gameType: GameType
    ownerId: string
    status: PredictStatus
    amount: number
    createdAt: number
    outcome?: number | null
    pnl?: number | null
    updatedAt: number
    price: number
    place: number
    isExact?: boolean | null
    owner?: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    } | null
  }>
  predicts: Array<{
    __typename?: 'BullseyePredict'
    id: string
    gameId: string
    gameType: GameType
    ownerId: string
    status: PredictStatus
    amount: number
    createdAt: number
    outcome?: number | null
    pnl?: number | null
    updatedAt: number
    price: number
    place: number
    isExact?: boolean | null
    owner?: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    } | null
  }>
  pool: {
    __typename?: 'BullseyeGamePoolInfo'
    predictsCount: number
    poolAmount: number
  }
} & { ' $fragmentName'?: 'BullsEyeGameFragment' }

export type GetBullsEyeGameModesQueryVariables = Exact<{ [key: string]: never }>

export type GetBullsEyeGameModesQuery = {
  __typename?: 'Query'
  getBullseyeGameModes: Array<{
    __typename?: 'BullseyeGameMode'
    id: string
    assetId: string
    amount: number
    timeframeSec: number
    sortOrder: number
    exactRange: number
    asset: {
      __typename?: 'Asset'
      id: string
      name: string
      precision: number
      feedId: string
    }
    current?:
      | ({ __typename?: 'BullseyeGame'; modeId: string; exactRange: number } & {
          ' $fragmentRefs'?: { BullsEyeGameFragment: BullsEyeGameFragment }
        })
      | null
  }>
}

export type GetBullsEyeLeaderboardQueryVariables = Exact<{
  data: BullseyeLeaderboardInput
}>

export type GetBullsEyeLeaderboardQuery = {
  __typename?: 'Query'
  getBullseyeLeaderboard: {
    __typename?: 'BullseyeLeaderboard'
    periodStart?: number | null
    periodEnd?: number | null
    skip: number
    take: number
    total?: number | null
    entries: Array<{
      __typename?: 'BullseyeLeaderboardEntry'
      rank: number
      score: number
      exactHits: number
      settledRounds: number
      user: {
        __typename?: 'User'
        id: string
        name: string
        avatarUris: Array<string>
      }
    }>
  }
}

export type GetCurrentBullsEyeGameQueryVariables = Exact<{
  data: BullseyeModeIdInput
}>

export type GetCurrentBullsEyeGameQuery = {
  __typename?: 'Query'
  getCurrentBullseyeGame?:
    | ({ __typename?: 'BullseyeGame'; modeId: string; exactRange: number } & {
        ' $fragmentRefs'?: { BullsEyeGameFragment: BullsEyeGameFragment }
      })
    | null
}

export type GetDemoBullseyeQuotaQueryVariables = Exact<{ [key: string]: never }>

export type GetDemoBullseyeQuotaQuery = {
  __typename?: 'Query'
  getDemoBullseyeQuota: {
    __typename?: 'DemoBullseyeQuota'
    enabled: boolean
    roundsPlayed: number
    roundsLeft?: number | null
    canPlay: boolean
  }
}

export type GetMyBullsEyeLeaderboardPositionQueryVariables = Exact<{
  period: BullseyeLeaderboardPeriod
}>

export type GetMyBullsEyeLeaderboardPositionQuery = {
  __typename?: 'Query'
  getMyBullseyeLeaderboardPosition?: {
    __typename?: 'BullseyeLeaderboardEntry'
    rank: number
    score: number
    exactHits: number
    settledRounds: number
    user: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
    }
  } | null
}

export type GetUserBullseyePredictsQueryVariables = Exact<{
  data: UserBullseyePredictsInput
}>

export type GetUserBullseyePredictsQuery = {
  __typename?: 'Query'
  getUserBullseyePredicts: {
    __typename?: 'BullseyePredicts'
    skip: number
    take: number
    total?: number | null
    predicts: Array<{
      __typename?: 'BullseyePredict'
      id: string
      gameId: string
      gameType: GameType
      ownerId: string
      playerAddress: string
      status: PredictStatus
      amount: number
      createdAt: number
      outcome?: number | null
      pnl?: number | null
      updatedAt: number
      price: number
      place: number
      isExact?: boolean | null
      game?: {
        __typename?: 'BullseyeGame'
        modeId: string
        feedId?: string | null
        endPrice?: number | null
        contractAddress?: string | null
        pool: { __typename?: 'BullseyeGamePoolInfo'; predictsCount: number }
      } | null
    }>
  }
}

export type BullsEyeLeaderboardChangedSubscriptionVariables = Exact<{
  period: BullseyeLeaderboardPeriod
}>

export type BullsEyeLeaderboardChangedSubscription = {
  __typename?: 'Subscription'
  bullseyeLeaderboardChanged: {
    __typename?: 'BullseyeLeaderboardUpdate'
    period: BullseyeLeaderboardPeriod
    bucket?: string | null
    periodChanged: boolean
  }
}

export type MyBullsEyeLeaderboardPositionChangedSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type MyBullsEyeLeaderboardPositionChangedSubscription = {
  __typename?: 'Subscription'
  myBullseyeLeaderboardPositionChanged: {
    __typename?: 'BullseyeLeaderboardPositionUpdate'
    period: BullseyeLeaderboardPeriod
    rank: number
    rankDelta: number
    score: number
    exactHits: number
    settledRounds: number
    user: { __typename?: 'User'; id: string; name: string }
  }
}

export type BullsEyeGameStateSubscriptionVariables = Exact<{
  modeId: Scalars['ID']['input']
}>

export type BullsEyeGameStateSubscription = {
  __typename?: 'Subscription'
  bullseyeGameChanged: { __typename?: 'BullseyeGame' } & {
    ' $fragmentRefs'?: { BullsEyeGameFragment: BullsEyeGameFragment }
  }
}

export type SetupsGameOwnerFragment = {
  __typename: 'User'
  id: string
  name: string
  avatarUris: Array<string>
  level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
} & { ' $fragmentName'?: 'SetupsGameOwnerFragment' }

export type SetupsGamePoolFragment = {
  __typename?: 'SetupGamePoolInfo'
  predictsCount: number
  poolAmount: number
  multiplier: number
} & { ' $fragmentName'?: 'SetupsGamePoolFragment' }

export type SetupsGameFragment = {
  __typename: 'SetupGame'
  ownerProfit?: number | null
  id: string
  feedId?: string | null
  isLong: boolean
  startAt?: number | null
  endAt?: number | null
  ownerId: string
  startPrice?: number | null
  endPrice?: number | null
  stopLoss: number
  takeProfit: number
  stopPredictAt?: number | null
  timeframe?: number | null
  status: GameStatus
  contractAddress?: string | null
  takeProfitPool: {
    __typename?: 'SetupGamePoolInfo'
    predictsCount: number
    poolAmount: number
    multiplier: number
  }
  stopLossPool: {
    __typename?: 'SetupGamePoolInfo'
    predictsCount: number
    poolAmount: number
    multiplier: number
  }
  owner: {
    __typename: 'User'
    id: string
    name: string
    avatarUris: Array<string>
    level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
  }
  myPredict?:
    | ({ __typename?: 'SetupPredict' } & {
        ' $fragmentRefs'?: {
          SetupsPredictShallowFragment: SetupsPredictShallowFragment
        }
      })
    | null
  asset: { __typename?: 'Asset'; feedId: string; id: string; name: string }
} & { ' $fragmentName'?: 'SetupsGameFragment' }

export type SetupsPredictShallowFragment = {
  __typename: 'SetupPredict'
  id: string
  gameType: GameType
  ownerId: string
  gameId: string
  status: PredictStatus
  amount: number
  createdAt: number
  outcome?: number | null
  isLong: boolean
  pnl?: number | null
  updatedAt: number
} & { ' $fragmentName'?: 'SetupsPredictShallowFragment' }

export type SetupsPredictFragment = {
  __typename: 'SetupPredict'
  id: string
  gameType: GameType
  ownerId: string
  playerAddress: string
  gameId: string
  status: PredictStatus
  amount: number
  createdAt: number
  outcome?: number | null
  isLong: boolean
  pnl?: number | null
  updatedAt: number
  isRetrieved: boolean
  game: {
    __typename?: 'SetupGame'
    id: string
    endAt?: number | null
    stopLoss: number
    takeProfit: number
    startPrice?: number | null
    contractAddress?: string | null
    asset: { __typename?: 'Asset'; id: string }
    stopLossPool: {
      __typename?: 'SetupGamePoolInfo'
      predictsCount: number
      poolAmount: number
      multiplier: number
    }
    takeProfitPool: {
      __typename?: 'SetupGamePoolInfo'
      predictsCount: number
      poolAmount: number
      multiplier: number
    }
  }
  owner: { __typename?: 'User' } & {
    ' $fragmentRefs'?: { SetupsGameOwnerFragment: SetupsGameOwnerFragment }
  }
} & { ' $fragmentName'?: 'SetupsPredictFragment' }

export type GetSetupPredictsQueryVariables = Exact<{
  id: Scalars['String']['input']
  pagination: PaginatedInput
}>

export type GetSetupPredictsQuery = {
  __typename?: 'Query'
  getSetupPredicts: {
    __typename: 'SetupPredicts'
    predicts: Array<
      { __typename?: 'SetupPredict' } & {
        ' $fragmentRefs'?: { SetupsPredictFragment: SetupsPredictFragment }
      }
    >
  }
}

export type GetSetupGameQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetSetupGameQuery = {
  __typename?: 'Query'
  getSetupGame: { __typename?: 'SetupGame' } & {
    ' $fragmentRefs'?: { SetupsGameFragment: SetupsGameFragment }
  }
}

export type GetSetupGamesQueryVariables = Exact<{
  filters: SetupGameFilters
  pagination: PaginatedInput
}>

export type GetSetupGamesQuery = {
  __typename?: 'Query'
  getSetupGames: {
    __typename?: 'SetupGames'
    skip: number
    take: number
    total?: number | null
    games: Array<
      { __typename?: 'SetupGame' } & {
        ' $fragmentRefs'?: { SetupsGameFragment: SetupsGameFragment }
      }
    >
  }
}

export type GetUserSetupGamesQueryVariables = Exact<{
  filters: SetupGameFilters
  pagination: PaginatedInput
}>

export type GetUserSetupGamesQuery = {
  __typename?: 'Query'
  getUserSetupGames: {
    __typename?: 'SetupGames'
    skip: number
    take: number
    total?: number | null
    games: Array<
      {
        __typename?: 'SetupGame'
        ownerProfit?: number | null
        startAt?: number | null
      } & { ' $fragmentRefs'?: { SetupsGameFragment: SetupsGameFragment } }
    >
  }
}

export type GetSetupsUserPredictsQueryVariables = Exact<{
  filters: SetupPredictFilters
  pagination: PaginatedInput
}>

export type GetSetupsUserPredictsQuery = {
  __typename?: 'Query'
  getUserSetupPredicts: {
    __typename?: 'SetupPredicts'
    total?: number | null
    predicts: Array<
      { __typename?: 'SetupPredict' } & {
        ' $fragmentRefs'?: { SetupsPredictFragment: SetupsPredictFragment }
      }
    >
  }
}

export type SetupsGameChangedSubscriptionVariables = Exact<{
  gameId: Scalars['String']['input']
}>

export type SetupsGameChangedSubscription = {
  __typename?: 'Subscription'
  setupGameChanged: { __typename?: 'SetupGame' } & {
    ' $fragmentRefs'?: { SetupsGameFragment: SetupsGameFragment }
  }
}

export type SetupGamesChangedSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type SetupGamesChangedSubscription = {
  __typename?: 'Subscription'
  setupGamesChanged: { __typename?: 'SetupGame' } & {
    ' $fragmentRefs'?: { SetupsGameFragment: SetupsGameFragment }
  }
}

export type CreatedSetupGameSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type CreatedSetupGameSubscription = {
  __typename?: 'Subscription'
  setupGameCreated: { __typename?: 'SetupGame' } & {
    ' $fragmentRefs'?: { SetupsGameFragment: SetupsGameFragment }
  }
}

export type UserSetupPredictsChangedSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type UserSetupPredictsChangedSubscription = {
  __typename?: 'Subscription'
  userSetupPredictsChanged: { __typename?: 'SetupPredict' } & {
    ' $fragmentRefs'?: { SetupsPredictFragment: SetupsPredictFragment }
  }
}

export type AddDemoUpDownAiPredictMutationVariables = Exact<{
  data: AddDemoUpDownAiPredictInput
}>

export type AddDemoUpDownAiPredictMutation = {
  __typename?: 'Mutation'
  addDemoUpDownAiPredict: {
    __typename?: 'DemoUpDownAiPredict'
    id: string
    gameId: string
    userId?: string | null
    amount: number
    gameType: DemoGameType
    status: PredictStatus
    outcome?: number | null
    pnl?: number | null
    isLong: boolean
    winStreakLength: number
  }
}

export type CreateDemoUpDownAiGameMutationVariables = Exact<{
  data: CreateDemoUpDownAiGameInput
}>

export type CreateDemoUpDownAiGameMutation = {
  __typename?: 'Mutation'
  createDemoUpDownAiGame: {
    __typename?: 'DemoUpDownAiGame'
    id: string
    gameType: DemoGameType
    channelId: string
    feedId: string
    startAt?: number | null
    stopPredictAt?: number | null
    endAt?: number | null
    startPrice?: number | null
    endPrice?: number | null
    timeframe?: number | null
    status: GameStatus
    commission?: number | null
    totalAmount?: number | null
    createdAt: number
    updatedAt: number
    isUp?: boolean | null
    userId?: string | null
    opponentUserId: string
    deposit: number
    difficulty: BotDifficulty
    asset: { __typename?: 'Asset'; id: string; name: string; feedId: string }
    opponent: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    }
    participant?: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    } | null
    myPredict?: {
      __typename?: 'DemoUpDownAiPredict'
      id: string
      gameId: string
      userId?: string | null
      amount: number
      gameType: DemoGameType
      status: PredictStatus
      outcome?: number | null
      pnl?: number | null
      commission?: number | null
      createdAt: number
      updatedAt: number
      isLong: boolean
      winStreakLength: number
    } | null
    opponentPredict?: {
      __typename?: 'DemoUpDownAiPredict'
      id: string
      gameId: string
      userId?: string | null
      amount: number
      gameType: DemoGameType
      status: PredictStatus
      outcome?: number | null
      pnl?: number | null
      commission?: number | null
      createdAt: number
      updatedAt: number
      isLong: boolean
      winStreakLength: number
    } | null
  }
}

export type GetCurrentDemoUpDownAiGameQueryVariables = Exact<{
  [key: string]: never
}>

export type GetCurrentDemoUpDownAiGameQuery = {
  __typename?: 'Query'
  getCurrentDemoUpDownAiGame?: {
    __typename?: 'DemoUpDownAiGame'
    id: string
    gameType: DemoGameType
    channelId: string
    feedId: string
    startAt?: number | null
    stopPredictAt?: number | null
    endAt?: number | null
    startPrice?: number | null
    endPrice?: number | null
    timeframe?: number | null
    status: GameStatus
    commission?: number | null
    totalAmount?: number | null
    createdAt: number
    updatedAt: number
    isUp?: boolean | null
    userId?: string | null
    opponentUserId: string
    deposit: number
    difficulty: BotDifficulty
    asset: { __typename?: 'Asset'; id: string; name: string; feedId: string }
    opponent: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    }
    participant?: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    } | null
    myPredict?: {
      __typename?: 'DemoUpDownAiPredict'
      id: string
      gameId: string
      userId?: string | null
      amount: number
      gameType: DemoGameType
      status: PredictStatus
      outcome?: number | null
      pnl?: number | null
      commission?: number | null
      createdAt: number
      updatedAt: number
      isLong: boolean
      winStreakLength: number
    } | null
    opponentPredict?: {
      __typename?: 'DemoUpDownAiPredict'
      id: string
      gameId: string
      userId?: string | null
      amount: number
      gameType: DemoGameType
      status: PredictStatus
      outcome?: number | null
      pnl?: number | null
      commission?: number | null
      createdAt: number
      updatedAt: number
      isLong: boolean
      winStreakLength: number
    } | null
  } | null
}

export type GetDemoUpDownAiGameByIdQueryVariables = Exact<{
  gameId: Scalars['String']['input']
}>

export type GetDemoUpDownAiGameByIdQuery = {
  __typename?: 'Query'
  getDemoUpDownAiGameById: {
    __typename?: 'DemoUpDownAiGame'
    id: string
    gameType: DemoGameType
    channelId: string
    feedId: string
    startAt?: number | null
    stopPredictAt?: number | null
    endAt?: number | null
    startPrice?: number | null
    endPrice?: number | null
    timeframe?: number | null
    status: GameStatus
    commission?: number | null
    totalAmount?: number | null
    createdAt: number
    updatedAt: number
    isUp?: boolean | null
    userId?: string | null
    opponentUserId: string
    deposit: number
    difficulty: BotDifficulty
    asset: { __typename?: 'Asset'; id: string; name: string; feedId: string }
    opponent: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    }
    participant?: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    } | null
    myPredict?: {
      __typename?: 'DemoUpDownAiPredict'
      id: string
      gameId: string
      userId?: string | null
      amount: number
      gameType: DemoGameType
      status: PredictStatus
      outcome?: number | null
      pnl?: number | null
      commission?: number | null
      createdAt: number
      updatedAt: number
      isLong: boolean
      winStreakLength: number
    } | null
    opponentPredict?: {
      __typename?: 'DemoUpDownAiPredict'
      id: string
      gameId: string
      userId?: string | null
      amount: number
      gameType: DemoGameType
      status: PredictStatus
      outcome?: number | null
      pnl?: number | null
      commission?: number | null
      createdAt: number
      updatedAt: number
      isLong: boolean
      winStreakLength: number
    } | null
  }
}

export type GetDemoUpDownAiQuotaQueryVariables = Exact<{ [key: string]: never }>

export type GetDemoUpDownAiQuotaQuery = {
  __typename?: 'Query'
  getDemoUpDownAiQuota: {
    __typename?: 'DemoUpDownAiQuota'
    roundsPlayed: number
    roundsLeft?: number | null
    canPlay: boolean
  }
}

export type GetDemoUpDownAiSessionStatisticQueryVariables = Exact<{
  [key: string]: never
}>

export type GetDemoUpDownAiSessionStatisticQuery = {
  __typename?: 'Query'
  getDemoUpDownAiSessionStatistic: {
    __typename?: 'DemoUpDownAiSessionStatistic'
    totalGames: number
    totalWins: number
    winPercentage: number
    currentStreak: number
    bestStreak: number
    score?: number | null
    projectedDaily?: {
      __typename?: 'DemoUpDownAiProjectedRank'
      rank: number
      totalRanked: number
    } | null
    projectedWeekly?: {
      __typename?: 'DemoUpDownAiProjectedRank'
      rank: number
      totalRanked: number
    } | null
    projectedAlltime?: {
      __typename?: 'DemoUpDownAiProjectedRank'
      rank: number
      totalRanked: number
    } | null
  }
}

export type GetGuestDemoUpDownAiGamesQueryVariables = Exact<{
  data: GuestDemoUpDownAiGamesInput
}>

export type GetGuestDemoUpDownAiGamesQuery = {
  __typename?: 'Query'
  getGuestDemoUpDownAiGames: {
    __typename?: 'DemoUpDownAiGames'
    skip: number
    take: number
    total?: number | null
    games: Array<{
      __typename?: 'DemoUpDownAiGame'
      id: string
      status: GameStatus
      isUp?: boolean | null
      deposit: number
      startPrice?: number | null
      endPrice?: number | null
      createdAt: number
      myPredict?: {
        __typename?: 'DemoUpDownAiPredict'
        id: string
        gameId: string
        status: PredictStatus
        amount: number
        pnl?: number | null
        isLong: boolean
        winStreakLength: number
      } | null
    }>
  }
}

export type DemoUpDownAiGameChangedSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type DemoUpDownAiGameChangedSubscription = {
  __typename?: 'Subscription'
  demoUpDownAiGameChanged: { __typename?: 'DemoUpDownAiGame'; id: string }
}

export type FindUpDownAiOpponentsQueryVariables = Exact<{
  data: FindUpDownAiOpponentsInput
}>

export type FindUpDownAiOpponentsQuery = {
  __typename?: 'Query'
  findUpDownAiOpponents: Array<{
    __typename?: 'UpDownAiOpponent'
    difficulty: BotDifficulty
    user: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
    }
  }>
}

export type GetCurrentUpDownAiGamesQueryVariables = Exact<{
  data: UpDownAiCurrentGamesInput
}>

export type GetCurrentUpDownAiGamesQuery = {
  __typename?: 'Query'
  getCurrentUpDownAiGames: {
    __typename?: 'UpDownAiGames'
    skip: number
    take: number
    total?: number | null
    games: Array<{
      __typename?: 'UpDownAiGame'
      id: string
      gameType: GameType
      feedId?: string | null
      startAt?: number | null
      stopPredictAt?: number | null
      endAt?: number | null
      startPrice?: number | null
      endPrice?: number | null
      timeframe?: number | null
      status: GameStatus
      contractAddress?: string | null
      token?: string | null
      totalAmount?: number | null
      commission?: number | null
      createdAt: number
      updatedAt: number
      isUp?: boolean | null
      ownerId: string
      opponentId: string
      deposit: number
      difficulty?: BotDifficulty | null
      asset: { __typename?: 'Asset'; id: string; name: string; feedId: string }
      owner: {
        __typename?: 'User'
        id: string
        name: string
        avatarUris: Array<string>
        level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
      }
      opponent: {
        __typename?: 'User'
        id: string
        name: string
        avatarUris: Array<string>
        level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
      }
      ownerPredict?: {
        __typename?: 'UpDownAiPredict'
        id: string
        gameId: string
        gameType: GameType
        ownerId: string
        status: PredictStatus
        amount: number
        createdAt: number
        outcome?: number | null
        pnl?: number | null
        updatedAt: number
        isLong: boolean
        winStreakLength: number
      } | null
      opponentPredict?: {
        __typename?: 'UpDownAiPredict'
        id: string
        gameId: string
        gameType: GameType
        ownerId: string
        status: PredictStatus
        amount: number
        createdAt: number
        outcome?: number | null
        pnl?: number | null
        updatedAt: number
        isLong: boolean
        winStreakLength: number
      } | null
    }>
  }
}

export type GetMyUpDownAiLeaderboardPositionQueryVariables = Exact<{
  period: UpDownAiLeaderboardPeriod
}>

export type GetMyUpDownAiLeaderboardPositionQuery = {
  __typename?: 'Query'
  getMyUpDownAiLeaderboardPosition?: {
    __typename?: 'UpDownAiLeaderboardEntry'
    rank: number
    score: number
    winRate: number
    settledRounds: number
    currentStreak: number
    bestStreak: number
    user: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
    }
  } | null
}

export type GetUpDownAiGameQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetUpDownAiGameQuery = {
  __typename?: 'Query'
  getUpDownAiGame: {
    __typename?: 'UpDownAiGame'
    id: string
    gameType: GameType
    feedId?: string | null
    startAt?: number | null
    stopPredictAt?: number | null
    endAt?: number | null
    startPrice?: number | null
    endPrice?: number | null
    timeframe?: number | null
    status: GameStatus
    contractAddress?: string | null
    token?: string | null
    totalAmount?: number | null
    commission?: number | null
    createdAt: number
    updatedAt: number
    isUp?: boolean | null
    ownerId: string
    opponentId: string
    deposit: number
    difficulty?: BotDifficulty | null
    asset: { __typename?: 'Asset'; id: string; name: string; feedId: string }
    owner: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    }
    opponent: {
      __typename?: 'User'
      id: string
      name: string
      avatarUris: Array<string>
      level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
    }
    ownerPredict?: {
      __typename?: 'UpDownAiPredict'
      id: string
      gameId: string
      gameType: GameType
      ownerId: string
      status: PredictStatus
      amount: number
      createdAt: number
      outcome?: number | null
      pnl?: number | null
      updatedAt: number
      isLong: boolean
      winStreakLength: number
    } | null
    opponentPredict?: {
      __typename?: 'UpDownAiPredict'
      id: string
      gameId: string
      gameType: GameType
      ownerId: string
      status: PredictStatus
      amount: number
      createdAt: number
      outcome?: number | null
      pnl?: number | null
      updatedAt: number
      isLong: boolean
      winStreakLength: number
    } | null
  }
}

export type GetUpDownAiGamesQueryVariables = Exact<{
  filters: UpDownAiGameFilters
  pagination: PaginatedInput
}>

export type GetUpDownAiGamesQuery = {
  __typename?: 'Query'
  getUpDownAiGames: {
    __typename?: 'UpDownAiGames'
    skip: number
    take: number
    total?: number | null
    games: Array<{
      __typename?: 'UpDownAiGame'
      id: string
      gameType: GameType
      feedId?: string | null
      startAt?: number | null
      stopPredictAt?: number | null
      endAt?: number | null
      startPrice?: number | null
      endPrice?: number | null
      timeframe?: number | null
      status: GameStatus
      contractAddress?: string | null
      token?: string | null
      totalAmount?: number | null
      commission?: number | null
      createdAt: number
      updatedAt: number
      isUp?: boolean | null
      ownerId: string
      opponentId: string
      deposit: number
      difficulty?: BotDifficulty | null
      asset: { __typename?: 'Asset'; id: string; name: string; feedId: string }
      owner: {
        __typename?: 'User'
        id: string
        name: string
        avatarUris: Array<string>
        level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
      }
      opponent: {
        __typename?: 'User'
        id: string
        name: string
        avatarUris: Array<string>
        level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
      }
      ownerPredict?: {
        __typename?: 'UpDownAiPredict'
        id: string
        gameId: string
        ownerId: string
        playerAddress: string
        status: PredictStatus
        amount: number
        outcome?: number | null
        pnl?: number | null
        isLong: boolean
        winStreakLength: number
      } | null
      opponentPredict?: {
        __typename?: 'UpDownAiPredict'
        id: string
        gameId: string
        ownerId: string
        playerAddress: string
        status: PredictStatus
        amount: number
        outcome?: number | null
        pnl?: number | null
        isLong: boolean
        winStreakLength: number
      } | null
    }>
  }
}

export type GetUpDownAiLeaderboardQueryVariables = Exact<{
  data: UpDownAiLeaderboardInput
}>

export type GetUpDownAiLeaderboardQuery = {
  __typename?: 'Query'
  getUpDownAiLeaderboard: {
    __typename?: 'UpDownAiLeaderboard'
    periodStart?: number | null
    periodEnd?: number | null
    skip: number
    take: number
    total?: number | null
    entries: Array<{
      __typename?: 'UpDownAiLeaderboardEntry'
      rank: number
      score: number
      winRate: number
      settledRounds: number
      currentStreak: number
      bestStreak: number
      user: {
        __typename?: 'User'
        id: string
        name: string
        avatarUris: Array<string>
      }
    }>
  }
}

export type GetUserUpDownAiPredictsStatisticQueryVariables = Exact<{
  userId: Scalars['String']['input']
}>

export type GetUserUpDownAiPredictsStatisticQuery = {
  __typename?: 'Query'
  getUserUpDownAiPredictsStatistic: {
    __typename?: 'UserUpDownAiPredictsStatistic'
    totalGames: number
    totalWins: number
    winPercentage: number
    earned?: number | null
  }
}

export type GetUserUpDownAiPredictsQueryVariables = Exact<{
  data: UserUpDownAiPredictsInput
}>

export type GetUserUpDownAiPredictsQuery = {
  __typename?: 'Query'
  getUserUpDownAiPredicts: {
    __typename?: 'UpDownAiPredicts'
    skip: number
    take: number
    total?: number | null
    predicts: Array<{
      __typename?: 'UpDownAiPredict'
      id: string
      gameId: string
      gameType: GameType
      ownerId: string
      playerAddress: string
      status: PredictStatus
      amount: number
      createdAt: number
      outcome?: number | null
      pnl?: number | null
      updatedAt: number
      isLong: boolean
      winStreakLength: number
      game: {
        __typename?: 'UpDownAiGame'
        id: string
        startPrice?: number | null
        endPrice?: number | null
        isUp?: boolean | null
        status: GameStatus
        commission?: number | null
        contractAddress?: string | null
        feedId?: string | null
        deposit: number
      }
    }>
  }
}

export type SignUpDownAiGameCreationMutationVariables = Exact<{
  data: SignUpDownAiGameCreationInput
}>

export type SignUpDownAiGameCreationMutation = {
  __typename?: 'Mutation'
  signUpDownAiGameCreation: {
    __typename?: 'UpDownAiGameAuthorization'
    signer: string
    message: string
    signature: string
    opponent: string
    mint: string
    endTime: number
    stopPredictAt: number
    minDeposit: string
    feedId: string
    feeBps: number
    nonce: string
    unverifiedReport: string
    verifierAccount: string
    accessController: string
    verifierConfig: string
    verifierProgram: string
    chainlinkVerifierProgram: string
    feedWhitelist: string
    lookupTable?: string | null
  }
}

export type MyUpDownAiLeaderboardPositionChangedSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type MyUpDownAiLeaderboardPositionChangedSubscription = {
  __typename?: 'Subscription'
  myUpDownAiLeaderboardPositionChanged: {
    __typename?: 'UpDownAiLeaderboardPositionUpdate'
    period: UpDownAiLeaderboardPeriod
    rank: number
    rankDelta: number
    score: number
    winRate: number
    settledRounds: number
    currentStreak: number
    bestStreak: number
    user: { __typename?: 'User'; id: string; name: string }
  }
}

export type UpDownAiGameChangedSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type UpDownAiGameChangedSubscription = {
  __typename?: 'Subscription'
  upDownAiGameChanged: { __typename?: 'UpDownAiGame'; id: string }
}

export type UpDownAiLeaderboardChangedSubscriptionVariables = Exact<{
  period: UpDownAiLeaderboardPeriod
}>

export type UpDownAiLeaderboardChangedSubscription = {
  __typename?: 'Subscription'
  upDownAiLeaderboardChanged: {
    __typename?: 'UpDownAiLeaderboardUpdate'
    period: UpDownAiLeaderboardPeriod
    bucket?: string | null
    periodChanged: boolean
  }
}

export type GetLastClosedUpDownGamesQueryVariables = Exact<{
  data: UpDownContractAddressInput
}>

export type GetLastClosedUpDownGamesQuery = {
  __typename?: 'Query'
  getLastClosedUpDownGames: {
    __typename?: 'UpDownGames'
    games: Array<{
      __typename?: 'UpDownGame'
      id: string
      isUp?: boolean | null
      startAt?: number | null
      endAt?: number | null
      startPrice?: number | null
      endPrice?: number | null
    }>
  }
}

export type GetCurrentUpDownGameQueryVariables = Exact<{
  data: UpDownContractAddressInput
}>

export type GetCurrentUpDownGameQuery = {
  __typename?: 'Query'
  getCurrentUpDownGame: {
    __typename?: 'UpDownGame'
    id: string
    gameType: GameType
    feedId?: string | null
    startAt?: number | null
    stopPredictAt?: number | null
    endAt?: number | null
    startPrice?: number | null
    endPrice?: number | null
    timeframe?: number | null
    status: GameStatus
    contractAddress?: string | null
    createdAt: number
    updatedAt: number
    isUp?: boolean | null
    token?: string | null
    myPredict?: {
      __typename?: 'UpDownPredict'
      id: string
      gameId: string
      gameType: GameType
      ownerId: string
      status: PredictStatus
      amount: number
      createdAt: number
      outcome?: number | null
      pnl?: number | null
      updatedAt: number
      isLong: boolean
    } | null
    upPool: {
      __typename?: 'UpDownGamePoolInfo'
      predictsCount: number
      poolAmount: number
      predicts: Array<{
        __typename?: 'UpDownPredict'
        id: string
        amount: number
        isLong: boolean
        owner?: {
          __typename?: 'User'
          id: string
          name: string
          avatarUris: Array<string>
          level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
        } | null
      }>
    }
    downPool: {
      __typename?: 'UpDownGamePoolInfo'
      predictsCount: number
      poolAmount: number
      predicts: Array<{
        __typename?: 'UpDownPredict'
        id: string
        amount: number
        isLong: boolean
        owner?: {
          __typename?: 'User'
          id: string
          name: string
          avatarUris: Array<string>
          level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
        } | null
      }>
    }
  }
}

export type GetUserUpDownPredictsQueryVariables = Exact<{
  data: UserUpDownPredictsInput
}>

export type GetUserUpDownPredictsQuery = {
  __typename?: 'Query'
  getUserUpDownPredicts: {
    __typename?: 'UpDownPredicts'
    skip: number
    take: number
    total?: number | null
    predicts: Array<{
      __typename?: 'UpDownPredict'
      id: string
      gameId: string
      gameType: GameType
      ownerId: string
      playerAddress: string
      status: PredictStatus
      amount: number
      createdAt: number
      outcome?: number | null
      pnl?: number | null
      winStreakLength: number
      updatedAt: number
      isLong: boolean
      game?: {
        __typename?: 'UpDownGame'
        startPrice?: number | null
        endPrice?: number | null
        commission?: number | null
        contractAddress?: string | null
        upPool: {
          __typename?: 'UpDownGamePoolInfo'
          predictsCount: number
          poolAmount: number
        }
        downPool: {
          __typename?: 'UpDownGamePoolInfo'
          predictsCount: number
          poolAmount: number
        }
      } | null
    }>
  }
}

export type UpDownGameChangedSubscriptionVariables = Exact<{
  contractAddress: Scalars['String']['input']
}>

export type UpDownGameChangedSubscription = {
  __typename?: 'Subscription'
  upDownGameChanged: {
    __typename?: 'UpDownGame'
    id: string
    gameType: GameType
    feedId?: string | null
    startAt?: number | null
    stopPredictAt?: number | null
    endAt?: number | null
    startPrice?: number | null
    endPrice?: number | null
    timeframe?: number | null
    status: GameStatus
    contractAddress?: string | null
    createdAt: number
    updatedAt: number
    isUp?: boolean | null
    token?: string | null
    myPredict?: {
      __typename?: 'UpDownPredict'
      id: string
      gameId: string
      gameType: GameType
      ownerId: string
      status: PredictStatus
      amount: number
      createdAt: number
      outcome?: number | null
      pnl?: number | null
      updatedAt: number
      isLong: boolean
    } | null
    upPool: {
      __typename?: 'UpDownGamePoolInfo'
      predictsCount: number
      poolAmount: number
      predicts: Array<{
        __typename?: 'UpDownPredict'
        id: string
        amount: number
        isLong: boolean
        owner?: {
          __typename?: 'User'
          id: string
          name: string
          avatarUris: Array<string>
          level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
        } | null
      }>
    }
    downPool: {
      __typename?: 'UpDownGamePoolInfo'
      predictsCount: number
      poolAmount: number
      predicts: Array<{
        __typename?: 'UpDownPredict'
        id: string
        amount: number
        isLong: boolean
        owner?: {
          __typename?: 'User'
          id: string
          name: string
          avatarUris: Array<string>
          level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
        } | null
      }>
    }
  }
}

export type CreateCoinAddressStubQueryVariables = Exact<{
  [key: string]: never
}>

export type CreateCoinAddressStubQuery = { __typename: 'Query' }

export type GetUserBalanceOperationsStubQueryVariables = Exact<{
  [key: string]: never
}>

export type GetUserBalanceOperationsStubQuery = { __typename: 'Query' }

export type CoinListStubQueryVariables = Exact<{ [key: string]: never }>

export type CoinListStubQuery = { __typename: 'Query' }

export type ListCoinAddressesStubQueryVariables = Exact<{
  [key: string]: never
}>

export type ListCoinAddressesStubQuery = { __typename: 'Query' }

export type CoinRatesStubQueryVariables = Exact<{ [key: string]: never }>

export type CoinRatesStubQuery = { __typename: 'Query' }

export type ListTransactionsStubQueryVariables = Exact<{ [key: string]: never }>

export type ListTransactionsStubQuery = { __typename: 'Query' }

export type WithdrawalStubQueryVariables = Exact<{ [key: string]: never }>

export type WithdrawalStubQuery = { __typename: 'Query' }

export type AssetPricesQueryVariables = Exact<{
  data: AssetPricesInput
}>

export type AssetPricesQuery = {
  __typename?: 'Query'
  assetPrices: Array<{
    __typename?: 'AssetPrice'
    assetId: string
    feedId: string
    formattedValue: number
    timestamp: number
  }>
}

export type PriceRangeQueryVariables = Exact<{
  data: AssetPricesRangeInput
}>

export type PriceRangeQuery = {
  __typename?: 'Query'
  priceRange: Array<{
    __typename?: 'AssetPrice'
    assetId: string
    feedId: string
    formattedValue: number
    timestamp: number
  }>
}

export type AssetPriceChangedSubscriptionVariables = Exact<{
  assetId: Scalars['String']['input']
}>

export type AssetPriceChangedSubscription = {
  __typename?: 'Subscription'
  assetPriceChanged: {
    __typename?: 'AssetPrice'
    assetId: string
    formattedValue: number
    timestamp: number
    payload: string
  }
}

export type GetOwnReferralWithdrawRequestsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetOwnReferralWithdrawRequestsQuery = {
  __typename?: 'Query'
  getOwnReferralWithdrawRequests: {
    __typename?: 'ReferralWithdrawRequests'
    skip: number
    take: number
    total?: number | null
    requests: Array<{
      __typename?: 'ReferralWithdrawRequest'
      id: string
      status: ReferralWithdrawRequestStatus
      amount: number
      cancelReason?: string | null
      transactionHash?: string | null
      createdAt: number
      updatedAt: number
    }>
  }
}

export type GetProfitForReferralsPredictsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetProfitForReferralsPredictsQuery = {
  __typename?: 'Query'
  getProfitForReferralsPredicts: {
    __typename?: 'ProfitForReferralsPredicts'
    availableProfitAmountToWithdraw: number
    minProfitAmountToWithdraw: number
  }
}

export type CreateWithdrawRequestMutationVariables = Exact<{
  [key: string]: never
}>

export type CreateWithdrawRequestMutation = {
  __typename?: 'Mutation'
  createWithdrawRequest: { __typename?: 'ReferralWithdrawRequest'; id: string }
}

export type RewardBaseFragment = {
  __typename?: 'Reward'
  id: string
  rewards: number
  currentPlace?: number | null
  placeChange?: number | null
} & { ' $fragmentName'?: 'RewardBaseFragment' }

export type RewardStatsFragment = {
  __typename: 'Reward'
  referralRewards: number
  currentPlace?: number | null
  rewardsForChallenges: number
  lastPlaceOnLeaderboard: number
} & { ' $fragmentName'?: 'RewardStatsFragment' }

export type RewardUserFragment = {
  __typename?: 'User'
  id: string
  bio: string
  name: string
  avatarKeys: Array<string>
  discordRoles: Array<string>
  isInfluencer: boolean
  createdAt: number
  updatedAt: number
  avatarUris: Array<string>
} & { ' $fragmentName'?: 'RewardUserFragment' }

export type RewardWithUserFragment = ({
  __typename?: 'Reward'
  user?: {
    __typename?: 'User'
    id: string
    bio: string
    name: string
    avatarKeys: Array<string>
    discordRoles: Array<string>
    isInfluencer: boolean
    createdAt: number
    updatedAt: number
    avatarUris: Array<string>
  } | null
} & { ' $fragmentRefs'?: { RewardBaseFragment: RewardBaseFragment } }) & {
  ' $fragmentName'?: 'RewardWithUserFragment'
}

export type GetUserDailyTasksQueryVariables = Exact<{ [key: string]: never }>

export type GetUserDailyTasksQuery = {
  __typename?: 'Query'
  getUserDailyTasks: {
    __typename?: 'DailyTasks'
    facetedTasks: Array<{
      __typename?: 'ChallengeTask'
      id: string
      name: string
      description?: string | null
      number: number
      reward?: number | null
      isCompleted: boolean
      requirement?: number | null
      userRelatedTask?: {
        __typename?: 'UserChallengeTask'
        id: string
        taskId: string
        progress?: number | null
        userId: string
        status: UserChallengeTaskStatus
        isBonusReceived: boolean
      } | null
    }>
    simpleTasks: Array<{
      __typename?: 'ChallengeTask'
      id: string
      name: string
      description?: string | null
      number: number
      reward?: number | null
      isCompleted: boolean
      requirement?: number | null
      userRelatedTask?: {
        __typename?: 'UserChallengeTask'
        id: string
        taskId: string
        progress?: number | null
        userId: string
        status: UserChallengeTaskStatus
        isBonusReceived: boolean
      } | null
    }>
    serialTasks: Array<
      Array<{
        __typename?: 'ChallengeTask'
        id: string
        name: string
        description?: string | null
        number: number
        reward?: number | null
        isCompleted: boolean
        requirement?: number | null
        userRelatedTask?: {
          __typename?: 'UserChallengeTask'
          id: string
          taskId: string
          progress?: number | null
          userId: string
          status: UserChallengeTaskStatus
          isBonusReceived: boolean
        } | null
      }>
    >
  }
}

export type GetReferralStatisticQueryVariables = Exact<{ [key: string]: never }>

export type GetReferralStatisticQuery = {
  __typename?: 'Query'
  getReferralStatistic: {
    __typename?: 'ReferralStatistic'
    numberOfInvited: number
    numberOfSecondLevelInvited: number
  }
}

export type GetTopUsersRewardsQueryVariables = Exact<{ [key: string]: never }>

export type GetTopUsersRewardsQuery = {
  __typename?: 'Query'
  getTopUsersRewards: {
    __typename?: 'TopUsersRewards'
    rewards: Array<{
      __typename?: 'Reward'
      id: string
      rewards: number
      referralRewards: number
      lastPlace?: number | null
      currentPlace?: number | null
      placeChange?: number | null
      rewardsForChallenges: number
      lastPlaceOnLeaderboard: number
      user?: {
        __typename?: 'User'
        id: string
        bio: string
        name: string
        avatarKeys: Array<string>
        discordRoles: Array<string>
        isInfluencer: boolean
        createdAt: number
        updatedAt: number
        avatarUris: Array<string>
        level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
      } | null
    }>
    myReward: {
      __typename?: 'Reward'
      id: string
      rewards: number
      referralRewards: number
      lastPlace?: number | null
      currentPlace?: number | null
      placeChange?: number | null
      rewardsForChallenges: number
      lastPlaceOnLeaderboard: number
      user?: {
        __typename?: 'User'
        id: string
        bio: string
        name: string
        avatarKeys: Array<string>
        discordRoles: Array<string>
        isInfluencer: boolean
        createdAt: number
        updatedAt: number
        avatarUris: Array<string>
        level?: { __typename?: 'UserLevel'; levelId?: number | null } | null
      } | null
    }
  }
}

export type GetUserRewardStatsQueryVariables = Exact<{ [key: string]: never }>

export type GetUserRewardStatsQuery = {
  __typename?: 'Query'
  getUserReward: { __typename?: 'Reward' } & {
    ' $fragmentRefs'?: { RewardStatsFragment: RewardStatsFragment }
  }
}

export type GetUserRewardQueryVariables = Exact<{ [key: string]: never }>

export type GetUserRewardQuery = {
  __typename?: 'Query'
  getUserReward: { __typename?: 'Reward' } & {
    ' $fragmentRefs'?: { RewardBaseFragment: RewardBaseFragment }
  }
}

export type GetUserSeasonStateQueryVariables = Exact<{ [key: string]: never }>

export type GetUserSeasonStateQuery = {
  __typename?: 'Query'
  getUserSeasonState: {
    __typename?: 'Season'
    id: string
    name: string
    description: string
    countCompletedChallegnes: number
    challenges: Array<{
      __typename?: 'SeasonChallenge'
      id: string
      name: string
      description: string
      number: number
      tasks: Array<{
        __typename?: 'ChallengeTask'
        id: string
        name: string
        description?: string | null
        reward?: number | null
        number: number
        userRelatedTask?: {
          __typename?: 'UserChallengeTask'
          id: string
          status: UserChallengeTaskStatus
        } | null
      }>
    }>
  }
}

export type CheckChallengeTaskCompletionMutationVariables = Exact<{
  data: CheckChallengeTaskCompletionInput
}>

export type CheckChallengeTaskCompletionMutation = {
  __typename?: 'Mutation'
  checkChallengeTaskCompletion: { __typename?: 'Season'; id: string }
}

export type ClaimRewardMutationVariables = Exact<{
  data: ClaimRewardInput
}>

export type ClaimRewardMutation = {
  __typename?: 'Mutation'
  claimReward: {
    __typename?: 'UserChallengeTask'
    id: string
    status: UserChallengeTaskStatus
  }
}

export type UpdateReferralMutationVariables = Exact<{
  data: UpdateReferralInput
}>

export type UpdateReferralMutation = {
  __typename?: 'Mutation'
  updateReferral: { __typename?: 'Referral'; code: string }
}

export type GetUserLevelQueryVariables = Exact<{
  userId: Scalars['String']['input']
}>

export type GetUserLevelQuery = {
  __typename?: 'Query'
  getUserLevel: {
    __typename?: 'UserLevel'
    id: string
    commissionsPaid: number
    levelId?: number | null
    userId: string
    claimedOnLevel?: number | null
    isCashBackReceived?: boolean | null
    requestedOnCashBackValue?: number | null
    txHash?: string | null
    progressPercent?: number | null
    level?: {
      __typename?: 'Level'
      id: number
      name: string
      commissionsToPay: number
      cashReward: number
      pointReward: number
      cashBackPercent: number
    } | null
  }
}

export type GetLevelsQueryVariables = Exact<{ [key: string]: never }>

export type GetLevelsQuery = {
  __typename?: 'Query'
  getLevels: Array<{
    __typename?: 'Level'
    id: number
    name: string
    commissionsToPay: number
    cashReward: number
    pointReward: number
    cashBackPercent: number
  }>
}

export type UserDailyTasksChangedSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type UserDailyTasksChangedSubscription = {
  __typename?: 'Subscription'
  userDailyTasksChanged: Array<{
    __typename?: 'ChallengeTask'
    id: string
    name: string
    description?: string | null
    number: number
    reward?: number | null
    userRelatedTask?: {
      __typename?: 'UserChallengeTask'
      id: string
      status: UserChallengeTaskStatus
    } | null
  }>
}

export type RewardChangedSubscriptionVariables = Exact<{ [key: string]: never }>

export type RewardChangedSubscription = {
  __typename?: 'Subscription'
  rewardChanged: { __typename?: 'Reward' } & {
    ' $fragmentRefs'?: { RewardBaseFragment: RewardBaseFragment }
  }
}

export type UserSeasonChangedSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type UserSeasonChangedSubscription = {
  __typename?: 'Subscription'
  userSeasonChanged: {
    __typename?: 'Season'
    id: string
    name: string
    description: string
    countCompletedChallegnes: number
    challenges: Array<{
      __typename?: 'SeasonChallenge'
      id: string
      name: string
      description: string
      number: number
      tasks: Array<{
        __typename?: 'ChallengeTask'
        id: string
        name: string
        description?: string | null
        reward?: number | null
        number: number
        userRelatedTask?: {
          __typename?: 'UserChallengeTask'
          id: string
          status: UserChallengeTaskStatus
        } | null
      }>
    }>
  }
}

export type UserShallowFragment = {
  __typename?: 'User'
  id: string
  name: string
  isInfluencer: boolean
} & { ' $fragmentName'?: 'UserShallowFragment' }

export type GetCashbackSummaryQueryVariables = Exact<{ [key: string]: never }>

export type GetCashbackSummaryQuery = {
  __typename?: 'Query'
  getCashbackSummary: Array<{
    __typename?: 'CashbackPeriodSummary'
    cashbackAmount: number
    applicableLevel?: number | null
    commissionPaid: number
    txHash?: string | null
    status?: CashbackStatus | null
    period: {
      __typename?: 'CashbackPeriods'
      id: string
      startDate: number
      endDate: number
    }
  }>
}

export type GetUserBetsStatisticStubQueryVariables = Exact<{
  [key: string]: never
}>

export type GetUserBetsStatisticStubQuery = { __typename: 'Query' }

export type GetUserByIdQueryVariables = Exact<{
  userId: Scalars['String']['input']
}>

export type GetUserByIdQuery = {
  __typename?: 'Query'
  getUserById: { __typename?: 'User' } & {
    ' $fragmentRefs'?: { MeFragment: MeFragment }
  }
}

export type GetUserGamesStatisticQueryVariables = Exact<{
  userId: Scalars['String']['input']
}>

export type GetUserGamesStatisticQuery = {
  __typename?: 'Query'
  getUserGamesStatistic: {
    __typename?: 'UserGamesStatistic'
    totalGames: number
    winPercentage: number
    earned?: number | null
    largestWin?: {
      __typename?: 'Predict'
      pnl?: number | null
      createdAt: number
      gameType: GameType
      amount: number
    } | null
  }
}

export type StatisticsQueryVariables = Exact<{
  userId: Scalars['String']['input']
}>

export type StatisticsQuery = {
  __typename?: 'Query'
  getUserSetupPredictsStatistic: {
    __typename?: 'UserSetupPredictsStatistic'
    totalGames: number
    totalWins: number
    winPercentage: number
    earned?: number | null
  }
  getUserSetupGamesStatistic: {
    __typename?: 'UserSetupGamesStatistic'
    totalPlayersOnGames: number
    totalGames: number
    earned?: number | null
    totalTakeProfitClosedGames: number
    totalTakeProfitClosedGamesPercentage?: number | null
    totalStopLossClosedGames: number
    totalStopLossClosedGamesPercentage?: number | null
    totalRejectedGames: number
    totalRejectedGamesPercentage?: number | null
  }
  getUserBullseyePredictsStatistic: {
    __typename?: 'UserBullseyePredictsStatistic'
    totalGames: number
    totalWins: number
    winPercentage: number
    earned?: number | null
  }
  getUserUpDownPredictsStatistic: {
    __typename?: 'UserUpDownPredictsStatistic'
    totalGames: number
    totalWins: number
    winPercentage: number
    earned?: number | null
  }
  getUserOneVsOnePredictsStatistic: {
    __typename?: 'UserOneVsOnePredictsStatistic'
    totalGames: number
    totalWins: number
    winPercentage: number
    earned?: number | null
  }
  getUserUpDownAiPredictsStatistic: {
    __typename?: 'UserUpDownAiPredictsStatistic'
    totalGames: number
    totalWins: number
    winPercentage: number
    earned?: number | null
  }
}

export type GetUserGamesWinratesHistoryStubQueryVariables = Exact<{
  [key: string]: never
}>

export type GetUserGamesWinratesHistoryStubQuery = { __typename: 'Query' }

export type ClaimCashbackMutationVariables = Exact<{
  periodId: Scalars['String']['input']
}>

export type ClaimCashbackMutation = {
  __typename?: 'Mutation'
  claimCashback: {
    __typename?: 'CashbackRequest'
    id: string
    userLevelId: string
    status: CashbackStatus
    amount: number
    commissionsPaid: number
    cashbackPeriodId: string
    txHash?: string | null
    userLevel?: {
      __typename?: 'UserLevel'
      id: string
      commissionsPaid: number
      levelId?: number | null
      userId: string
      claimedOnLevel?: number | null
      isCashBackReceived?: boolean | null
      requestedOnCashBackValue?: number | null
      txHash?: string | null
      progressPercent?: number | null
    } | null
    period?: {
      __typename?: 'CashbackPeriods'
      id: string
      startDate: number
      endDate: number
    } | null
  }
}

export type AttachDiscordMutationVariables = Exact<{
  data: AttachDiscordInput
}>

export type AttachDiscordMutation = {
  __typename?: 'Mutation'
  attachDiscord: any
}

export type AttachTwitterMutationVariables = Exact<{
  data: AttachTwitterInput
}>

export type AttachTwitterMutation = {
  __typename?: 'Mutation'
  attachTwitter: any
}

export type UpdateAvatarMutationVariables = Exact<{
  file: Scalars['Upload']['input']
}>

export type UpdateAvatarMutation = {
  __typename?: 'Mutation'
  updateAvatar: {
    __typename?: 'User'
    avatarKeys: Array<string>
    avatarUris: Array<string>
  }
}

export type UpdateUserBioMutationVariables = Exact<{
  bio: Scalars['String']['input']
}>

export type UpdateUserBioMutation = {
  __typename?: 'Mutation'
  updateUser: { __typename?: 'User'; bio: string }
}

export type UpdateUserNameMutationVariables = Exact<{
  name: Scalars['String']['input']
}>

export type UpdateUserNameMutation = {
  __typename?: 'Mutation'
  updateUser: { __typename?: 'User'; name: string }
}

export type ChangePasswordStubQueryVariables = Exact<{ [key: string]: never }>

export type ChangePasswordStubQuery = { __typename: 'Query' }

export type DeleteAvatarMutationVariables = Exact<{ [key: string]: never }>

export type DeleteAvatarMutation = {
  __typename?: 'Mutation'
  deleteAvatar: { __typename?: 'User' } & {
    ' $fragmentRefs'?: { MeFragment: MeFragment }
  }
}

export type GetDiscordLinkUriQueryVariables = Exact<{
  data: GetDiscordAuthUriInput
}>

export type GetDiscordLinkUriQuery = {
  __typename?: 'Query'
  getDiscordAuthUri: string
}

export type GetNotificationsPoliciesQueryVariables = Exact<{
  [key: string]: never
}>

export type GetNotificationsPoliciesQuery = {
  __typename?: 'Query'
  getNotificationsPolicies: {
    __typename?: 'EmailNotificationPolicyType'
    sendNotificationsToEmail: boolean
    notifyBetsResult: boolean
    notifyBettingInvitation: boolean
    notifyNewAchievements: boolean
    notifyUpdates: boolean
  }
}

export type GetPrivacyPoliciesQueryVariables = Exact<{ [key: string]: never }>

export type GetPrivacyPoliciesQuery = {
  __typename?: 'Query'
  getPrivacyPolicies: {
    __typename?: 'PrivacyPolicyType'
    showProfile: boolean
    showAchievements: boolean
    showSetups: boolean
    showStats: boolean
    showBettingHistory: boolean
    allowTagInChat: boolean
    allowInviteIn1vs1Game: boolean
  }
}

export type GetTwitterLinkUriQueryVariables = Exact<{
  data: GetTwitterAuthUriInput
}>

export type GetTwitterLinkUriQuery = {
  __typename?: 'Query'
  getTwitterAuthUri: string
}

export type UpdateNotificationsPolicyMutationVariables = Exact<{
  changes: ChangeEmailNotificationPolicyInput
}>

export type UpdateNotificationsPolicyMutation = {
  __typename?: 'Mutation'
  updateNotificationsPolicy: {
    __typename?: 'EmailNotificationPolicyType'
    sendNotificationsToEmail: boolean
    notifyBetsResult: boolean
    notifyBettingInvitation: boolean
    notifyNewAchievements: boolean
    notifyUpdates: boolean
  }
}

export type UpdatePrivacyPolicyMutationVariables = Exact<{
  changes: ChangePrivacyPolicyInput
}>

export type UpdatePrivacyPolicyMutation = {
  __typename?: 'Mutation'
  updatePrivacyPolicy: {
    __typename?: 'PrivacyPolicyType'
    showProfile: boolean
    showAchievements: boolean
    showSetups: boolean
    showStats: boolean
    showBettingHistory: boolean
  }
}

export type LinkWalletChallengeMutationVariables = Exact<{
  walletAddress: Scalars['String']['input']
}>

export type LinkWalletChallengeMutation = {
  __typename?: 'Mutation'
  linkWalletChallenge: { __typename?: 'WalletLinkChallenge'; challenge: string }
}

export type LinkWalletMutationVariables = Exact<{
  walletAddress: Scalars['String']['input']
  signature: Scalars['String']['input']
}>

export type LinkWalletMutation = {
  __typename?: 'Mutation'
  linkWallet: {
    __typename?: 'UserWallet'
    id: string
    address: string
    isPrimary: boolean
    createdAt: string
  }
}

export const MeSocialFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeSocial' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discordRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInfluencer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryWalletAddress' }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wallets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discord' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'twitter' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<MeSocialFragment, unknown>
export const MeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Me' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discordRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInfluencer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'level' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'levelId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryWalletAddress' }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wallets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPlayed' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<MeFragment, unknown>
export const BullsEyeGameFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BullsEyeGame' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BullseyeGame' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopPredictAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contractAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPredicts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'place' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isExact' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'predicts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'place' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isExact' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<BullsEyeGameFragment, unknown>
export const SetupsGamePoolFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsGamePool' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupGamePoolInfo' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'predictsCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SetupsGamePoolFragment, unknown>
export const SetupsPredictShallowFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsPredictShallow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupPredict' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SetupsPredictShallowFragment, unknown>
export const SetupsGameFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsGame' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupGame' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'takeProfitPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stopLossPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelId' }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPredict' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsPredictShallow' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopLoss' } },
          { kind: 'Field', name: { kind: 'Name', value: 'takeProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopPredictAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contractAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsPredictShallow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupPredict' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SetupsGameFragment, unknown>
export const SetupsGameOwnerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsGameOwner' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'level' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'levelId' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SetupsGameOwnerFragment, unknown>
export const SetupsPredictFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsPredict' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupPredict' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'game' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stopLoss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'takeProfit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contractAddress' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopLossPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multiplier' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'takeProfitPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multiplier' }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsGameOwner' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'playerAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRetrieved' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsGameOwner' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'level' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'levelId' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SetupsPredictFragment, unknown>
export const RewardStatsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RewardStats' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Reward' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referralRewards' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentPlace' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rewardsForChallenges' }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastPlaceOnLeaderboard' }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RewardStatsFragment, unknown>
export const RewardUserFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RewardUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discordRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInfluencer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RewardUserFragment, unknown>
export const RewardBaseFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RewardBase' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Reward' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rewards' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentPlace' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeChange' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RewardBaseFragment, unknown>
export const RewardWithUserFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RewardWithUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Reward' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'RewardBase' }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarKeys' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discordRoles' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isInfluencer' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RewardBase' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Reward' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rewards' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentPlace' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeChange' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RewardWithUserFragment, unknown>
export const UserShallowFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserShallow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInfluencer' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UserShallowFragment, unknown>
export const AssetPayloadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assetPayload' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AssetPricesInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assetPrices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'payload' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<AssetPayloadQuery, AssetPayloadQueryVariables>
export const TouchAttributionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'touchAttribution' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'touchAttribution' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  TouchAttributionMutation,
  TouchAttributionMutationVariables
>
export const CheckReferralAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'checkReferralAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckReferralAvalabilityInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checkReferralAvalability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CheckReferralAvailabilityQuery,
  CheckReferralAvailabilityQueryVariables
>
export const CheckNameAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'checkNameAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckNameAvailabilityInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checkNameAvailability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CheckNameAvailabilityQuery,
  CheckNameAvailabilityQueryVariables
>
export const GetReferralDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getReferral' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getReferral' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetReferralQuery, GetReferralQueryVariables>
export const SignoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'signout' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'signout' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SignoutMutation, SignoutMutationVariables>
export const MeSocialDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'meSocial' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeSocial' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeSocial' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discordRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInfluencer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryWalletAddress' }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wallets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discord' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'twitter' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<MeSocialQuery, MeSocialQueryVariables>
export const MeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'me' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Me' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Me' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discordRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInfluencer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'level' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'levelId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryWalletAddress' }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wallets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPlayed' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<MeQuery, MeQueryVariables>
export const SignInPrivyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'signInPrivy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SignInPrivyInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signInPrivy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SignInPrivyMutation, SignInPrivyMutationVariables>
export const GetRakebackSummaryStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getRakebackSummaryStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetRakebackSummaryStubQuery,
  GetRakebackSummaryStubQueryVariables
>
export const GetUserBlockchainBalancesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserBlockchainBalances' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserBlockchainBalances' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'walletAddress' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nativeBalance' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenBalance' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenDeposited' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chainIdentifier' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserBlockchainBalancesQuery,
  GetUserBlockchainBalancesQueryVariables
>
export const GetUserPendingRakebackGamesStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserPendingRakebackGamesStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserPendingRakebackGamesStubQuery,
  GetUserPendingRakebackGamesStubQueryVariables
>
export const GetUserPendingSetupGamesStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserPendingSetupGamesStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserPendingSetupGamesStubQuery,
  GetUserPendingSetupGamesStubQueryVariables
>
export const ForceUpdateUserBlockchainBalanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'forceUpdateUserBlockchainBalance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'walletAddress' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'forceUpdateUserBlockchainBalance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'walletAddress' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'walletAddress' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'walletAddress' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nativeBalance' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenBalance' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenDeposited' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chainIdentifier' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ForceUpdateUserBlockchainBalanceMutation,
  ForceUpdateUserBlockchainBalanceMutationVariables
>
export const UserBlockchainBalanceChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'userBlockchainBalanceChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userBlockchainBalanceChanged' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'walletAddress' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nativeBalance' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenBalance' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tokenDeposited' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chainIdentifier' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UserBlockchainBalanceChangedSubscription,
  UserBlockchainBalanceChangedSubscriptionVariables
>
export const GetCurrentOnlineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCurrentOnline' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'getCurrentOnline' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetCurrentOnlineQuery,
  GetCurrentOnlineQueryVariables
>
export const GetRoomByTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getRoomByType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GetRoom' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRoomByType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetRoomByTypeQuery, GetRoomByTypeQueryVariables>
export const GetRoomMessagesPaginatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getRoomMessagesPaginated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GetRoomMessages' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRoomMessagesPaginated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prevToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextToken' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sender' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarKeys' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'discordRoles' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roomId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'replyTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetRoomMessagesPaginatedQuery,
  GetRoomMessagesPaginatedQueryVariables
>
export const SendMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'sendMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SendMessageInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarKeys' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discordRoles' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'roomId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'replyTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendMessageMutation, SendMessageMutationVariables>
export const OnlineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'online' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'online' } }]
      }
    }
  ]
} as unknown as DocumentNode<OnlineSubscription, OnlineSubscriptionVariables>
export const RoomMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'roomMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'roomId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roomMessages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roomId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'roomId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarKeys' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discordRoles' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'roomId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'replyTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  RoomMessagesSubscription,
  RoomMessagesSubscriptionVariables
>
export const SetConsentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setConsent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConsentInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setConsent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SetConsentMutation, SetConsentMutationVariables>
export const FragmentBetShallowStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fragmentBetShallowStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  FragmentBetShallowStubQuery,
  FragmentBetShallowStubQueryVariables
>
export const GetNotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getNotifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PaginatedInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getNotifications' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notifications' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' }
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'SetupGameClosedNotification'
                          }
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isRead' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'payload' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gameId' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ownerProfit' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'OneVsOneAcceptedNotification'
                          }
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isRead' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'payload' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gameId' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'opponentId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'OneVsOneRefusedNotification'
                          }
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isRead' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'payload' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gameId' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'opponentId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'OneVsOneInvitationNotification'
                          }
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isRead' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'payload' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gameId' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'opponentId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'HotNotification' }
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isRead' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'updatedAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userId' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'BonusNotification' }
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isRead' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'assetId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'MentionNotification' }
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isRead' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'messageId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userId' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'GameResultNotification'
                          }
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isRead' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'payload' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' }
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value:
                                          'UpDownGameResultNotificationPayload'
                                      }
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'gameType'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outcome'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'status'
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value:
                                          'SetupGameResultNotificationPayload'
                                      }
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'gameType'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outcome'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'status'
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value:
                                          'OneVsOneGameResultNotificationPayload'
                                      }
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'gameType'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'opponent'
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outcome'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'status'
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value:
                                          'BullseyeGameResultNotificationPayload'
                                      }
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'gameType'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'winner'
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id'
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'isExact'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outcome'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'status'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'winnerOutcome'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetNotificationsQuery,
  GetNotificationsQueryVariables
>
export const GetVolumeOfThePreviousDayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getVolumeOfThePreviousDay' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'contractAddress' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getVolumeOfThePreviousDay' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contractAddress' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'contractAddress' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'volume' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetVolumeOfThePreviousDayQuery,
  GetVolumeOfThePreviousDayQueryVariables
>
export const GetSmartContractsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSmartContracts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSmartContracts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contractName' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contracts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'active' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'chainIdentifier' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'chainType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contractAddress' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contractName' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fee' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ownerFee' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'token' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'asset' }
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'isMultiParticipation'
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'version' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetSmartContractsQuery,
  GetSmartContractsQueryVariables
>
export const GetUnreadNotificationsCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUnreadNotificationsCount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUnreadNotificationsCount' }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUnreadNotificationsCountQuery,
  GetUnreadNotificationsCountQueryVariables
>
export const MarkNotificationsReadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'markNotificationsRead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MarkNotificationsAsReadInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markNotificationsRead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  MarkNotificationsReadMutation,
  MarkNotificationsReadMutationVariables
>
export const OnVolumeChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'onVolumeChanged' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'contractAddress' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onVolumeChanged' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contractAddress' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'contractAddress' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'volume' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  OnVolumeChangedSubscription,
  OnVolumeChangedSubscriptionVariables
>
export const NotificationsListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'notificationsList' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notificationsList' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SetupGameClosedNotification' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payload' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ownerProfit' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'OneVsOneAcceptedNotification'
                    }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payload' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opponentId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OneVsOneRefusedNotification' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payload' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opponentId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'OneVsOneInvitationNotification'
                    }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payload' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opponentId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HotNotification' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BonusNotification' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assetId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' }
                      }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MentionNotification' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageId' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'GameResultNotification' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payload' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' }
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'UpDownGameResultNotificationPayload'
                                }
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gameType' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'outcome' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'SetupGameResultNotificationPayload'
                                }
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gameType' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'outcome' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'OneVsOneGameResultNotificationPayload'
                                }
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gameType' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'opponent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'outcome' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'opponent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'avatarKeys'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'BullseyeGameResultNotificationPayload'
                                }
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gameType' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'winner' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isExact' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'outcome' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'winnerOutcome'
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'winner' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'avatarKeys'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  NotificationsListSubscription,
  NotificationsListSubscriptionVariables
>
export const NotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'notifications' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SetupGameClosedNotification' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payload' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ownerProfit' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'OneVsOneAcceptedNotification'
                    }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payload' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opponentId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OneVsOneRefusedNotification' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payload' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opponentId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'OneVsOneInvitationNotification'
                    }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payload' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opponentId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HotNotification' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BonusNotification' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assetId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' }
                      }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MentionNotification' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageId' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } }
                    ]
                  }
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'GameResultNotification' }
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isRead' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payload' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' }
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'UpDownGameResultNotificationPayload'
                                }
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gameType' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'outcome' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'SetupGameResultNotificationPayload'
                                }
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gameType' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'outcome' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'OneVsOneGameResultNotificationPayload'
                                }
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gameType' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'opponent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'outcome' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'opponent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'avatarKeys'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'BullseyeGameResultNotificationPayload'
                                }
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gameType' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'winner' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isExact' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'outcome' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'winnerOutcome'
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'winner' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'avatarKeys'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  NotificationsSubscription,
  NotificationsSubscriptionVariables
>
export const CreateGuestSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createGuestSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CreateGuestSessionInput' }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createGuestSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'claimedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CreateGuestSessionMutation,
  CreateGuestSessionMutationVariables
>
export const GetGuestSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getGuestSession' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getGuestSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'claimedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetGuestSessionQuery,
  GetGuestSessionQueryVariables
>
export const MergeGuestSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'mergeGuestSession' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mergeGuestSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'alreadyClaimed' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roundsMigrated' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'wins' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'upDown' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roundsMigrated' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'wins' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scoreMigrated' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rankDaily' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rankWeekly' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rankAlltime' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'upDownAi' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roundsMigrated' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'wins' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scoreMigrated' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rankDaily' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rankWeekly' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rankAlltime' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bullseye' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roundsMigrated' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'wins' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scoreMigrated' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'settledRounds' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exactHits' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avgErrorPct' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rankDaily' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rankWeekly' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rankAlltime' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  MergeGuestSessionMutation,
  MergeGuestSessionMutationVariables
>
export const GetLiveWinsPredictsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getLiveWinsPredicts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getLiveWinsPredicts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'skip' },
                      value: { kind: 'IntValue', value: '0' }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'take' },
                      value: { kind: 'IntValue', value: '10' }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predicts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'game' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contractAddress' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetLiveWinsPredictsQuery,
  GetLiveWinsPredictsQueryVariables
>
export const LiveWinsPredictsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'liveWinsPredicts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'liveWinsPredicts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  LiveWinsPredictsSubscription,
  LiveWinsPredictsSubscriptionVariables
>
export const ListAssetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'listAssets' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'precision' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'price' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formattedValue' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payload' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'last7days' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formattedValue' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timestamp' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'price24h' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formattedValue' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timestamp' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'supportedResolutions' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ListAssetsQuery, ListAssetsQueryVariables>
export const GetCurrentRaceGameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCurrentRaceGame' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RaceContractAddressInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCurrentRaceGame' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopPredictAt' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'commission' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAmount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contractAddress' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedsIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrices' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endPrices' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startTimestamps' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'endTimestamps' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'priceDiffs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wonFeedId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myPredicts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizeTxHash' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bio' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarKeys' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'discordRoles' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isInfluencer' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'level' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predicts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizeTxHash' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bio' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarKeys' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'discordRoles' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isInfluencer' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'level' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetCurrentRaceGameQuery,
  GetCurrentRaceGameQueryVariables
>
export const GetUserRaceGamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserRaceGames' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserRacePredictsInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserRaceGames' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'games' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stopPredictAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startPrice' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endPrice' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeframe' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commission' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contractAddress' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedsIds' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startPrices' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endPrices' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startTimestamps' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endTimestamps' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceDiffs' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wonFeedId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myPredicts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameType' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ownerId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'playerAddress' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pnl' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'finalizeTxHash' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'updatedAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'index' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'feedId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserRaceGamesQuery,
  GetUserRaceGamesQueryVariables
>
export const RaceGameChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'raceGameChanged' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'contractAddress' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'raceGameChanged' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contractAddress' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'contractAddress' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopPredictAt' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'commission' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAmount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contractAddress' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedsIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrices' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endPrices' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startTimestamps' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'endTimestamps' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'priceDiffs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wonFeedId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myPredicts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizeTxHash' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bio' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarKeys' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'discordRoles' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isInfluencer' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'level' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predicts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizeTxHash' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bio' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarKeys' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'discordRoles' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isInfluencer' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'level' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  RaceGameChangedSubscription,
  RaceGameChangedSubscriptionVariables
>
export const AddOneVsOneBetStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'addOneVsOneBetStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  AddOneVsOneBetStubQuery,
  AddOneVsOneBetStubQueryVariables
>
export const CreateOneVsOneGameStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'createOneVsOneGameStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CreateOneVsOneGameStubQuery,
  CreateOneVsOneGameStubQueryVariables
>
export const FindOpponentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'findOpponents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FindUsersInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'findOpponents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryWalletAddress' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelId' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<FindOpponentsQuery, FindOpponentsQueryVariables>
export const GetOneVsOneGamesCountStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOneVsOneGamesCountStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetOneVsOneGamesCountStubQuery,
  GetOneVsOneGamesCountStubQueryVariables
>
export const GetOneVsOneGameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOneVsOneGame' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'getOneVsOneGame' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getOneVsOneGame' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'getOneVsOneGame' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'precision' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrivate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contractAddress' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopPredictAt' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponentPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ownerPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetOneVsOneGameQuery,
  GetOneVsOneGameQueryVariables
>
export const GetOneVsOneGamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOneVsOneGames' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OneVsOneGameFilters' }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pagination' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PaginatedInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getOneVsOneGames' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pagination' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'games' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrivate' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isAccepted' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startPrice' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeframe' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stopPredictAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contractAddress' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opponent' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerPredict' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetOneVsOneGamesQuery,
  GetOneVsOneGamesQueryVariables
>
export const GetOneVsOneUpDownGameStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOneVsOneUpDownGameStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetOneVsOneUpDownGameStubQuery,
  GetOneVsOneUpDownGameStubQueryVariables
>
export const GetOneVsOneUpDownGamesStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOneVsOneUpDownGamesStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetOneVsOneUpDownGamesStubQuery,
  GetOneVsOneUpDownGamesStubQueryVariables
>
export const GetOwnOneVsOneGamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOwnOneVsOneGames' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OneVsOneGameFilters' }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pagination' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PaginatedInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getOwnOneVsOneGames' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pagination' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'games' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrivate' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isAccepted' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startPrice' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeframe' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stopPredictAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contractAddress' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opponent' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opponentPredict' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'playerAddress' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pnl' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'owner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUris' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'level' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'levelId'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerPredict' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'playerAddress' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pnl' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetOwnOneVsOneGamesQuery,
  GetOwnOneVsOneGamesQueryVariables
>
export const GetOwnOneVsOneUpDownGamesStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOwnOneVsOneUpDownGamesStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetOwnOneVsOneUpDownGamesStubQuery,
  GetOwnOneVsOneUpDownGamesStubQueryVariables
>
export const RejectOneVsOneGameStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'rejectOneVsOneGameStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  RejectOneVsOneGameStubQuery,
  RejectOneVsOneGameStubQueryVariables
>
export const RejectOneVsOneGameInvitationStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'rejectOneVsOneGameInvitationStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  RejectOneVsOneGameInvitationStubQuery,
  RejectOneVsOneGameInvitationStubQueryVariables
>
export const OneVsOneGameChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'oneVsOneGameChanged' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'gameId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'oneVsOneGameChanged' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'gameId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'gameId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'precision' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrivate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopPredictAt' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contractAddress' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponentPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ownerPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  OneVsOneGameChangedSubscription,
  OneVsOneGameChangedSubscriptionVariables
>
export const OneVsOneGameCreatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'oneVsOneGameCreated' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'oneVsOneGameCreated' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrivate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contractAddress' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopPredictAt' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ownerPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gameId' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  OneVsOneGameCreatedSubscription,
  OneVsOneGameCreatedSubscriptionVariables
>
export const OneVsOneGamesChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'oneVsOneGamesChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'oneVsOneGamesChanged' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'precision' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isAccepted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrivate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopPredictAt' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponentPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ownerPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  OneVsOneGamesChangedSubscription,
  OneVsOneGamesChangedSubscriptionVariables
>
export const OneVsOneCountGlobalGamesChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'oneVsOneCountGlobalGamesChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'oneVsOneCountGlobalGamesChanged' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'global' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  OneVsOneCountGlobalGamesChangedSubscription,
  OneVsOneCountGlobalGamesChangedSubscriptionVariables
>
export const OneVsOneUpDownGameChangedStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'oneVsOneUpDownGameChangedStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  OneVsOneUpDownGameChangedStubQuery,
  OneVsOneUpDownGameChangedStubQueryVariables
>
export const OneVsOneUpDownGameCreatedStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'oneVsOneUpDownGameCreatedStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  OneVsOneUpDownGameCreatedStubQuery,
  OneVsOneUpDownGameCreatedStubQueryVariables
>
export const OneVsOneCountUserGamesChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'oneVsOneCountUserGamesChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'oneVsOneCountUserGamesChanged' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'personal' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  OneVsOneCountUserGamesChangedSubscription,
  OneVsOneCountUserGamesChangedSubscriptionVariables
>
export const GetBullsEyeGameModesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getBullsEyeGameModes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBullseyeGameModes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timeframeSec' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exactRange' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'precision' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'feedId' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'current' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modeId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exactRange' }
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BullsEyeGame' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BullsEyeGame' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BullseyeGame' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopPredictAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contractAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPredicts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'place' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isExact' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'predicts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'place' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isExact' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetBullsEyeGameModesQuery,
  GetBullsEyeGameModesQueryVariables
>
export const GetBullsEyeLeaderboardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getBullsEyeLeaderboard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BullseyeLeaderboardInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBullseyeLeaderboard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'periodStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'periodEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exactHits' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'settledRounds' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetBullsEyeLeaderboardQuery,
  GetBullsEyeLeaderboardQueryVariables
>
export const GetCurrentBullsEyeGameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCurrentBullsEyeGame' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BullseyeModeIdInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCurrentBullseyeGame' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'modeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exactRange' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BullsEyeGame' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BullsEyeGame' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BullseyeGame' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopPredictAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contractAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPredicts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'place' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isExact' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'predicts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'place' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isExact' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetCurrentBullsEyeGameQuery,
  GetCurrentBullsEyeGameQueryVariables
>
export const GetDemoBullseyeQuotaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getDemoBullseyeQuota' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDemoBullseyeQuota' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roundsPlayed' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'roundsLeft' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canPlay' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetDemoBullseyeQuotaQuery,
  GetDemoBullseyeQuotaQueryVariables
>
export const GetMyBullsEyeLeaderboardPositionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMyBullsEyeLeaderboardPosition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'period' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BullseyeLeaderboardPeriod' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getMyBullseyeLeaderboardPosition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'period' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'period' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exactHits' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settledRounds' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetMyBullsEyeLeaderboardPositionQuery,
  GetMyBullsEyeLeaderboardPositionQueryVariables
>
export const GetUserBullseyePredictsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserBullseyePredicts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserBullseyePredictsInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserBullseyePredicts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predicts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'playerAddress' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'place' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isExact' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'game' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modeId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'feedId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endPrice' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contractAddress' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pool' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'predictsCount'
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserBullseyePredictsQuery,
  GetUserBullseyePredictsQueryVariables
>
export const BullsEyeLeaderboardChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'bullsEyeLeaderboardChanged' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'period' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BullseyeLeaderboardPeriod' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bullseyeLeaderboardChanged' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'period' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'period' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'periodChanged' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  BullsEyeLeaderboardChangedSubscription,
  BullsEyeLeaderboardChangedSubscriptionVariables
>
export const MyBullsEyeLeaderboardPositionChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'myBullsEyeLeaderboardPositionChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'myBullseyeLeaderboardPositionChanged'
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rankDelta' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exactHits' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settledRounds' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  MyBullsEyeLeaderboardPositionChangedSubscription,
  MyBullsEyeLeaderboardPositionChangedSubscriptionVariables
>
export const BullsEyeGameStateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'bullsEyeGameState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'modeId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bullseyeGameChanged' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'modeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'modeId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BullsEyeGame' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BullsEyeGame' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BullseyeGame' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopPredictAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contractAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPredicts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'place' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isExact' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'predicts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'place' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isExact' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  BullsEyeGameStateSubscription,
  BullsEyeGameStateSubscriptionVariables
>
export const GetSetupPredictsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSetupPredicts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pagination' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PaginatedInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSetupPredicts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pagination' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predicts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SetupsPredict' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsGameOwner' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'level' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'levelId' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsPredict' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupPredict' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'game' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stopLoss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'takeProfit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contractAddress' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopLossPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multiplier' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'takeProfitPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multiplier' }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsGameOwner' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'playerAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRetrieved' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetSetupPredictsQuery,
  GetSetupPredictsQueryVariables
>
export const GetSetupGameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSetupGame' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSetupGame' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsGame' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsPredictShallow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupPredict' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsGame' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupGame' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'takeProfitPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stopLossPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelId' }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPredict' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsPredictShallow' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopLoss' } },
          { kind: 'Field', name: { kind: 'Name', value: 'takeProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopPredictAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contractAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetSetupGameQuery, GetSetupGameQueryVariables>
export const GetSetupGamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSetupGames' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SetupGameFilters' }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pagination' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PaginatedInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSetupGames' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pagination' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'games' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SetupsGame' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsPredictShallow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupPredict' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsGame' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupGame' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'takeProfitPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stopLossPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelId' }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPredict' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsPredictShallow' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopLoss' } },
          { kind: 'Field', name: { kind: 'Name', value: 'takeProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopPredictAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contractAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetSetupGamesQuery, GetSetupGamesQueryVariables>
export const GetUserSetupGamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserSetupGames' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SetupGameFilters' }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pagination' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PaginatedInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserSetupGames' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pagination' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'games' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SetupsGame' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerProfit' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startAt' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsPredictShallow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupPredict' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsGame' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupGame' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'takeProfitPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stopLossPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelId' }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPredict' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsPredictShallow' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopLoss' } },
          { kind: 'Field', name: { kind: 'Name', value: 'takeProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopPredictAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contractAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserSetupGamesQuery,
  GetUserSetupGamesQueryVariables
>
export const GetSetupsUserPredictsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSetupsUserPredicts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SetupPredictFilters' }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pagination' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PaginatedInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserSetupPredicts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pagination' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predicts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SetupsPredict' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsGameOwner' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'level' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'levelId' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsPredict' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupPredict' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'game' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stopLoss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'takeProfit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contractAddress' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopLossPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multiplier' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'takeProfitPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multiplier' }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsGameOwner' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'playerAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRetrieved' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetSetupsUserPredictsQuery,
  GetSetupsUserPredictsQueryVariables
>
export const SetupsGameChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'setupsGameChanged' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'gameId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setupGameChanged' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'gameId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'gameId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsGame' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsPredictShallow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupPredict' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsGame' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupGame' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'takeProfitPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stopLossPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelId' }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPredict' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsPredictShallow' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopLoss' } },
          { kind: 'Field', name: { kind: 'Name', value: 'takeProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopPredictAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contractAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  SetupsGameChangedSubscription,
  SetupsGameChangedSubscriptionVariables
>
export const SetupGamesChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'setupGamesChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setupGamesChanged' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsGame' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsPredictShallow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupPredict' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsGame' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupGame' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'takeProfitPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stopLossPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelId' }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPredict' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsPredictShallow' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopLoss' } },
          { kind: 'Field', name: { kind: 'Name', value: 'takeProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopPredictAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contractAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  SetupGamesChangedSubscription,
  SetupGamesChangedSubscriptionVariables
>
export const CreatedSetupGameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'createdSetupGame' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setupGameCreated' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsGame' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsPredictShallow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupPredict' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsGame' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupGame' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'takeProfitPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stopLossPool' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predictsCount' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'poolAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelId' }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPredict' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsPredictShallow' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopLoss' } },
          { kind: 'Field', name: { kind: 'Name', value: 'takeProfit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stopPredictAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contractAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'asset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CreatedSetupGameSubscription,
  CreatedSetupGameSubscriptionVariables
>
export const UserSetupPredictsChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'userSetupPredictsChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSetupPredictsChanged' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsPredict' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsGameOwner' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'level' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'levelId' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SetupsPredict' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SetupPredict' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'game' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stopLoss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'takeProfit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contractAddress' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopLossPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multiplier' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'takeProfitPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multiplier' }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SetupsGameOwner' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'playerAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRetrieved' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UserSetupPredictsChangedSubscription,
  UserSetupPredictsChangedSubscriptionVariables
>
export const AddDemoUpDownAiPredictDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addDemoUpDownAiPredict' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddDemoUpDownAiPredictInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addDemoUpDownAiPredict' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'winStreakLength' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  AddDemoUpDownAiPredictMutation,
  AddDemoUpDownAiPredictMutationVariables
>
export const CreateDemoUpDownAiGameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createDemoUpDownAiGame' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateDemoUpDownAiGameInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDemoUpDownAiGame' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopPredictAt' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'commission' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponentUserId' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'deposit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'difficulty' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'feedId' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commission' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isLong' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'winStreakLength' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponentPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commission' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isLong' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'winStreakLength' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CreateDemoUpDownAiGameMutation,
  CreateDemoUpDownAiGameMutationVariables
>
export const GetCurrentDemoUpDownAiGameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCurrentDemoUpDownAiGame' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCurrentDemoUpDownAiGame' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopPredictAt' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'commission' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponentUserId' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'deposit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'difficulty' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'feedId' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commission' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isLong' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'winStreakLength' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponentPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commission' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isLong' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'winStreakLength' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetCurrentDemoUpDownAiGameQuery,
  GetCurrentDemoUpDownAiGameQueryVariables
>
export const GetDemoUpDownAiGameByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getDemoUpDownAiGameById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'gameId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDemoUpDownAiGameById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'gameId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'gameId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopPredictAt' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'commission' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponentUserId' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'deposit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'difficulty' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'feedId' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commission' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isLong' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'winStreakLength' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponentPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commission' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isLong' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'winStreakLength' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetDemoUpDownAiGameByIdQuery,
  GetDemoUpDownAiGameByIdQueryVariables
>
export const GetDemoUpDownAiQuotaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getDemoUpDownAiQuota' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDemoUpDownAiQuota' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roundsPlayed' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'roundsLeft' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canPlay' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetDemoUpDownAiQuotaQuery,
  GetDemoUpDownAiQuotaQueryVariables
>
export const GetDemoUpDownAiSessionStatisticDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getDemoUpDownAiSessionStatistic' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDemoUpDownAiSessionStatistic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalGames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalWins' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'winPercentage' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentStreak' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'bestStreak' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'projectedDaily' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRanked' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'projectedWeekly' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRanked' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'projectedAlltime' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRanked' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetDemoUpDownAiSessionStatisticQuery,
  GetDemoUpDownAiSessionStatisticQueryVariables
>
export const GetGuestDemoUpDownAiGamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getGuestDemoUpDownAiGames' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GuestDemoUpDownAiGamesInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getGuestDemoUpDownAiGames' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'games' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUp' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deposit' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startPrice' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endPrice' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myPredict' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pnl' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLong' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'winStreakLength' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetGuestDemoUpDownAiGamesQuery,
  GetGuestDemoUpDownAiGamesQueryVariables
>
export const DemoUpDownAiGameChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'demoUpDownAiGameChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'demoUpDownAiGameChanged' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  DemoUpDownAiGameChangedSubscription,
  DemoUpDownAiGameChangedSubscriptionVariables
>
export const FindUpDownAiOpponentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'findUpDownAiOpponents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FindUpDownAiOpponentsInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'findUpDownAiOpponents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'difficulty' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  FindUpDownAiOpponentsQuery,
  FindUpDownAiOpponentsQueryVariables
>
export const GetCurrentUpDownAiGamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCurrentUpDownAiGames' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpDownAiCurrentGamesInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCurrentUpDownAiGames' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'games' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stopPredictAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startPrice' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endPrice' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeframe' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contractAddress' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commission' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUp' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opponentId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deposit' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'difficulty' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asset' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'feedId' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opponent' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerPredict' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameType' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ownerId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pnl' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'updatedAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLong' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'winStreakLength' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opponentPredict' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameType' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ownerId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pnl' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'updatedAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLong' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'winStreakLength' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetCurrentUpDownAiGamesQuery,
  GetCurrentUpDownAiGamesQueryVariables
>
export const GetMyUpDownAiLeaderboardPositionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMyUpDownAiLeaderboardPosition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'period' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpDownAiLeaderboardPeriod' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getMyUpDownAiLeaderboardPosition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'period' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'period' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'winRate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settledRounds' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentStreak' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'bestStreak' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetMyUpDownAiLeaderboardPositionQuery,
  GetMyUpDownAiLeaderboardPositionQueryVariables
>
export const GetUpDownAiGameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUpDownAiGame' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUpDownAiGame' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopPredictAt' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contractAddress' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'commission' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'opponentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deposit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'difficulty' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'feedId' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUris' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelId' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ownerPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isLong' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'winStreakLength' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opponentPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isLong' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'winStreakLength' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUpDownAiGameQuery,
  GetUpDownAiGameQueryVariables
>
export const GetUpDownAiGamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUpDownAiGames' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpDownAiGameFilters' }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pagination' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PaginatedInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUpDownAiGames' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pagination' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'games' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stopPredictAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startPrice' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endPrice' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeframe' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contractAddress' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commission' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUp' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opponentId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deposit' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'difficulty' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asset' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'feedId' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opponent' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerPredict' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ownerId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'playerAddress' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pnl' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLong' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'winStreakLength' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opponentPredict' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gameId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ownerId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'playerAddress' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pnl' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLong' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'winStreakLength' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUpDownAiGamesQuery,
  GetUpDownAiGamesQueryVariables
>
export const GetUpDownAiLeaderboardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUpDownAiLeaderboard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpDownAiLeaderboardInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUpDownAiLeaderboard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'periodStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'periodEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'winRate' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'settledRounds' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentStreak' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bestStreak' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUpDownAiLeaderboardQuery,
  GetUpDownAiLeaderboardQueryVariables
>
export const GetUserUpDownAiPredictsStatisticDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserUpDownAiPredictsStatistic' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserUpDownAiPredictsStatistic' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalGames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalWins' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'winPercentage' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'earned' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserUpDownAiPredictsStatisticQuery,
  GetUserUpDownAiPredictsStatisticQueryVariables
>
export const GetUserUpDownAiPredictsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserUpDownAiPredicts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserUpDownAiPredictsInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserUpDownAiPredicts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predicts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'playerAddress' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isLong' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'winStreakLength' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'game' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startPrice' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endPrice' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isUp' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commission' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contractAddress' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'feedId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deposit' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserUpDownAiPredictsQuery,
  GetUserUpDownAiPredictsQueryVariables
>
export const SignUpDownAiGameCreationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'signUpDownAiGameCreation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SignUpDownAiGameCreationInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signUpDownAiGameCreation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'signer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signature' } },
                { kind: 'Field', name: { kind: 'Name', value: 'opponent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mint' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopPredictAt' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'minDeposit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feeBps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nonce' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unverifiedReport' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verifierAccount' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accessController' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verifierConfig' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verifierProgram' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chainlinkVerifierProgram' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feedWhitelist' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lookupTable' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  SignUpDownAiGameCreationMutation,
  SignUpDownAiGameCreationMutationVariables
>
export const MyUpDownAiLeaderboardPositionChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'myUpDownAiLeaderboardPositionChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'myUpDownAiLeaderboardPositionChanged'
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rankDelta' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'winRate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settledRounds' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentStreak' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'bestStreak' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  MyUpDownAiLeaderboardPositionChangedSubscription,
  MyUpDownAiLeaderboardPositionChangedSubscriptionVariables
>
export const UpDownAiGameChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'upDownAiGameChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upDownAiGameChanged' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpDownAiGameChangedSubscription,
  UpDownAiGameChangedSubscriptionVariables
>
export const UpDownAiLeaderboardChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'upDownAiLeaderboardChanged' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'period' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpDownAiLeaderboardPeriod' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upDownAiLeaderboardChanged' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'period' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'period' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'periodChanged' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpDownAiLeaderboardChangedSubscription,
  UpDownAiLeaderboardChangedSubscriptionVariables
>
export const GetLastClosedUpDownGamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getLastClosedUpDownGames' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpDownContractAddressInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getLastClosedUpDownGames' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'games' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isUp' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startPrice' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endPrice' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetLastClosedUpDownGamesQuery,
  GetLastClosedUpDownGamesQueryVariables
>
export const GetCurrentUpDownGameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCurrentUpDownGame' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpDownContractAddressInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCurrentUpDownGame' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopPredictAt' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contractAddress' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLong' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'upPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predicts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLong' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'owner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUris' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'level' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'levelId'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'downPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predicts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLong' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'owner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUris' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'level' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'levelId'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetCurrentUpDownGameQuery,
  GetCurrentUpDownGameQueryVariables
>
export const GetUserUpDownPredictsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserUpDownPredicts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserUpDownPredictsInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserUpDownPredicts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'predicts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'playerAddress' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'winStreakLength' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isLong' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'game' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startPrice' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endPrice' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commission' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contractAddress' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'upPool' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'predictsCount'
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'poolAmount' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'downPool' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'predictsCount'
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'poolAmount' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserUpDownPredictsQuery,
  GetUserUpDownPredictsQueryVariables
>
export const UpDownGameChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'upDownGameChanged' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'contractAddress' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upDownGameChanged' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contractAddress' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'contractAddress' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gameType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stopPredictAt' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeframe' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contractAddress' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myPredict' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ownerId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isLong' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'upPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predicts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLong' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'owner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUris' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'level' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'levelId'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'downPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predictsCount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'poolAmount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'predicts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLong' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'owner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUris' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'level' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'levelId'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpDownGameChangedSubscription,
  UpDownGameChangedSubscriptionVariables
>
export const CreateCoinAddressStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'createCoinAddressStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CreateCoinAddressStubQuery,
  CreateCoinAddressStubQueryVariables
>
export const GetUserBalanceOperationsStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserBalanceOperationsStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserBalanceOperationsStubQuery,
  GetUserBalanceOperationsStubQueryVariables
>
export const CoinListStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'coinListStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CoinListStubQuery, CoinListStubQueryVariables>
export const ListCoinAddressesStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'listCoinAddressesStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ListCoinAddressesStubQuery,
  ListCoinAddressesStubQueryVariables
>
export const CoinRatesStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'coinRatesStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CoinRatesStubQuery, CoinRatesStubQueryVariables>
export const ListTransactionsStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'listTransactionsStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ListTransactionsStubQuery,
  ListTransactionsStubQueryVariables
>
export const WithdrawalStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'withdrawalStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<WithdrawalStubQuery, WithdrawalStubQueryVariables>
export const AssetPricesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assetPrices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AssetPricesInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assetPrices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'formattedValue' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<AssetPricesQuery, AssetPricesQueryVariables>
export const PriceRangeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'priceRange' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AssetPricesRangeInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'priceRange' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'formattedValue' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<PriceRangeQuery, PriceRangeQueryVariables>
export const AssetPriceChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'assetPriceChanged' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assetId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assetPriceChanged' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assetId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'assetId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'formattedValue' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'payload' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  AssetPriceChangedSubscription,
  AssetPriceChangedSubscriptionVariables
>
export const GetOwnReferralWithdrawRequestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOwnReferralWithdrawRequests' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getOwnReferralWithdrawRequests' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'ObjectValue', fields: [] }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'skip' },
                      value: { kind: 'IntValue', value: '0' }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'take' },
                      value: { kind: 'IntValue', value: '5' }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'take' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requests' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancelReason' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionHash' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetOwnReferralWithdrawRequestsQuery,
  GetOwnReferralWithdrawRequestsQueryVariables
>
export const GetProfitForReferralsPredictsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProfitForReferralsPredicts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProfitForReferralsPredicts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'availableProfitAmountToWithdraw'
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'minProfitAmountToWithdraw' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetProfitForReferralsPredictsQuery,
  GetProfitForReferralsPredictsQueryVariables
>
export const CreateWithdrawRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createWithdrawRequest' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createWithdrawRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CreateWithdrawRequestMutation,
  CreateWithdrawRequestMutationVariables
>
export const GetUserDailyTasksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserDailyTasks' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserDailyTasks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facetedTasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'number' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reward' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userRelatedTask' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'taskId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'progress' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isBonusReceived' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isCompleted' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requirement' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'simpleTasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'number' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reward' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userRelatedTask' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'taskId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'progress' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isBonusReceived' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isCompleted' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requirement' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serialTasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'number' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reward' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userRelatedTask' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'taskId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'progress' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userId' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isBonusReceived' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isCompleted' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requirement' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserDailyTasksQuery,
  GetUserDailyTasksQueryVariables
>
export const GetReferralStatisticDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getReferralStatistic' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getReferralStatistic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfInvited' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfSecondLevelInvited' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetReferralStatisticQuery,
  GetReferralStatisticQueryVariables
>
export const GetTopUsersRewardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTopUsersRewards' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTopUsersRewards' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'skip' },
                      value: { kind: 'IntValue', value: '0' }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'take' },
                      value: { kind: 'IntValue', value: '100' }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rewards' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rewards' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'referralRewards' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastPlace' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentPlace' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bio' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarKeys' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'discordRoles' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isInfluencer' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'updatedAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'placeChange' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rewardsForChallenges' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastPlaceOnLeaderboard' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myReward' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rewards' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'referralRewards' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastPlace' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentPlace' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bio' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarKeys' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'discordRoles' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isInfluencer' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'updatedAt' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUris' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'levelId' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'placeChange' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rewardsForChallenges' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastPlaceOnLeaderboard' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetTopUsersRewardsQuery,
  GetTopUsersRewardsQueryVariables
>
export const GetUserRewardStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserRewardStats' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RewardStats' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RewardStats' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Reward' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referralRewards' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentPlace' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rewardsForChallenges' }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastPlaceOnLeaderboard' }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserRewardStatsQuery,
  GetUserRewardStatsQueryVariables
>
export const GetUserRewardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserReward' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RewardBase' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RewardBase' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Reward' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rewards' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentPlace' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeChange' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetUserRewardQuery, GetUserRewardQueryVariables>
export const GetUserSeasonStateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserSeasonState' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserSeasonState' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'number' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tasks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reward' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'number' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userRelatedTask' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countCompletedChallegnes' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserSeasonStateQuery,
  GetUserSeasonStateQueryVariables
>
export const CheckChallengeTaskCompletionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'checkChallengeTaskCompletion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckChallengeTaskCompletionInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checkChallengeTaskCompletion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CheckChallengeTaskCompletionMutation,
  CheckChallengeTaskCompletionMutationVariables
>
export const ClaimRewardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'claimReward' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ClaimRewardInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'claimReward' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ClaimRewardMutation, ClaimRewardMutationVariables>
export const UpdateReferralDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateReferral' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateReferralInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateReferral' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateReferralMutation,
  UpdateReferralMutationVariables
>
export const GetUserLevelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserLevel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserLevel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'commissionsPaid' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'levelId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'claimedOnLevel' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCashBackReceived' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestedOnCashBackValue' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'txHash' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commissionsToPay' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cashReward' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pointReward' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cashBackPercent' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'progressPercent' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetUserLevelQuery, GetUserLevelQueryVariables>
export const GetLevelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getLevels' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getLevels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'commissionsToPay' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cashReward' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pointReward' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cashBackPercent' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetLevelsQuery, GetLevelsQueryVariables>
export const UserDailyTasksChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'userDailyTasksChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userDailyTasksChanged' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reward' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userRelatedTask' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UserDailyTasksChangedSubscription,
  UserDailyTasksChangedSubscriptionVariables
>
export const RewardChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'rewardChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rewardChanged' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RewardBase' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RewardBase' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Reward' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rewards' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentPlace' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeChange' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  RewardChangedSubscription,
  RewardChangedSubscriptionVariables
>
export const UserSeasonChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'userSeasonChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSeasonChanged' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'number' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tasks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reward' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'number' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'userRelatedTask' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countCompletedChallegnes' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UserSeasonChangedSubscription,
  UserSeasonChangedSubscriptionVariables
>
export const GetCashbackSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCashbackSummary' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCashbackSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'period' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDate' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cashbackAmount' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicableLevel' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'commissionPaid' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'txHash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetCashbackSummaryQuery,
  GetCashbackSummaryQueryVariables
>
export const GetUserBetsStatisticStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserBetsStatisticStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserBetsStatisticStubQuery,
  GetUserBetsStatisticStubQueryVariables
>
export const GetUserByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Me' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Me' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discordRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInfluencer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'level' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'levelId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryWalletAddress' }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wallets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPlayed' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetUserByIdQuery, GetUserByIdQueryVariables>
export const GetUserGamesStatisticDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserGamesStatistic' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserGamesStatistic' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalGames' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'winPercentage' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'earned' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largestWin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'pnl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameType' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserGamesStatisticQuery,
  GetUserGamesStatisticQueryVariables
>
export const StatisticsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'statistics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserSetupPredictsStatistic' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalGames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalWins' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'winPercentage' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'earned' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserSetupGamesStatistic' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalPlayersOnGames' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalGames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'earned' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalTakeProfitClosedGames' }
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'totalTakeProfitClosedGamesPercentage'
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalStopLossClosedGames' }
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'totalStopLossClosedGamesPercentage'
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalRejectedGames' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalRejectedGamesPercentage' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserBullseyePredictsStatistic' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalGames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalWins' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'winPercentage' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'earned' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserUpDownPredictsStatistic' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalGames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalWins' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'winPercentage' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'earned' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserOneVsOnePredictsStatistic' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalGames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalWins' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'winPercentage' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'earned' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserUpDownAiPredictsStatistic' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalGames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalWins' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'winPercentage' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'earned' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StatisticsQuery, StatisticsQueryVariables>
export const GetUserGamesWinratesHistoryStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserGamesWinratesHistoryStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetUserGamesWinratesHistoryStubQuery,
  GetUserGamesWinratesHistoryStubQueryVariables
>
export const ClaimCashbackDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'claimCashback' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'periodId' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'claimCashback' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'periodId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'periodId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userLevelId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'commissionsPaid' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cashbackPeriodId' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'txHash' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userLevel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commissionsPaid' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'claimedOnLevel' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isCashBackReceived' }
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'requestedOnCashBackValue'
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'txHash' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'progressPercent' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'period' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDate' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ClaimCashbackMutation,
  ClaimCashbackMutationVariables
>
export const AttachDiscordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'attachDiscord' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AttachDiscordInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachDiscord' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  AttachDiscordMutation,
  AttachDiscordMutationVariables
>
export const AttachTwitterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'attachTwitter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AttachTwitterInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachTwitter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  AttachTwitterMutation,
  AttachTwitterMutationVariables
>
export const UpdateAvatarDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAvatar' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'file' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Upload' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAvatar' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'file' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'file' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'avatarKeys' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateAvatarMutation,
  UpdateAvatarMutationVariables
>
export const UpdateUserBioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserBio' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bio' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'bio' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'bio' }
                      }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'bio' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateUserBioMutation,
  UpdateUserBioMutationVariables
>
export const UpdateUserNameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'name' }
                      }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateUserNameMutation,
  UpdateUserNameMutationVariables
>
export const ChangePasswordStubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'changePasswordStub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ChangePasswordStubQuery,
  ChangePasswordStubQueryVariables
>
export const DeleteAvatarDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteAvatar' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAvatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Me' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Me' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discordRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUris' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInfluencer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'level' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'levelId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'level' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryWalletAddress' }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wallets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPlayed' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  DeleteAvatarMutation,
  DeleteAvatarMutationVariables
>
export const GetDiscordLinkUriDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getDiscordLinkUri' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GetDiscordAuthUriInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDiscordAuthUri' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetDiscordLinkUriQuery,
  GetDiscordLinkUriQueryVariables
>
export const GetNotificationsPoliciesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getNotificationsPolicies' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getNotificationsPolicies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendNotificationsToEmail' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notifyBetsResult' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notifyBettingInvitation' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notifyNewAchievements' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notifyUpdates' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetNotificationsPoliciesQuery,
  GetNotificationsPoliciesQueryVariables
>
export const GetPrivacyPoliciesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPrivacyPolicies' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPrivacyPolicies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'showProfile' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAchievements' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'showSetups' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showStats' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showBettingHistory' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowTagInChat' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowInviteIn1vs1Game' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetPrivacyPoliciesQuery,
  GetPrivacyPoliciesQueryVariables
>
export const GetTwitterLinkUriDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTwitterLinkUri' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GetTwitterAuthUriInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTwitterAuthUri' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' }
                }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  GetTwitterLinkUriQuery,
  GetTwitterLinkUriQueryVariables
>
export const UpdateNotificationsPolicyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateNotificationsPolicy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'changes' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ChangeEmailNotificationPolicyInput'
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNotificationsPolicy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'changes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'changes' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendNotificationsToEmail' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notifyBetsResult' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notifyBettingInvitation' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notifyNewAchievements' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notifyUpdates' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdateNotificationsPolicyMutation,
  UpdateNotificationsPolicyMutationVariables
>
export const UpdatePrivacyPolicyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePrivacyPolicy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'changes' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChangePrivacyPolicyInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePrivacyPolicy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'changes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'changes' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'showProfile' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showAchievements' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'showSetups' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showStats' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showBettingHistory' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  UpdatePrivacyPolicyMutation,
  UpdatePrivacyPolicyMutationVariables
>
export const LinkWalletChallengeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'linkWalletChallenge' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'walletAddress' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'linkWalletChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'walletAddress' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'walletAddress' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'challenge' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  LinkWalletChallengeMutation,
  LinkWalletChallengeMutationVariables
>
export const LinkWalletDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'linkWallet' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'walletAddress' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'signature' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'linkWallet' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'walletAddress' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'walletAddress' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'signature' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'signature' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<LinkWalletMutation, LinkWalletMutationVariables>
